import { images } from "../utils/customFn";

export const IconPassword = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
  >
    <path
      d="M9.53843 4.85709L12.0468 7.39047V7.2622C12.0468 6.62433 11.7967 6.01258 11.3515 5.56153C10.9063 5.11049 10.3025 4.85709 9.67295 4.85709H9.53843ZM6.13588 5.49845L7.36238 6.74109C7.32282 6.90945 7.29908 7.07781 7.29908 7.2622C7.29908 7.90007 7.54918 8.51182 7.99437 8.96287C8.43956 9.41391 9.04336 9.66731 9.67295 9.66731C9.84704 9.66731 10.0211 9.64326 10.1873 9.60317L11.4138 10.8458C10.8836 11.1104 10.2981 11.2707 9.67295 11.2707C8.62363 11.2707 7.61729 10.8484 6.87532 10.0966C6.13334 9.34491 5.7165 8.32532 5.7165 7.2622C5.7165 6.62885 5.87475 6.03559 6.13588 5.49845ZM1.76004 1.06504L3.56418 2.89292L3.92027 3.25369C2.61464 4.2959 1.58596 5.65879 0.96875 7.2622C2.33768 10.7817 5.7165 13.275 9.67295 13.275C10.8995 13.275 12.0706 13.0345 13.1388 12.6015L13.4791 12.9383L15.7896 15.2792L16.7946 14.2611L2.76498 0.046875M9.67295 3.25369C10.7223 3.25369 11.7286 3.67601 12.4706 4.42775C13.2126 5.17949 13.6294 6.19908 13.6294 7.2622C13.6294 7.77529 13.5265 8.27235 13.3445 8.7213L15.663 11.0703C16.85 10.0682 17.7995 8.75337 18.3772 7.2622C17.0082 3.74272 13.6294 1.24943 9.67295 1.24943C8.56514 1.24943 7.50481 1.44985 6.50779 1.81062L8.22489 3.53428C8.67592 3.35791 9.15861 3.25369 9.67295 3.25369Z"
      fill="#777980"
    />
  </svg>
);

// SideBar icon
export const IconDashboard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
  >
    <path
      d="M10.877 4.35547H5.04362C4.39929 4.35547 3.87695 4.8778 3.87695 5.52214V13.6888C3.87695 14.3331 4.39929 14.8555 5.04362 14.8555H10.877C11.5213 14.8555 12.0436 14.3331 12.0436 13.6888V5.52214C12.0436 4.8778 11.5213 4.35547 10.877 4.35547Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7104 4.35547H17.8771C17.2328 4.35547 16.7104 4.8778 16.7104 5.52214V9.02214C16.7104 9.66647 17.2328 10.1888 17.8771 10.1888H23.7104C24.3548 10.1888 24.8771 9.66647 24.8771 9.02214V5.52214C24.8771 4.8778 24.3548 4.35547 23.7104 4.35547Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7104 14.8555H17.8771C17.2328 14.8555 16.7104 15.3778 16.7104 16.0221V24.1888C16.7104 24.8331 17.2328 25.3555 17.8771 25.3555H23.7104C24.3548 25.3555 24.8771 24.8331 24.8771 24.1888V16.0221C24.8771 15.3778 24.3548 14.8555 23.7104 14.8555Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.877 19.522H5.04362C4.39929 19.522 3.87695 20.0443 3.87695 20.6886V24.1886C3.87695 24.833 4.39929 25.3553 5.04362 25.3553H10.877C11.5213 25.3553 12.0436 24.833 12.0436 24.1886V20.6886C12.0436 20.0443 11.5213 19.522 10.877 19.522Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSubconVendor = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <path
      d="M2.43911 3.13661C2.20366 3.60597 2.08785 4.18498 1.85625 5.343L1.07861 9.23118C0.586231 11.6931 2.46927 13.99 4.97995 13.99C7.02396 13.99 8.73542 12.4412 8.9388 10.4073L9.02855 9.50979C8.81644 11.9141 10.7115 13.99 13.1322 13.99C15.5694 13.99 17.4738 11.8857 17.2312 9.46065L17.3262 10.4073C17.5296 12.4412 19.241 13.99 21.2851 13.99C23.7957 13.99 25.6788 11.6931 25.1864 9.23118L24.4088 5.343C24.1772 4.18501 24.0613 3.60597 23.8259 3.13661C23.3297 2.14759 22.437 1.41575 21.3699 1.12321C20.8635 0.984375 20.273 0.984375 19.0921 0.984375H16.3836H7.17291C5.99197 0.984375 5.40149 0.984375 4.89506 1.12321C3.82796 1.41575 2.93524 2.14759 2.43911 3.13661Z"
      fill="white"
    />
    <path
      d="M21.2856 15.9412C22.3482 15.9412 23.3356 15.665 24.1878 15.1855V16.5915C24.1878 21.4962 24.1878 23.9486 22.664 25.4723C21.4375 26.6989 19.6092 26.9381 16.3844 26.9847V22.4441C16.3844 21.2286 16.3844 20.6208 16.1229 20.1681C15.9518 19.8716 15.7055 19.6252 15.4089 19.4541C14.9562 19.1927 14.3485 19.1927 13.1329 19.1927C11.9174 19.1927 11.3097 19.1927 10.857 19.4541C10.5604 19.6252 10.3141 19.8716 10.1429 20.1681C9.88153 20.6208 9.88153 21.2286 9.88153 22.4441V26.9847C6.65668 26.9381 4.82838 26.6989 3.60183 25.4723C2.07812 23.9486 2.07812 21.4962 2.07812 16.5915V15.1855C2.93031 15.665 3.91763 15.9412 4.98043 15.9412C6.5373 15.9412 7.96471 15.3383 9.02881 14.344C10.1048 15.3327 11.5417 15.9412 13.1327 15.9412C14.7238 15.9412 16.1608 15.3326 17.2369 14.3438C18.301 15.3382 19.7285 15.9412 21.2856 15.9412Z"
      fill="white"
    />
  </svg>
);

export const IconEstimation = () => (
 <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 24 24" fill="none">
  <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.315 0-10 1.675-10 5v3h20v-3c0-3.325-6.685-5-10-5z" fill="white"/>
</svg>

);

export const IconPurchase = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.3921 0.750646C16.9059 0.493782 17.5306 0.702015 17.7874 1.21574L20.8397 7.32024C22.716 7.46439 23.8934 7.83242 24.6531 8.77216C25.9018 10.3168 25.4037 12.6415 24.4074 17.2907L23.8132 20.064C23.1379 23.2152 22.8003 24.7908 21.6561 25.7157C20.512 26.6406 18.9007 26.6406 15.6779 26.6406H9.71667C6.49389 26.6406 4.88249 26.6406 3.73841 25.7157C2.59432 24.7908 2.25668 23.2152 1.58142 20.064L0.98713 17.2907C-0.00912617 12.6415 -0.507254 10.3168 0.741498 8.77216C1.50118 7.83243 2.67857 7.4644 4.55483 7.32026L7.60708 1.21574C7.86394 0.702015 8.48865 0.493782 9.00237 0.750646C9.5161 1.00751 9.72434 1.63221 9.46747 2.14594L6.92306 7.23477C7.59312 7.22746 8.32426 7.22746 9.12239 7.22746H16.2722C17.0703 7.22746 17.8014 7.22746 18.4714 7.23477L15.927 2.14594C15.6701 1.63221 15.8784 1.00751 16.3921 0.750646ZM6.11063 14.1607C6.11063 13.5864 6.57625 13.1207 7.15062 13.1207H18.2439C18.8182 13.1207 19.2839 13.5864 19.2839 14.1607C19.2839 14.7351 18.8182 15.2007 18.2439 15.2007H7.15062C6.57625 15.2007 6.11063 14.7351 6.11063 14.1607ZM9.92393 17.2807C9.34956 17.2807 8.88394 17.7463 8.88394 18.3207C8.88394 18.895 9.34956 19.3607 9.92393 19.3607H15.4706C16.0449 19.3607 16.5105 18.895 16.5105 18.3207C16.5105 17.7463 16.0449 17.2807 15.4706 17.2807H9.92393Z"
      fill="white"
    />
  </svg>
);

export const IconDocuments = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <path
      d="M18.4013 0.761126C17.8683 0.228126 16.9453 0.592126 16.9453 1.33313V5.87013C16.9453 7.76813 18.5573 9.34113 20.5203 9.34113C21.7553 9.35413 23.4713 9.35413 24.9403 9.35413C25.6813 9.35413 26.0713 8.48313 25.5513 7.96313C23.6793 6.07813 20.3253 2.68513 18.4013 0.761126Z"
      fill="white"
    />
    <path
      d="M24.5094 11.1314H20.7524C17.6714 11.1314 15.1624 8.62237 15.1624 5.54137V1.78437C15.1624 1.06937 14.5774 0.484375 13.8624 0.484375H8.35037C4.34637 0.484375 1.10938 3.08438 1.10938 7.72538V19.2434C1.10938 23.8844 4.34637 26.4844 8.35037 26.4844H18.5684C22.5724 26.4844 25.8094 23.8844 25.8094 19.2434V12.4314C25.8094 11.7164 25.2244 11.1314 24.5094 11.1314ZM12.8094 20.9594H7.60938C7.07638 20.9594 6.63437 20.5174 6.63437 19.9844C6.63437 19.4514 7.07638 19.0094 7.60938 19.0094H12.8094C13.3424 19.0094 13.7844 19.4514 13.7844 19.9844C13.7844 20.5174 13.3424 20.9594 12.8094 20.9594ZM15.4094 15.7594H7.60938C7.07638 15.7594 6.63437 15.3174 6.63437 14.7844C6.63437 14.2514 7.07638 13.8094 7.60938 13.8094H15.4094C15.9424 13.8094 16.3844 14.2514 16.3844 14.7844C16.3844 15.3174 15.9424 15.7594 15.4094 15.7594Z"
      fill="white"
    />
  </svg>
);

export const IconFinanceSide = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <path
      d="M17.6298 6.32812H5.35888C4.99491 6.32812 4.65694 6.34112 4.34497 6.35412C1.26424 6.53611 0.445312 7.66701 0.445312 11.1767V11.9307C0.445312 12.6456 1.03026 13.2305 1.7452 13.2305H21.2435C21.9584 13.2305 22.5434 12.6456 22.5434 11.9307V11.1767C22.5434 7.30304 21.5555 6.32812 17.6298 6.32812Z"
      fill="white"
    />
    <path
      d="M1.7452 15.1797C1.03026 15.1797 0.445312 15.7646 0.445312 16.4796V20.2622C0.445312 24.1359 1.43323 25.1108 5.35888 25.1108H17.6298C21.4905 25.1108 22.5044 24.1749 22.5434 20.4702V16.4796C22.5434 15.7646 21.9584 15.1797 21.2435 15.1797H1.7452ZM6.89275 21.9391H4.66994C4.13699 21.9391 3.69503 21.4971 3.69503 20.9642C3.69503 20.4312 4.13699 19.9893 4.66994 19.9893H6.90574C7.4387 19.9893 7.88066 20.4312 7.88066 20.9642C7.88066 21.4971 7.4387 21.9391 6.89275 21.9391ZM14.1591 21.9391H9.6875C9.15455 21.9391 8.71258 21.4971 8.71258 20.9642C8.71258 20.4312 9.15455 19.9893 9.6875 19.9893H14.1591C14.6921 19.9893 15.134 20.4312 15.134 20.9642C15.134 21.4971 14.7051 21.9391 14.1591 21.9391Z"
      fill="white"
    />
    <path
      d="M26.449 15.1401V8.32867C26.449 4.26003 24.1222 2.49219 20.6125 2.49219H9.00449C8.01658 2.49219 7.13265 2.63517 6.35272 2.93415C5.74178 3.15513 5.19582 3.4801 4.75386 3.90906C4.51988 4.13004 4.70187 4.49401 5.03984 4.49401H19.1696C22.0944 4.49401 24.4602 6.8598 24.4602 9.78455V19.1048C24.4602 19.4297 24.8111 19.6117 25.0451 19.3778C25.942 18.4288 26.449 17.038 26.449 15.1401Z"
      fill="white"
    />
  </svg>
);

// Header Icon
export const IconCalendar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <g clipPath="url(#clip0_1_3091)">
      <path
        d="M3.37695 18.1055C3.37814 19.0997 3.77361 20.0528 4.47662 20.7558C5.17962 21.4588 6.13276 21.8543 7.12695 21.8555H17.627C18.6211 21.8543 19.5743 21.4588 20.2773 20.7558C20.9803 20.0528 21.3758 19.0997 21.377 18.1055V11.3555H3.37695V18.1055ZM16.127 14.7305C16.3495 14.7305 16.567 14.7964 16.752 14.9201C16.937 15.0437 17.0812 15.2194 17.1663 15.4249C17.2515 15.6305 17.2737 15.8567 17.2303 16.0749C17.1869 16.2932 17.0798 16.4936 16.9224 16.651C16.7651 16.8083 16.5647 16.9154 16.3464 16.9589C16.1282 17.0023 15.902 16.98 15.6964 16.8948C15.4909 16.8097 15.3152 16.6655 15.1915 16.4805C15.0679 16.2955 15.002 16.078 15.002 15.8555C15.002 15.5571 15.1205 15.271 15.3315 15.06C15.5424 14.849 15.8286 14.7305 16.127 14.7305ZM12.377 14.7305C12.5995 14.7305 12.817 14.7964 13.002 14.9201C13.187 15.0437 13.3312 15.2194 13.4163 15.4249C13.5015 15.6305 13.5237 15.8567 13.4803 16.0749C13.4369 16.2932 13.3298 16.4936 13.1724 16.651C13.0151 16.8083 12.8147 16.9154 12.5964 16.9589C12.3782 17.0023 12.152 16.98 11.9464 16.8948C11.7409 16.8097 11.5652 16.6655 11.4415 16.4805C11.3179 16.2955 11.252 16.078 11.252 15.8555C11.252 15.5571 11.3705 15.271 11.5815 15.06C11.7924 14.849 12.0786 14.7305 12.377 14.7305ZM8.62695 14.7305C8.84946 14.7305 9.06696 14.7964 9.25197 14.9201C9.43698 15.0437 9.58117 15.2194 9.66632 15.4249C9.75147 15.6305 9.77375 15.8567 9.73034 16.0749C9.68693 16.2932 9.57978 16.4936 9.42245 16.651C9.26511 16.8083 9.06466 16.9154 8.84643 16.9589C8.6282 17.0023 8.402 16.98 8.19643 16.8948C7.99087 16.8097 7.81517 16.6655 7.69155 16.4805C7.56793 16.2955 7.50195 16.078 7.50195 15.8555C7.50195 15.5571 7.62048 15.271 7.83146 15.06C8.04244 14.849 8.32858 14.7305 8.62695 14.7305Z"
        fill="#9FAEC6"
      />
      <path
        d="M17.627 5.35547H16.877V4.60547C16.877 4.40656 16.7979 4.21579 16.6573 4.07514C16.5166 3.93449 16.3259 3.85547 16.127 3.85547C15.928 3.85547 15.7373 3.93449 15.5966 4.07514C15.456 4.21579 15.377 4.40656 15.377 4.60547V5.35547H9.37695V4.60547C9.37695 4.40656 9.29794 4.21579 9.15728 4.07514C9.01663 3.93449 8.82587 3.85547 8.62695 3.85547C8.42804 3.85547 8.23728 3.93449 8.09662 4.07514C7.95597 4.21579 7.87695 4.40656 7.87695 4.60547V5.35547H7.12695C6.13276 5.35666 5.17962 5.75213 4.47662 6.45513C3.77361 7.15814 3.37814 8.11127 3.37695 9.10547L3.37695 9.85547H21.377V9.10547C21.3758 8.11127 20.9803 7.15814 20.2773 6.45513C19.5743 5.75213 18.6211 5.35666 17.627 5.35547Z"
        fill="#9FAEC6"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3091">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(3.37695 3.85547)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconBell = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M19.2869 15.5211C19.2155 15.4352 19.1455 15.3493 19.0768 15.2663C18.1314 14.1229 17.5595 13.4329 17.5595 10.196C17.5595 8.52023 17.1586 7.14523 16.3684 6.11398C15.7858 5.35215 14.9982 4.77422 13.96 4.34711C13.9467 4.33968 13.9347 4.32993 13.9248 4.31832C13.5514 3.06793 12.5296 2.23047 11.3772 2.23047C10.2248 2.23047 9.20339 3.06793 8.83 4.31703C8.82003 4.32821 8.80827 4.33765 8.79519 4.34496C6.37261 5.34227 5.19527 7.25566 5.19527 10.1947C5.19527 13.4329 4.62421 14.1229 3.67804 15.265C3.60929 15.348 3.53925 15.4322 3.46793 15.5198C3.28368 15.742 3.16694 16.0124 3.13153 16.2989C3.09612 16.5853 3.14352 16.876 3.26812 17.1363C3.53324 17.6949 4.09828 18.0417 4.74324 18.0417H18.0159C18.6578 18.0417 19.219 17.6954 19.485 17.1393C19.6101 16.8789 19.6579 16.588 19.6228 16.3012C19.5877 16.0144 19.4711 15.7437 19.2869 15.5211ZM11.3772 21.4805C11.9981 21.48 12.6073 21.3114 13.1402 20.9927C13.6731 20.674 14.1097 20.217 14.4039 19.6702C14.4178 19.644 14.4246 19.6146 14.4238 19.585C14.4229 19.5554 14.4145 19.5265 14.3991 19.5011C14.3838 19.4757 14.3622 19.4547 14.3364 19.4401C14.3106 19.4256 14.2814 19.4179 14.2518 19.418H8.50343C8.47375 19.4179 8.44455 19.4254 8.41867 19.44C8.39279 19.4545 8.37112 19.4755 8.35576 19.5009C8.3404 19.5263 8.33188 19.5552 8.33103 19.5849C8.33017 19.6146 8.33702 19.644 8.35089 19.6702C8.64503 20.2169 9.08164 20.6739 9.61444 20.9926C10.1472 21.3113 10.7563 21.4799 11.3772 21.4805Z"
      fill="#9FAEC6"
    />
  </svg>
);

export const IconMassage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M1.62696 10.8555C1.62696 6.02297 5.54446 2.10547 10.377 2.10547C15.2095 2.10547 19.127 6.02297 19.127 10.8555C19.127 15.688 15.2095 19.6055 10.377 19.6055C8.89696 19.6055 7.50071 19.2373 6.27696 18.5873L2.82196 19.5698C2.66139 19.6154 2.49157 19.6172 2.33005 19.5751C2.16854 19.5331 2.02118 19.4487 1.90319 19.3306C1.78521 19.2126 1.70088 19.0652 1.65891 18.9036C1.61694 18.7421 1.61886 18.5723 1.66446 18.4117L2.64696 14.9573C1.97549 13.6945 1.62519 12.2857 1.62696 10.8555ZM6.62696 8.98047C6.62696 9.14623 6.69281 9.3052 6.81002 9.42241C6.92723 9.53962 7.0862 9.60547 7.25196 9.60547H13.502C13.6677 9.60547 13.8267 9.53962 13.9439 9.42241C14.0611 9.3052 14.127 9.14623 14.127 8.98047C14.127 8.81471 14.0611 8.65574 13.9439 8.53853C13.8267 8.42132 13.6677 8.35547 13.502 8.35547H7.25196C7.0862 8.35547 6.92723 8.42132 6.81002 8.53853C6.69281 8.65574 6.62696 8.81471 6.62696 8.98047ZM7.25196 12.1055C7.0862 12.1055 6.92723 12.1713 6.81002 12.2885C6.69281 12.4057 6.62696 12.5647 6.62696 12.7305C6.62696 12.8962 6.69281 13.0552 6.81002 13.1724C6.92723 13.2896 7.0862 13.3555 7.25196 13.3555H11.002C11.1677 13.3555 11.3267 13.2896 11.4439 13.1724C11.5611 13.0552 11.627 12.8962 11.627 12.7305C11.627 12.5647 11.5611 12.4057 11.4439 12.2885C11.3267 12.1713 11.1677 12.1055 11.002 12.1055H7.25196Z"
      fill="#9FAEC6"
    />
  </svg>
);

export const IconDay = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="white" />
    <g clipPath="url(#clip0_350_298)">
      <path
        d="M12.6279 3.62791C12.6279 3.46138 12.5618 3.30167 12.444 3.18391C12.3263 3.06615 12.1665 3 12 3C11.8335 3 11.6738 3.06615 11.556 3.18391C11.4383 3.30167 11.3721 3.46138 11.3721 3.62791H12.6279ZM11.3721 4.46512C11.3721 4.63165 11.4383 4.79136 11.556 4.90911C11.6738 5.02687 11.8335 5.09302 12 5.09302C12.1665 5.09302 12.3263 5.02687 12.444 4.90911C12.5618 4.79136 12.6279 4.63165 12.6279 4.46512H11.3721ZM12.6279 19.5349C12.6279 19.3684 12.5618 19.2086 12.444 19.0909C12.3263 18.9731 12.1665 18.907 12 18.907C11.8335 18.907 11.6738 18.9731 11.556 19.0909C11.4383 19.2086 11.3721 19.3684 11.3721 19.5349H12.6279ZM11.3721 20.3721C11.3721 20.5386 11.4383 20.6983 11.556 20.8161C11.6738 20.9338 11.8335 21 12 21C12.1665 21 12.3263 20.9338 12.444 20.8161C12.5618 20.6983 12.6279 20.5386 12.6279 20.3721H11.3721ZM19.5642 8.35814C19.6357 8.31691 19.6983 8.26201 19.7485 8.19657C19.7988 8.13113 19.8357 8.05644 19.857 7.97675C19.8784 7.89707 19.8839 7.81395 19.8731 7.73215C19.8624 7.65035 19.8357 7.57146 19.7944 7.5C19.7532 7.42854 19.6983 7.36589 19.6329 7.31565C19.5674 7.2654 19.4927 7.22854 19.413 7.20716C19.3334 7.18578 19.2502 7.1803 19.1684 7.19105C19.0866 7.20179 19.0078 7.22854 18.9363 7.26977L19.5642 8.35814ZM18.2113 7.68837C18.0669 7.77164 17.9616 7.90883 17.9184 8.06976C17.8752 8.23069 17.8978 8.40218 17.981 8.54651C18.0643 8.69084 18.2015 8.79618 18.3624 8.83935C18.5234 8.88253 18.6948 8.86001 18.8392 8.77674L18.2113 7.68837ZM5.78875 16.3116C5.93308 16.2284 6.03842 16.0912 6.0816 15.9302C6.12477 15.7693 6.10225 15.5978 6.01899 15.4535C5.97776 15.382 5.92286 15.3194 5.85742 15.2691C5.79198 15.2189 5.71729 15.182 5.6376 15.1606C5.47667 15.1175 5.30518 15.14 5.16085 15.2233L5.78875 16.3116ZM4.43582 15.6419C4.2915 15.7251 4.18616 15.8623 4.14298 16.0232C4.09981 16.1842 4.12233 16.3557 4.20559 16.5C4.28886 16.6443 4.42605 16.7497 4.58698 16.7928C4.74791 16.836 4.9194 16.8135 5.06373 16.7302L4.43582 15.6419ZM5.06373 7.26977C4.9194 7.1865 4.74791 7.16398 4.58698 7.20716C4.42605 7.25033 4.28886 7.35567 4.20559 7.5C4.12233 7.64433 4.09981 7.81582 4.14298 7.97675C4.18616 8.13768 4.2915 8.27487 4.43582 8.35814L5.06373 7.26977ZM5.16085 8.77674C5.23231 8.81797 5.3112 8.84472 5.393 8.85546C5.4748 8.86621 5.55791 8.86073 5.6376 8.83935C5.71729 8.81798 5.79198 8.78111 5.85742 8.73086C5.92286 8.68062 5.97776 8.61797 6.01899 8.54651C6.06022 8.47505 6.08697 8.39616 6.09771 8.31436C6.10845 8.23256 6.10298 8.14944 6.0816 8.06976C6.06022 7.99007 6.02335 7.91538 5.97311 7.84994C5.92286 7.7845 5.86022 7.7296 5.78875 7.68837L5.16085 8.77674ZM18.8392 15.2233C18.6948 15.14 18.5234 15.1175 18.3624 15.1606C18.2015 15.2038 18.0643 15.3092 17.981 15.4535C17.8978 15.5978 17.8752 15.7693 17.9184 15.9302C17.9616 16.0912 18.0669 16.2284 18.2113 16.3116L18.8392 15.2233ZM18.9363 16.7302C19.0806 16.8135 19.2521 16.836 19.413 16.7928C19.574 16.7497 19.7112 16.6443 19.7944 16.5C19.8777 16.3557 19.9002 16.1842 19.857 16.0232C19.8139 15.8623 19.7085 15.7251 19.5642 15.6419L18.9363 16.7302ZM16.3954 12C16.3954 14.4279 14.4279 16.3953 12 16.3953V17.6512C13.4988 17.6512 14.9362 17.0558 15.996 15.996C17.0558 14.9362 17.6512 13.4988 17.6512 12H16.3954ZM12 16.3953C10.8343 16.3953 9.71632 15.9323 8.89203 15.108C8.06774 14.2837 7.60466 13.1657 7.60466 12H6.34885C6.34885 13.4988 6.94424 14.9362 8.00403 15.996C9.06383 17.0558 10.5012 17.6512 12 17.6512V16.3953ZM7.60466 12C7.60466 9.57209 9.5721 7.60465 12 7.60465V6.34884C10.5012 6.34884 9.06383 6.94423 8.00403 8.00402C6.94424 9.06382 6.34885 10.5012 6.34885 12H7.60466ZM12 7.60465C14.4279 7.60465 16.3954 9.57209 16.3954 12H17.6512C17.6512 10.5012 17.0558 9.06382 15.996 8.00402C14.9362 6.94423 13.4988 6.34884 12 6.34884V7.60465ZM11.3721 3.62791V4.46512H12.6279V3.62791H11.3721ZM11.3721 19.5349V20.3721H12.6279V19.5349H11.3721ZM18.9363 7.26977L18.2113 7.68837L18.8392 8.77674L19.5642 8.35814L18.9363 7.26977ZM5.16085 15.2233L4.43582 15.6419L5.06373 16.7302L5.78875 16.3116L5.16085 15.2233ZM4.43582 8.35814L5.16085 8.77674L5.78875 7.68837L5.06373 7.26977L4.43582 8.35814ZM18.2113 16.3116L18.9363 16.7302L19.5642 15.6419L18.8392 15.2233L18.2113 16.3116Z"
        fill="#333333"
      />
    </g>
    <defs>
      <clipPath id="clip0_350_298">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconNight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#060610" />
    <g clipPath="url(#clip0_350_305)">
      <path
        d="M20.1326 13.7939C18.8411 14.9653 17.1711 15.6105 15.4309 15.6105C11.5677 15.6105 8.42461 12.4676 8.42461 8.60429C8.42461 6.86405 9.0698 5.19427 10.2412 3.90256C10.6035 3.50308 10.215 2.87466 9.69505 3.022C5.88306 4.10179 3.03516 7.61274 3.03516 11.838C3.03516 16.9015 7.13293 21 12.1972 21C16.4127 21 19.9306 18.1617 21.0132 14.3401C21.1603 13.8213 20.5331 13.431 20.1326 13.7939ZM12.1972 19.9221C7.73966 19.9221 4.11308 16.2955 4.11308 11.8379C4.11308 8.845 5.783 6.12946 8.33419 4.73541C7.69023 5.91329 7.34679 7.24001 7.34679 8.60425C7.34679 13.0618 10.9732 16.6884 15.4309 16.6884C16.7953 16.6884 18.1219 16.345 19.2998 15.701C17.9057 18.2522 15.1902 19.9221 12.1972 19.9221Z"
        fill="#2492FF"
      />
      <path
        d="M11.96 10.1142L13.2365 10.7525L13.8748 12.029C13.9196 12.1185 13.9884 12.1938 14.0735 12.2464C14.1587 12.299 14.2568 12.3268 14.3568 12.3268C14.4569 12.3268 14.555 12.299 14.6402 12.2464C14.7253 12.1938 14.7941 12.1185 14.8389 12.029L15.4772 10.7525L16.7537 10.1142C16.8431 10.0694 16.9184 10.0006 16.971 9.91542C17.0236 9.83028 17.0514 9.73218 17.0514 9.6321C17.0514 9.53203 17.0236 9.43393 16.971 9.34879C16.9184 9.26365 16.8431 9.19482 16.7537 9.15002L15.4772 8.51183L14.8389 7.23538C14.7941 7.14585 14.7253 7.07055 14.6402 7.01791C14.5551 6.96527 14.457 6.93738 14.3569 6.93736C14.2568 6.93733 14.1586 6.9652 14.0735 7.01785C13.9883 7.07049 13.9195 7.14581 13.8748 7.23538L13.2365 8.51183L11.96 9.15002C11.8705 9.19478 11.7952 9.26359 11.7426 9.34874C11.6899 9.43389 11.662 9.53202 11.662 9.63212C11.662 9.73222 11.6899 9.83035 11.7426 9.9155C11.7952 10.0006 11.8705 10.0695 11.96 10.1142ZM13.8792 9.39555C13.9835 9.34343 14.0681 9.25884 14.1202 9.15452L14.3568 8.68143L14.5934 9.15456C14.6456 9.25887 14.7302 9.34343 14.8345 9.39555L15.3076 9.63205L14.8344 9.86865C14.7301 9.92082 14.6456 10.0054 14.5935 10.1096L14.3569 10.5828L14.1202 10.1096C14.0681 10.0053 13.9835 9.92077 13.8792 9.86865L13.4061 9.63216L13.8792 9.39555ZM17.5867 5.9096H18.1256V6.44848C18.1256 6.74621 18.3669 6.98749 18.6646 6.98749C18.9622 6.98749 19.2034 6.74621 19.2034 6.44848V5.9096H19.7424C20.0401 5.9096 20.2814 5.66829 20.2814 5.37058C20.2814 5.07299 20.0401 4.83171 19.7424 4.83171H19.2034V4.29269C19.2034 3.9951 18.9622 3.75378 18.6646 3.75378C18.3669 3.75378 18.1256 3.9951 18.1256 4.29269V4.83171H17.5867C17.2889 4.83171 17.0477 5.07299 17.0477 5.37058C17.0477 5.66829 17.2889 5.9096 17.5867 5.9096Z"
        fill="#2492FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_350_305">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconCalendarLight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
  >
    <path
      d="M1.43408 11.3553C1.43408 7.42718 1.43408 5.4626 2.65377 4.24281C3.87242 3.02197 5.83517 3.02197 9.75962 3.02197H13.9224C17.8468 3.02197 19.8096 3.02197 21.0282 4.24281C22.2479 5.4626 22.2479 7.42718 22.2479 11.3553V13.4386C22.2479 17.3668 22.2479 19.3313 21.0282 20.5511C19.8096 21.772 17.8468 21.772 13.9224 21.772H9.75962C5.83517 21.772 3.87242 21.772 2.65377 20.5511C1.43408 19.3313 1.43408 17.3668 1.43408 13.4386V11.3553Z"
      stroke="#A4B4CB"
      strokeWidth="1.5"
    />
    <path
      d="M6.6377 3.02197V1.45947M17.0446 3.02197V1.45947M1.95459 8.23031H21.7277"
      stroke="#A4B4CB"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M18.085 16.5638C18.085 16.8401 17.9753 17.105 17.7802 17.3004C17.585 17.4957 17.3203 17.6055 17.0443 17.6055C16.7683 17.6055 16.5036 17.4957 16.3084 17.3004C16.1132 17.105 16.0036 16.8401 16.0036 16.5638C16.0036 16.2875 16.1132 16.0226 16.3084 15.8272C16.5036 15.6319 16.7683 15.5221 17.0443 15.5221C17.3203 15.5221 17.585 15.6319 17.7802 15.8272C17.9753 16.0226 18.085 16.2875 18.085 16.5638ZM18.085 12.3971C18.085 12.6734 17.9753 12.9384 17.7802 13.1337C17.585 13.3291 17.3203 13.4388 17.0443 13.4388C16.7683 13.4388 16.5036 13.3291 16.3084 13.1337C16.1132 12.9384 16.0036 12.6734 16.0036 12.3971C16.0036 12.1209 16.1132 11.8559 16.3084 11.6606C16.5036 11.4652 16.7683 11.3555 17.0443 11.3555C17.3203 11.3555 17.585 11.4652 17.7802 11.6606C17.9753 11.8559 18.085 12.1209 18.085 12.3971ZM12.8815 16.5638C12.8815 16.8401 12.7719 17.105 12.5767 17.3004C12.3815 17.4957 12.1168 17.6055 11.8408 17.6055C11.5648 17.6055 11.3001 17.4957 11.105 17.3004C10.9098 17.105 10.8001 16.8401 10.8001 16.5638C10.8001 16.2875 10.9098 16.0226 11.105 15.8272C11.3001 15.6319 11.5648 15.5221 11.8408 15.5221C12.1168 15.5221 12.3815 15.6319 12.5767 15.8272C12.7719 16.0226 12.8815 16.2875 12.8815 16.5638ZM12.8815 12.3971C12.8815 12.6734 12.7719 12.9384 12.5767 13.1337C12.3815 13.3291 12.1168 13.4388 11.8408 13.4388C11.5648 13.4388 11.3001 13.3291 11.105 13.1337C10.9098 12.9384 10.8001 12.6734 10.8001 12.3971C10.8001 12.1209 10.9098 11.8559 11.105 11.6606C11.3001 11.4652 11.5648 11.3555 11.8408 11.3555C12.1168 11.3555 12.3815 11.4652 12.5767 11.6606C12.7719 11.8559 12.8815 12.1209 12.8815 12.3971ZM7.67806 16.5638C7.67806 16.8401 7.56842 17.105 7.37325 17.3004C7.17808 17.4957 6.91338 17.6055 6.63737 17.6055C6.36136 17.6055 6.09666 17.4957 5.90149 17.3004C5.70632 17.105 5.59668 16.8401 5.59668 16.5638C5.59668 16.2875 5.70632 16.0226 5.90149 15.8272C6.09666 15.6319 6.36136 15.5221 6.63737 15.5221C6.91338 15.5221 7.17808 15.6319 7.37325 15.8272C7.56842 16.0226 7.67806 16.2875 7.67806 16.5638ZM7.67806 12.3971C7.67806 12.6734 7.56842 12.9384 7.37325 13.1337C7.17808 13.3291 6.91338 13.4388 6.63737 13.4388C6.36136 13.4388 6.09666 13.3291 5.90149 13.1337C5.70632 12.9384 5.59668 12.6734 5.59668 12.3971C5.59668 12.1209 5.70632 11.8559 5.90149 11.6606C6.09666 11.4652 6.36136 11.3555 6.63737 11.3555C6.91338 11.3555 7.17808 11.4652 7.37325 11.6606C7.56842 11.8559 7.67806 12.1209 7.67806 12.3971Z"
      fill="#A4B4CB"
    />
  </svg>
);

export const IconFilter = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_1_3135)">
      <path
        d="M0.833094 3.52262H2.65691C3.01688 4.84705 4.38233 5.62891 5.70676 5.26895C6.5574 5.03775 7.22189 4.37326 7.45309 3.52262H15.4983C15.8664 3.52262 16.1649 3.22418 16.1649 2.85603C16.1649 2.48788 15.8664 2.18944 15.4983 2.18944H7.45309C7.09313 0.86498 5.72767 0.0831204 4.40324 0.443085C3.5526 0.67428 2.88811 1.33878 2.65691 2.18941H0.833094C0.464943 2.18941 0.166504 2.48785 0.166504 2.856C0.166504 3.22415 0.464943 3.52262 0.833094 3.52262Z"
        fill="#A4B4CB"
      />
      <path
        d="M15.4983 7.68909H13.6745C13.3152 6.36485 11.9505 5.58255 10.6263 5.94176C9.77495 6.17271 9.10989 6.83774 8.87895 7.68909H0.833094C0.464943 7.68909 0.166504 7.98753 0.166504 8.35568C0.166504 8.72383 0.464943 9.02227 0.833094 9.02227H8.87895C9.23819 10.3465 10.6029 11.1288 11.9271 10.7696C12.7785 10.5387 13.4435 9.87362 13.6745 9.02227H15.4983C15.8664 9.02227 16.1649 8.72383 16.1649 8.35568C16.1649 7.98753 15.8664 7.68909 15.4983 7.68909Z"
        fill="#A4B4CB"
      />
      <path
        d="M15.4983 13.1884H7.45309C7.09313 11.864 5.72767 11.0821 4.40324 11.4421C3.5526 11.6733 2.88811 12.3378 2.65691 13.1884H0.833094C0.464943 13.1884 0.166504 13.4869 0.166504 13.855C0.166504 14.2232 0.464943 14.5216 0.833094 14.5216H2.65691C3.01688 15.846 4.38233 16.6279 5.70676 16.2679C6.5574 16.0367 7.22189 15.3722 7.45309 14.5216H15.4983C15.8664 14.5216 16.1649 14.2232 16.1649 13.855C16.1649 13.4869 15.8664 13.1884 15.4983 13.1884Z"
        fill="#A4B4CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3135">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.165527 0.355469)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
  >
    <path
      d="M0.97591 9L5 5L0.97591 1"
      stroke="#01265D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Card Icon
export const IconATotalProject = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <path
      d="M12.8984 10.6797C12.5669 10.6797 12.249 10.8114 12.0146 11.0458C11.7801 11.2802 11.6484 11.5982 11.6484 11.9297V24.4297C11.6484 24.7612 11.7801 25.0792 12.0146 25.3136C12.249 25.548 12.5669 25.6797 12.8984 25.6797C13.23 25.6797 13.5479 25.548 13.7823 25.3136C14.0167 25.0792 14.1484 24.7612 14.1484 24.4297V11.9297C14.1484 11.5982 14.0167 11.2802 13.7823 11.0458C13.5479 10.8114 13.23 10.6797 12.8984 10.6797ZM20.8151 10.6797C20.4836 10.6797 20.1656 10.8114 19.9312 11.0458C19.6968 11.2802 19.5651 11.5982 19.5651 11.9297V19.4297C19.5651 19.7612 19.6968 20.0792 19.9312 20.3136C20.1656 20.548 20.4836 20.6797 20.8151 20.6797C21.1466 20.6797 21.4646 20.548 21.699 20.3136C21.9334 20.0792 22.0651 19.7612 22.0651 19.4297V11.9297C22.0651 11.5982 21.9334 11.2802 21.699 11.0458C21.4646 10.8114 21.1466 10.6797 20.8151 10.6797ZM27.4818 11.9297C27.4818 11.5982 27.6135 11.2802 27.8479 11.0458C28.0823 10.8114 28.4003 10.6797 28.7318 10.6797C29.0633 10.6797 29.3812 10.8114 29.6157 11.0458C29.8501 11.2802 29.9818 11.5982 29.9818 11.9297V27.763C29.9818 28.0945 29.8501 28.4125 29.6157 28.6469C29.3812 28.8813 29.0633 29.013 28.7318 29.013C28.4003 29.013 28.0823 28.8813 27.8479 28.6469C27.6135 28.4125 27.4818 28.0945 27.4818 27.763V11.9297Z"
      fill="#00AC4F"
    />
    <path
      d="M7.0651 4.01562H34.5651C36.1751 4.01562 37.4818 5.32229 37.4818 6.93229V34.4323C37.4818 35.2058 37.1745 35.9477 36.6275 36.4947C36.0805 37.0417 35.3387 37.349 34.5651 37.349H7.0651C6.29156 37.349 5.54969 37.0417 5.00271 36.4947C4.45573 35.9477 4.14844 35.2058 4.14844 34.4323V6.93229C4.14844 5.32229 5.4551 4.01562 7.0651 4.01562ZM6.64844 6.93229V34.4323C6.64844 34.6623 6.8351 34.849 7.0651 34.849H34.5651C34.6756 34.849 34.7816 34.8051 34.8597 34.7269C34.9379 34.6488 34.9818 34.5428 34.9818 34.4323V6.93229C34.9818 6.82178 34.9379 6.7158 34.8597 6.63766C34.7816 6.55952 34.6756 6.51562 34.5651 6.51562H7.0651C6.9546 6.51562 6.84862 6.55952 6.77048 6.63766C6.69234 6.7158 6.64844 6.82178 6.64844 6.93229Z"
      fill="#00AC4F"
    />
  </svg>
);

export const IconFinance = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
  >
    <g clipPath="url(#clip0_100_205703)">
      <path
        d="M19.8136 12.8996V8.82812M19.8136 12.8996C17.5608 12.8996 15.7422 12.8996 15.7422 15.6138C15.7422 19.6853 23.885 19.6853 23.885 23.7567C23.885 26.471 22.0665 26.471 19.8136 26.471M19.8136 12.8996C22.0665 12.8996 23.885 13.931 23.885 15.6138M15.7422 23.7567C15.7422 25.7924 17.5608 26.471 19.8136 26.471M19.8136 26.471V30.5424"
        stroke="#0177FD"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8147 37.3248C29.5586 37.3248 37.4576 29.4258 37.4576 19.6819C37.4576 9.93804 29.5586 2.03906 19.8147 2.03906C10.0709 2.03906 2.17188 9.93804 2.17188 19.6819C2.17188 29.4258 10.0709 37.3248 19.8147 37.3248Z"
        stroke="#0177FD"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_205703">
        <rect
          width="38"
          height="38"
          fill="white"
          transform="translate(0.8125 0.679688)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconFinishedTask = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <path
      d="M28.3125 34.6516L25.075 31.4141L23.3125 33.1766L28.3125 38.1766L38.3125 28.1766L36.55 26.4141L28.3125 34.6516Z"
      fill="#2BB2FE"
    />
    <path
      d="M32.0625 6.92969H28.3125V5.67969C28.3105 5.01725 28.0465 4.38252 27.5781 3.91411C27.1097 3.44569 26.4749 3.18167 25.8125 3.17969H15.8125C15.1501 3.18167 14.5153 3.44569 14.0469 3.91411C13.5785 4.38252 13.3145 5.01725 13.3125 5.67969V6.92969H9.5625C8.90007 6.93167 8.26533 7.19569 7.79692 7.66411C7.32851 8.13252 7.06448 8.76725 7.0625 9.42969V35.6797C7.06448 36.3421 7.32851 36.9769 7.79692 37.4453C8.26533 37.9137 8.90007 38.1777 9.5625 38.1797H20.8125V35.6797H9.5625V9.42969H13.3125V13.1797H28.3125V9.42969H32.0625V23.1797H34.5625V9.42969C34.5605 8.76725 34.2965 8.13252 33.8281 7.66411C33.3597 7.19569 32.7249 6.93167 32.0625 6.92969ZM25.8125 10.6797H15.8125V5.67969H25.8125V10.6797Z"
      fill="#2BB2FE"
    />
  </svg>
);

export const IconIncidents = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <path
      d="M38.3125 27.4422L36.55 25.6797L32.0625 30.1672L27.575 25.6797L25.8125 27.4422L30.3 31.9297L25.8125 36.4172L27.575 38.1797L32.0625 33.6922L36.55 38.1797L38.3125 36.4172L33.825 31.9297L38.3125 27.4422ZM18.3125 33.1797C14.3343 33.1797 10.5189 31.5993 7.7059 28.7863C4.89285 25.9732 3.3125 22.1579 3.3125 18.1797C3.3125 14.2014 4.89285 10.3861 7.7059 7.57309C10.5189 4.76004 14.3343 3.17969 18.3125 3.17969V33.1797ZM23.095 6.63469C24.6102 7.26413 25.987 8.18487 27.1475 9.34469L28.9125 7.57969C27.5201 6.18781 25.868 5.08276 24.05 4.32719L23.095 6.63469ZM33.3125 18.1797C33.313 16.2103 32.9234 14.2602 32.1663 12.4422L29.8575 13.3972C30.4885 14.9126 30.8131 16.5381 30.8125 18.1797H33.3125Z"
      fill="#E95063"
    />
  </svg>
);

export const IconIncomeMoney = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <g clipPath="url(#clip0_100_205746)">
      <path
        d="M15.0625 3.67969H4.5625C3.5683 3.68088 2.61517 4.07635 1.91216 4.77935C1.20916 5.48236 0.813691 6.43549 0.8125 7.42969L0.8125 11.9297C0.813691 12.9239 1.20916 13.877 1.91216 14.58C2.61517 15.283 3.5683 15.6785 4.5625 15.6797H15.0625C16.0567 15.6785 17.0098 15.283 17.7128 14.58C18.4158 13.877 18.8113 12.9239 18.8125 11.9297V7.42969C18.8113 6.43549 18.4158 5.48236 17.7128 4.77935C17.0098 4.07635 16.0567 3.68088 15.0625 3.67969ZM3.8125 13.4297C3.66416 13.4297 3.51916 13.3857 3.39582 13.3033C3.27249 13.2209 3.17636 13.1037 3.11959 12.9667C3.06282 12.8297 3.04797 12.6789 3.07691 12.5334C3.10585 12.3879 3.17728 12.2542 3.28217 12.1494C3.38706 12.0445 3.5207 11.973 3.66618 11.9441C3.81167 11.9152 3.96247 11.93 4.09951 11.9868C4.23656 12.0435 4.35369 12.1397 4.4361 12.263C4.51851 12.3863 4.5625 12.5314 4.5625 12.6797C4.5625 12.8786 4.48348 13.0694 4.34283 13.21C4.20218 13.3507 4.01141 13.4297 3.8125 13.4297ZM3.8125 7.42969C3.66416 7.42969 3.51916 7.3857 3.39582 7.30329C3.27249 7.22088 3.17636 7.10374 3.11959 6.9667C3.06282 6.82966 3.04797 6.67886 3.07691 6.53337C3.10585 6.38788 3.17728 6.25425 3.28217 6.14936C3.38706 6.04447 3.5207 5.97304 3.66618 5.9441C3.81167 5.91516 3.96247 5.93001 4.09951 5.98678C4.23656 6.04354 4.35369 6.13967 4.4361 6.26301C4.51851 6.38635 4.5625 6.53135 4.5625 6.67969C4.5625 6.8786 4.48348 7.06937 4.34283 7.21002C4.20218 7.35067 4.01141 7.42969 3.8125 7.42969ZM9.8125 12.6797C9.21916 12.6797 8.63914 12.5037 8.14579 12.1741C7.65244 11.8445 7.26792 11.3759 7.04086 10.8277C6.8138 10.2796 6.75439 9.67636 6.87014 9.09442C6.9859 8.51247 7.27162 7.97792 7.69118 7.55837C8.11074 7.13881 8.64529 6.85309 9.22723 6.73733C9.80917 6.62158 10.4124 6.68099 10.9606 6.90805C11.5087 7.13511 11.9773 7.51963 12.3069 8.01298C12.6366 8.50632 12.8125 9.08634 12.8125 9.67969C12.8125 10.4753 12.4964 11.2384 11.9338 11.801C11.3712 12.3636 10.6081 12.6797 9.8125 12.6797ZM15.8125 13.4297C15.6642 13.4297 15.5192 13.3857 15.3958 13.3033C15.2725 13.2209 15.1764 13.1037 15.1196 12.9667C15.0628 12.8297 15.048 12.6789 15.0769 12.5334C15.1059 12.3879 15.1773 12.2542 15.2822 12.1494C15.3871 12.0445 15.5207 11.973 15.6662 11.9441C15.8117 11.9152 15.9625 11.93 16.0995 11.9868C16.2366 12.0435 16.3537 12.1397 16.4361 12.263C16.5185 12.3863 16.5625 12.5314 16.5625 12.6797C16.5625 12.8786 16.4835 13.0694 16.3428 13.21C16.2022 13.3507 16.0114 13.4297 15.8125 13.4297ZM15.8125 7.42969C15.6642 7.42969 15.5192 7.3857 15.3958 7.30329C15.2725 7.22088 15.1764 7.10374 15.1196 6.9667C15.0628 6.82966 15.048 6.67886 15.0769 6.53337C15.1059 6.38788 15.1773 6.25425 15.2822 6.14936C15.3871 6.04447 15.5207 5.97304 15.6662 5.9441C15.8117 5.91516 15.9625 5.93001 16.0995 5.98678C16.2366 6.04354 16.3537 6.13967 16.4361 6.26301C16.5185 6.38635 16.5625 6.53135 16.5625 6.67969C16.5625 6.8786 16.4835 7.06937 16.3428 7.21002C16.2022 7.35067 16.0114 7.42969 15.8125 7.42969ZM11.3125 9.67969C11.3125 9.97636 11.2245 10.2664 11.0597 10.513C10.8949 10.7597 10.6606 10.952 10.3865 11.0655C10.1124 11.179 9.81084 11.2087 9.51987 11.1509C9.22889 11.093 8.96162 10.9501 8.75184 10.7403C8.54206 10.5306 8.3992 10.2633 8.34132 9.97232C8.28344 9.68135 8.31315 9.37975 8.42668 9.10566C8.54021 8.83157 8.73247 8.59731 8.97915 8.43248C9.22582 8.26766 9.51583 8.17969 9.8125 8.17969C10.2103 8.17969 10.5919 8.33772 10.8732 8.61903C11.1545 8.90033 11.3125 9.28186 11.3125 9.67969Z"
        fill="#F3C619"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_205746">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.8125 0.679688)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconCreditCard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <g clipPath="url(#clip0_100_205756)">
      <path
        d="M15.0625 2.92969H4.5625C3.5683 2.93088 2.61517 3.32635 1.91216 4.02935C1.20916 4.73236 0.813691 5.68549 0.8125 6.67969H18.8125C18.8113 5.68549 18.4158 4.73236 17.7128 4.02935C17.0098 3.32635 16.0567 2.93088 15.0625 2.92969Z"
        fill="#F86624"
      />
      <path
        d="M0.8125 12.6797C0.813691 13.6739 1.20916 14.627 1.91216 15.33C2.61517 16.033 3.5683 16.4285 4.5625 16.4297H15.0625C16.0567 16.4285 17.0098 16.033 17.7128 15.33C18.4158 14.627 18.8113 13.6739 18.8125 12.6797V8.17969H0.8125V12.6797ZM6.0625 12.3047C6.0625 12.5272 5.99652 12.7447 5.8729 12.9297C5.74929 13.1147 5.57359 13.2589 5.36802 13.344C5.16245 13.4292 4.93625 13.4515 4.71802 13.4081C4.49979 13.3647 4.29934 13.2575 4.142 13.1002C3.98467 12.9428 3.87752 12.7424 3.83412 12.5242C3.79071 12.3059 3.81299 12.0797 3.89814 11.8742C3.98328 11.6686 4.12748 11.4929 4.31248 11.3693C4.49749 11.2457 4.715 11.1797 4.9375 11.1797C5.23587 11.1797 5.52202 11.2982 5.733 11.5092C5.94397 11.7202 6.0625 12.0063 6.0625 12.3047Z"
        fill="#F86624"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_205756">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.8125 0.679688)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M10.8125 17.6797L10.8125 5.67969"
      stroke="#00AC4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.97656 10.6771L10.8099 4.84375L16.6432 10.6771"
      stroke="#00AC4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrowUpSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M1.08575 5.34625H8.53908C8.67093 5.3457 8.79965 5.30606 8.90897 5.23235C9.0183 5.15865 9.10331 5.05418 9.15326 4.93215C9.20321 4.81013 9.21586 4.67604 9.1896 4.54683C9.16334 4.41762 9.09936 4.2991 9.00575 4.20625L5.28575 0.486261C5.22377 0.423776 5.15004 0.37418 5.0688 0.340334C4.98756 0.306488 4.90042 0.289062 4.81241 0.289062C4.72441 0.289062 4.63727 0.306488 4.55603 0.340334C4.47479 0.37418 4.40106 0.423776 4.33908 0.486261L0.61908 4.20625C0.525466 4.2991 0.461485 4.41762 0.435228 4.54683C0.408971 4.67604 0.421618 4.81013 0.471568 4.93215C0.521518 5.05418 0.60653 5.15865 0.715852 5.23235C0.825174 5.30606 0.953898 5.3457 1.08575 5.34625Z"
      fill="#1A9882"
    />
  </svg>
);

export const IconArrowDownSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
  >
    <path
      d="M1.0884 0.679688H8.5364C8.66823 0.679716 8.7971 0.71883 8.9067 0.792086C9.01631 0.865342 9.10174 0.969451 9.15218 1.09125C9.20263 1.21305 9.21583 1.34707 9.19012 1.47637C9.16441 1.60568 9.10094 1.72445 9.00773 1.81769L5.28373 5.54168C5.15871 5.66666 4.98918 5.73687 4.8124 5.73687C4.63562 5.73687 4.46608 5.66666 4.34107 5.54168L0.617066 1.81769C0.52386 1.72445 0.460389 1.60568 0.434677 1.47637C0.408966 1.34707 0.422168 1.21305 0.472614 1.09125C0.523061 0.969451 0.608487 0.865342 0.718094 0.792086C0.827701 0.71883 0.956566 0.679716 1.0884 0.679688Z"
      fill="#EB3D4D"
    />
  </svg>
);

export const IconDollar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <g clipPath="url(#clip0_100_205766)">
      <path
        d="M8.3635 15.6797C7.75342 15.6791 7.1685 15.4365 6.73711 15.0051C6.30571 14.5737 6.0631 13.9888 6.0625 13.3787C6.0625 13.1798 5.98348 12.989 5.84283 12.8484C5.70218 12.7077 5.51141 12.6287 5.3125 12.6287C5.11359 12.6287 4.92282 12.7077 4.78217 12.8484C4.64152 12.989 4.5625 13.1798 4.5625 13.3787V13.4297C4.5625 13.4439 4.5625 13.4567 4.5625 13.4709C4.58753 14.4626 4.9989 15.4054 5.70892 16.0981C6.41895 16.7909 7.37148 17.179 8.3635 17.1797H9.0625V17.9297C9.0625 18.1286 9.14152 18.3194 9.28217 18.46C9.42282 18.6007 9.61359 18.6797 9.8125 18.6797C10.0114 18.6797 10.2022 18.6007 10.3428 18.46C10.4835 18.3194 10.5625 18.1286 10.5625 17.9297V17.1797H11.2615C12.1635 17.1787 13.0358 16.857 13.7224 16.2721C14.409 15.6871 14.8652 14.877 15.0095 13.9866C15.1538 13.0962 14.9767 12.1835 14.5099 11.4117C14.0431 10.6399 13.3171 10.0592 12.4615 9.77344L10.5625 9.13969V3.67969H11.2615C11.8716 3.68028 12.4565 3.9229 12.8879 4.35429C13.3193 4.78569 13.5619 5.37061 13.5625 5.98069C13.5625 6.1796 13.6415 6.37037 13.7822 6.51102C13.9228 6.65167 14.1136 6.73069 14.3125 6.73069C14.5114 6.73069 14.7022 6.65167 14.8428 6.51102C14.9835 6.37037 15.0625 6.1796 15.0625 5.98069V5.92969C15.0625 5.91544 15.0625 5.90269 15.0625 5.88844C15.0375 4.89673 14.6261 3.95402 13.9161 3.26123C13.206 2.56843 12.2535 2.18035 11.2615 2.17969H10.5625V1.42969C10.5625 1.23078 10.4835 1.04001 10.3428 0.899357C10.2022 0.758705 10.0114 0.679688 9.8125 0.679688C9.61359 0.679688 9.42282 0.758705 9.28217 0.899357C9.14152 1.04001 9.0625 1.23078 9.0625 1.42969V2.17969H8.3635C7.46149 2.18065 6.58922 2.50236 5.9026 3.08732C5.21597 3.67228 4.75976 4.48236 4.61549 5.37276C4.47122 6.26315 4.64831 7.17584 5.11509 7.94768C5.58188 8.71952 6.30794 9.3002 7.1635 9.58594L9.0625 10.2197V15.6797H8.3635ZM10.5625 10.7199L11.9875 11.1954C12.5059 11.368 12.9461 11.7194 13.2291 12.1868C13.5121 12.6542 13.6196 13.207 13.5323 13.7464C13.4449 14.2858 13.1685 14.7765 12.7525 15.1307C12.3364 15.4849 11.8079 15.6795 11.2615 15.6797H10.5625V10.7199ZM7.6375 8.16394C7.11905 7.99138 6.67893 7.63997 6.3959 7.17258C6.11287 6.70519 6.0054 6.15233 6.09273 5.61294C6.18005 5.07356 6.45647 4.58285 6.87252 4.22865C7.28857 3.87444 7.81709 3.67984 8.3635 3.67969H9.0625V8.63944L7.6375 8.16394Z"
        fill="#2BB2FE"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_205766">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.8125 0.679688)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconArrowDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M10.8125 3.67969L10.8125 15.6797"
      stroke="#E95063"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6484 10.6823L10.8151 16.5156L4.98177 10.6823"
      stroke="#E95063"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDataDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
  >
    <path
      d="M1.8125 1.67969L6.8125 6.67969L11.8125 1.67969"
      stroke="#A4B4CB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDots = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="172"
    height="24"
    viewBox="0 0 172 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#929BC0" />
    <rect x="37" width="24" height="24" rx="12" fill="#929BC0" />
    <rect x="74" width="24" height="24" rx="12" fill="#929BC0" />
    <rect x="111" width="24" height="24" rx="12" fill="#929BC0" />
    <rect x="148" width="24" height="24" rx="12" fill="#929BC0" />
  </svg>
);

export const IconSearch = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00094 0.686035C7.69946 0.686146 6.41688 0.997481 5.26021 1.59407C4.10353 2.19065 3.1063 3.05519 2.35171 4.11554C1.59712 5.1759 1.10706 6.40133 0.922408 7.68959C0.737758 8.97785 0.863874 10.2916 1.29024 11.5212C1.7166 12.7508 2.43084 13.8606 3.37337 14.7581C4.31591 15.6555 5.4594 16.3146 6.70845 16.6802C7.9575 17.0459 9.27589 17.1076 10.5536 16.8601C11.8314 16.6126 13.0314 16.0632 14.0536 15.2576L17.5603 18.7642C17.7414 18.9391 17.9839 19.0359 18.2357 19.0337C18.4874 19.0315 18.7283 18.9305 18.9063 18.7525C19.0843 18.5745 19.1853 18.3337 19.1875 18.0819C19.1897 17.8301 19.0929 17.5876 18.918 17.4065L15.4113 13.9C16.36 12.6965 16.9507 11.2503 17.1158 9.72677C17.2809 8.20329 17.0137 6.6641 16.3448 5.28536C15.676 3.90662 14.6325 2.74403 13.3337 1.93064C12.0349 1.11726 10.5334 0.685932 9.00094 0.686035ZM2.75957 8.84752C2.75957 7.19227 3.41714 5.60481 4.58763 4.43437C5.75811 3.26393 7.34563 2.60638 9.00094 2.60638C10.6563 2.60638 12.2438 3.26393 13.4143 4.43437C14.5847 5.60481 15.2423 7.19227 15.2423 8.84752C15.2423 10.5028 14.5847 12.0902 13.4143 13.2607C12.2438 14.4311 10.6563 15.0887 9.00094 15.0887C7.34563 15.0887 5.75811 14.4311 4.58763 13.2607C3.41714 12.0902 2.75957 10.5028 2.75957 8.84752Z"
      fill="#A4B4CB"
    />
  </svg>
);

export const IconDownloadArrowNew = () => (
<svg xmlns="http://www.w3.org/2000/svg" version="1.1"  width="512" height="512" x="0" y="0" viewBox="0 0 24 24"   class=""><g><path d="M21 19H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2zM12 2a1 1 0 0 0-1 1v10.59l-3.29-3.3a1 1 0 0 0-1.42 1.42l5 5a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0-1.42-1.42L13 13.59V3a1 1 0 0 0-1-1z" fill="#000000" opacity="1" data-original="#000000"></path></g>
</svg>  
);


export const IconDownloadArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="8"
    viewBox="0 0 15 8"
    fill="none"
  >
    <path
      d="M13.1523 1L7.15234 7L1.15234 1"
      stroke="#131635"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>



);



export const IconButtonDots = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="24"
    viewBox="0 0 6 24"
    fill="none"
  >
    <circle cx="2.97373" cy="3.45224" r="2.59677" fill="#75869E" />
    <circle cx="2.97373" cy="12.3556" r="2.59677" fill="#75869E" />
    <circle cx="2.97373" cy="21.2589" r="2.59677" fill="#75869E" />
  </svg>
);

export const IconEyes = () => (
  <svg
    width="25"
    height="25"
    x="0"
    y="0"
    viewBox="0 0 128 128"
    style={{ enableBackground: "new 0 0 512 512" }}
  >
    <g>
      <path
        d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z"
        fill="#000000"
        opacity="1"
      />
    </g>
  </svg>
);

export const IconViewEyes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M2.72949 13.5227C2.02116 12.6027 1.66699 12.1419 1.66699 10.776C1.66699 9.40937 2.02116 8.95021 2.72949 8.02938C4.14366 6.19271 6.51533 4.10938 10.0003 4.10938C13.4853 4.10938 15.857 6.19271 17.2712 8.02938C17.9795 8.95104 18.3337 9.41021 18.3337 10.776C18.3337 12.1427 17.9795 12.6019 17.2712 13.5227C15.857 15.3594 13.4853 17.4427 10.0003 17.4427C6.51533 17.4427 4.14366 15.3594 2.72949 13.5227Z"
      stroke="#01265D"
      stroke-width="1.5"
    />
    <path
      d="M12.5 10.7812C12.5 11.4443 12.2366 12.0802 11.7678 12.549C11.2989 13.0179 10.663 13.2812 10 13.2812C9.33696 13.2812 8.70107 13.0179 8.23223 12.549C7.76339 12.0802 7.5 11.4443 7.5 10.7812C7.5 10.1182 7.76339 9.48232 8.23223 9.01348C8.70107 8.54464 9.33696 8.28125 10 8.28125C10.663 8.28125 11.2989 8.54464 11.7678 9.01348C12.2366 9.48232 12.5 10.1182 12.5 10.7812Z"
      stroke="#01265D"
      stroke-width="1.5"
    />
  </svg>
);

// "View More";

export const IconClose = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
  >
    <path
      d="M6.37646 5.85547L1.37646 0.855469M6.37646 5.85547L11.3765 10.8555M6.37646 5.85547L11.3765 0.855469M6.37646 5.85547L1.37646 10.8555"
      stroke="#989898"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDownload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.93158 5.38325V1.41102C5.93158 1.26368 5.87305 1.12237 5.76886 1.01819C5.66468 0.914 5.52337 0.855469 5.37603 0.855469C5.22868 0.855469 5.08738 0.914 4.98319 1.01819C4.879 1.12237 4.82047 1.26368 4.82047 1.41102V5.38325L3.58714 3.84102C3.54244 3.78153 3.48625 3.73161 3.42189 3.69425C3.35753 3.65689 3.28632 3.63284 3.21249 3.62352C3.13866 3.61421 3.06371 3.61982 2.99209 3.64003C2.92047 3.66024 2.85364 3.69463 2.79557 3.74116C2.73749 3.7877 2.68936 3.84542 2.65402 3.91092C2.61869 3.97641 2.59687 4.04833 2.58987 4.12242C2.58286 4.19651 2.59082 4.27124 2.61325 4.3422C2.63569 4.41315 2.67215 4.47888 2.72047 4.53547L4.94269 7.31325C4.99475 7.37813 5.06071 7.4305 5.13571 7.46648C5.21072 7.50247 5.29284 7.52115 5.37603 7.52115C5.45921 7.52115 5.54134 7.50247 5.61634 7.46648C5.69134 7.4305 5.7573 7.37813 5.80936 7.31325L8.03158 4.53547C8.07991 4.47888 8.11637 4.41315 8.1388 4.3422C8.16124 4.27124 8.16919 4.19651 8.16219 4.12242C8.15518 4.04833 8.13337 3.97641 8.09803 3.91092C8.0627 3.84542 8.01456 3.7877 7.95649 3.74116C7.89842 3.69463 7.83158 3.66024 7.75996 3.64003C7.68834 3.61982 7.61339 3.61421 7.53956 3.62352C7.46573 3.63284 7.39452 3.65689 7.33017 3.69425C7.26581 3.73161 7.20961 3.78153 7.16492 3.84102L5.93158 5.38325Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0748 8.0078L2.79758 6.41113H1.48758C1.19289 6.41113 0.910275 6.5282 0.701902 6.73657C0.493528 6.94494 0.376465 7.22756 0.376465 7.52224V9.74447C0.376465 10.0392 0.493528 10.3218 0.701902 10.5301C0.910275 10.7385 1.19289 10.8556 1.48758 10.8556H9.26535C9.56004 10.8556 9.84265 10.7385 10.051 10.5301C10.2594 10.3218 10.3765 10.0392 10.3765 9.74447V7.52224C10.3765 7.22756 10.2594 6.94494 10.051 6.73657C9.84265 6.5282 9.56004 6.41113 9.26535 6.41113H7.95535L6.67758 8.0078C6.52143 8.20296 6.3234 8.3605 6.09813 8.46876C5.87286 8.57702 5.62612 8.63323 5.37619 8.63323C5.12625 8.63323 4.87952 8.57702 4.65425 8.46876C4.42898 8.3605 4.23094 8.20296 4.0748 8.0078ZM8.15424 8.0778C8.0069 8.0778 7.86559 8.13633 7.76141 8.24052C7.65722 8.3447 7.59869 8.48601 7.59869 8.63336C7.59869 8.7807 7.65722 8.92201 7.76141 9.02619C7.86559 9.13038 8.0069 9.18891 8.15424 9.18891H8.1598C8.30714 9.18891 8.44845 9.13038 8.55264 9.02619C8.65682 8.92201 8.71535 8.7807 8.71535 8.63336C8.71535 8.48601 8.65682 8.3447 8.55264 8.24052C8.44845 8.13633 8.30714 8.0778 8.1598 8.0778H8.15424Z"
      fill="black"
    />
  </svg>
);

export const IconPrint = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54785 2.10547C2.54785 1.77395 2.67955 1.45601 2.91397 1.22159C3.14839 0.987165 3.46633 0.855469 3.79785 0.855469H7.96452C8.29604 0.855469 8.61398 0.987165 8.8484 1.22159C9.08282 1.45601 9.21452 1.77395 9.21452 2.10547V2.52214H10.0479C10.4899 2.52214 10.9138 2.69773 11.2264 3.01029C11.5389 3.32285 11.7145 3.74677 11.7145 4.1888V7.9388C11.7145 8.27032 11.5828 8.58826 11.3484 8.82269C11.114 9.05711 10.796 9.1888 10.4645 9.1888H9.21452V9.60547C9.21452 9.93699 9.08282 10.2549 8.8484 10.4894C8.61398 10.7238 8.29604 10.8555 7.96452 10.8555H3.79785C3.46633 10.8555 3.14839 10.7238 2.91397 10.4894C2.67955 10.2549 2.54785 9.93699 2.54785 9.60547V9.1888H1.29785C0.966331 9.1888 0.648389 9.05711 0.413968 8.82269C0.179548 8.58826 0.0478516 8.27032 0.0478516 7.9388V4.1888C0.0478516 3.74677 0.223446 3.32285 0.536007 3.01029C0.848568 2.69773 1.27249 2.52214 1.71452 2.52214H2.54785V2.10547ZM8.38119 2.10547C8.38119 1.99496 8.33729 1.88898 8.25915 1.81084C8.18101 1.7327 8.07503 1.6888 7.96452 1.6888H3.79785C3.68734 1.6888 3.58136 1.7327 3.50322 1.81084C3.42508 1.88898 3.38119 1.99496 3.38119 2.10547V2.52214H8.38119V2.10547ZM3.38119 7.9388V9.60547C3.38119 9.71598 3.42508 9.82196 3.50322 9.9001C3.58136 9.97824 3.68734 10.0221 3.79785 10.0221H7.96452C8.07503 10.0221 8.18101 9.97824 8.25915 9.9001C8.33729 9.82196 8.38119 9.71598 8.38119 9.60547V7.9388C8.38119 7.8283 8.33729 7.72231 8.25915 7.64417C8.18101 7.56603 8.07503 7.52214 7.96452 7.52214H3.79785C3.68734 7.52214 3.58136 7.56603 3.50322 7.64417C3.42508 7.72231 3.38119 7.8283 3.38119 7.9388Z"
      fill="black"
    />
  </svg>
);
export const IconFile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
  >
    <path
      d="M11.9407 0.857422L14.3715 3.29582L14.3621 3.30479L11.9614 3.30661L11.939 0.859233L11.9407 0.857422Z"
      fill="#F1F1F1"
    />
    <path
      d="M5.41026 4.70606C5.41026 5.16871 5.15181 5.38724 4.75513 5.38411C4.70085 5.38411 4.64023 5.38411 4.60303 5.37559V4.1088C4.64023 4.10028 4.70352 4.09131 4.80135 4.09131C5.17737 4.09135 5.41297 4.30403 5.41026 4.70606Z"
      fill="#F1F1F1"
    />
    <path
      d="M3.45393 4.37047C3.45393 4.56879 3.3103 4.68682 3.07791 4.68682C3.01461 4.68682 2.9684 4.68369 2.93115 4.67517V4.10346C2.96301 4.09494 3.02313 4.08643 3.11198 4.08643C3.33051 4.08643 3.45393 4.19231 3.45393 4.37047Z"
      fill="#F1F1F1"
    />
    <path
      d="M1.99191 2.56055H9.53054V6.91321H1.99191H1.97352H0.376465V2.56055H1.97348H1.99191Z"
      fill="#F1F1F1"
    />
    <path
      d="M8.38868 9.16025C8.39403 9.61212 8.10505 10.4938 8.10505 10.4938C8.00538 10.3889 7.80615 9.82703 7.80615 9.30738C7.80615 8.78777 7.97402 8.646 8.10505 8.646C8.2365 8.646 8.38321 8.70884 8.38868 9.16025Z"
      fill="#DC1D00"
    />
    <path
      d="M11.537 13.101C11.537 13.6978 10.4556 13.4545 9.79053 12.8214C9.79053 12.8214 11.537 12.5046 11.537 13.101Z"
      fill="#DC1D00"
    />
    <path
      d="M5.26332 15.0666C4.72799 14.7462 6.38694 13.7594 6.68625 13.728C6.68625 13.728 5.82379 15.4017 5.26332 15.0666Z"
      fill="#DC1D00"
    />
    <path
      d="M8.36355 11.4756C8.66784 12.0424 9.27177 12.7092 9.27177 12.7092C9.27177 12.7092 9.04065 12.7352 8.5036 12.8667C7.96642 12.9981 7.69678 13.1346 7.69678 13.1346C7.69678 13.1346 7.69678 13.1346 7.91711 12.641C8.13786 12.1473 8.36355 11.4756 8.36355 11.4756Z"
      fill="#DC1D00"
    />
    <path
      d="M14.3786 3.30506V17.5482H1.99365V6.9133H9.53228V2.56063H1.99365V0.855469H11.9371L11.9388 0.857691L11.9371 0.859461L11.9595 3.30683L14.3602 3.30502L14.3696 3.29605L14.3786 3.30506Z"
      fill="#DC1D00"
    />
    <path
      d="M6.69024 13.7279C6.39097 13.7593 4.73198 14.746 5.2673 15.0664C5.82778 15.4016 6.69024 13.7279 6.69024 13.7279ZM9.79632 12.8214C10.4613 13.4546 11.5428 13.6979 11.5428 13.101C11.5428 12.5046 9.79632 12.8214 9.79632 12.8214ZM9.27309 12.7093C9.27309 12.7093 8.66911 12.0425 8.36486 11.4757C8.36486 11.4757 8.13918 12.1474 7.91839 12.641C7.69805 13.1346 7.69805 13.1346 7.69805 13.1346C7.69805 13.1346 7.96773 12.9982 8.50487 12.8667C9.04197 12.7353 9.27309 12.7093 9.27309 12.7093ZM8.11272 10.4939C8.11272 10.4939 8.40166 9.61215 8.39635 9.16028C8.39087 8.70887 8.2442 8.64602 8.11272 8.64602C7.98168 8.64602 7.81382 8.7878 7.81382 9.30741C7.81382 9.82705 8.01304 10.3889 8.11272 10.4939ZM8.47528 11.1764C8.76924 11.8118 9.57783 12.6303 9.57783 12.6303C9.57783 12.6303 9.8399 12.5621 10.9213 12.5361C12.0032 12.51 12.0503 13.1185 12.0552 13.171C12.0606 13.224 12.1029 13.7068 11.2417 13.7382C10.3811 13.7696 9.48811 12.8721 9.48811 12.8721C9.48811 12.8721 9.12102 12.93 8.81677 13.0032C8.51252 13.0768 7.53566 13.3447 7.53566 13.3447C7.53566 13.3447 7.24668 13.8697 6.60632 14.7092C5.96556 15.5493 5.24804 15.4865 5.04339 15.2082C4.80556 14.8851 4.9891 14.5626 5.44052 14.1425C5.89194 13.7225 6.93345 13.3743 6.93345 13.3743C6.93345 13.3743 7.14346 12.9964 7.45129 12.2753C7.75908 11.5542 7.99201 10.83 7.99201 10.83C7.99201 10.83 7.68731 10.1381 7.62805 9.54931C7.56167 8.89282 7.63525 8.45174 8.13918 8.44635C8.64315 8.44095 8.8006 8.81924 8.81632 9.47523C8.832 10.1318 8.47528 11.1764 8.47528 11.1764Z"
      fill="white"
    />
    <path
      d="M7.31783 4.13991V3.76953H6.16553V5.70376H6.57706V4.92184H7.27668V4.59261H6.57706V4.13991H7.31783Z"
      fill="#A51600"
    />
    <path
      d="M5.553 3.96225C5.36632 3.82134 5.11891 3.75537 4.75095 3.75537C4.52975 3.75537 4.31452 3.76973 4.1499 3.79574V5.69746C4.27336 5.71182 4.42921 5.72614 4.65626 5.72614C5.03545 5.72614 5.35056 5.64581 5.55427 5.47621C5.74095 5.31827 5.87832 5.06246 5.87832 4.69182C5.87832 4.35041 5.75449 4.11168 5.553 3.96225ZM4.73684 5.38428C4.68256 5.38428 4.64375 5.38428 4.56144 5.37576V4.10896C4.64375 4.10045 4.68523 4.09147 4.78309 4.09147C5.15912 4.09147 5.39468 4.30416 5.39196 4.70623C5.39196 5.16888 5.13348 5.38741 4.73684 5.38428Z"
      fill="#A51600"
    />
    <path
      d="M3.68253 3.9106C3.55331 3.80694 3.34264 3.75537 3.07247 3.75537C2.80546 3.75537 2.58586 3.77286 2.4624 3.79574V5.70351H2.91509V5.01356C2.95625 5.01941 3.01588 5.02254 3.07337 5.02254C3.33182 5.02254 3.55742 4.95924 3.70689 4.81837C3.82175 4.70936 3.88719 4.54824 3.88719 4.35889C3.88719 4.16909 3.80591 4.00843 3.68253 3.9106ZM3.07061 4.68647C3.00736 4.68647 2.95625 4.68335 2.91509 4.67483V4.10312C2.95625 4.0946 3.01588 4.08608 3.10469 4.08608C3.32326 4.08608 3.44664 4.19197 3.44664 4.37013C3.44664 4.56845 3.30305 4.68647 3.07061 4.68647Z"
      fill="#A51600"
    />
  </svg>
);

export const IconLocation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M10.372 2.46484C12.219 2.46484 13.9904 3.19858 15.2965 4.50464C16.6026 5.81069 17.3363 7.58209 17.3363 9.42913C17.3363 12.372 15.2684 15.5791 11.1863 19.0848C10.9593 19.2798 10.6699 19.3869 10.3707 19.3867C10.0714 19.3864 9.78222 19.2788 9.55557 19.0834L9.28557 18.8491C5.38414 15.4348 3.40771 12.3063 3.40771 9.42913C3.40771 7.58209 4.14145 5.81069 5.44751 4.50464C6.75356 3.19858 8.52496 2.46484 10.372 2.46484ZM10.372 3.53627C8.80912 3.53627 7.31025 4.15713 6.20512 5.26225C5.1 6.36738 4.47914 7.86625 4.47914 9.42913C4.47914 11.9306 6.29914 14.8127 9.98914 18.0413L10.2556 18.272C10.288 18.2998 10.3293 18.3152 10.372 18.3152C10.4147 18.3152 10.456 18.2998 10.4884 18.272C14.357 14.9491 16.2649 11.9898 16.2649 9.42913C16.2649 8.65527 16.1124 7.88899 15.8163 7.17403C15.5201 6.45908 15.0861 5.80945 14.5389 5.26225C13.9917 4.71505 13.3421 4.28098 12.6271 3.98484C11.9121 3.6887 11.1459 3.53627 10.372 3.53627ZM10.372 6.75056C11.0824 6.75056 11.7637 7.03276 12.266 7.53509C12.7684 8.03742 13.0506 8.71873 13.0506 9.42913C13.0506 10.1395 12.7684 10.8208 12.266 11.3232C11.7637 11.8255 11.0824 12.1077 10.372 12.1077C9.6616 12.1077 8.98029 11.8255 8.47796 11.3232C7.97564 10.8208 7.69343 10.1395 7.69343 9.42913C7.69343 8.71873 7.97564 8.03742 8.47796 7.53509C8.98029 7.03276 9.6616 6.75056 10.372 6.75056ZM10.372 7.82199C9.94576 7.82199 9.53698 7.99131 9.23558 8.29271C8.93418 8.59411 8.76486 9.00289 8.76486 9.42913C8.76486 9.85537 8.93418 10.2642 9.23558 10.5656C9.53698 10.867 9.94576 11.0363 10.372 11.0363C10.7982 11.0363 11.207 10.867 11.5084 10.5656C11.8098 10.2642 11.9791 9.85537 11.9791 9.42913C11.9791 9.00289 11.8098 8.59411 11.5084 8.29271C11.207 7.99131 10.7982 7.82199 10.372 7.82199Z"
      fill="#01265D"
    />
  </svg>
);

export const IconUpload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clip-path="url(#clip0_1_2317)">
      <path
        d="M18.747 10.5714L11.0886 18.2297C10.1504 19.1679 8.87794 19.695 7.55112 19.695C6.2243 19.695 4.95182 19.1679 4.01362 18.2297C3.07542 17.2915 2.54834 16.019 2.54834 14.6922C2.54834 13.3654 3.07542 12.0929 4.01362 11.1547L11.672 3.49638C12.2974 2.87092 13.1457 2.51953 14.0303 2.51953C14.9148 2.51953 15.7632 2.87092 16.3886 3.49638C17.0141 4.12185 17.3655 4.97017 17.3655 5.85472C17.3655 6.73926 17.0141 7.58758 16.3886 8.21305L8.72195 15.8714C8.5671 16.0262 8.38327 16.1491 8.18095 16.2329C7.97863 16.3167 7.76178 16.3598 7.54279 16.3598C7.3238 16.3598 7.10695 16.3167 6.90463 16.2329C6.7023 16.1491 6.51847 16.0262 6.36362 15.8714C6.20877 15.7165 6.08594 15.5327 6.00213 15.3304C5.91833 15.1281 5.87519 14.9112 5.87519 14.6922C5.87519 14.4732 5.91833 14.2564 6.00213 14.0541C6.08594 13.8517 6.20877 13.6679 6.36362 13.5131L13.4386 6.44638"
        stroke="#01265D"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2317">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.876465 0.855469)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconDocs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M2.87646 8.41899C2.87646 5.27649 2.87646 3.70482 3.85313 2.72899C4.82896 1.75232 6.40063 1.75232 9.54313 1.75232H11.2098C14.3523 1.75232 15.924 1.75232 16.8998 2.72899C17.8765 3.70482 17.8765 5.27649 17.8765 8.41899V11.7523C17.8765 14.8948 17.8765 16.4665 16.8998 17.4423C15.924 18.419 14.3523 18.419 11.2098 18.419H9.54313C6.40063 18.419 4.82896 18.419 3.85313 17.4423C2.87646 16.4665 2.87646 14.8948 2.87646 11.7523V8.41899Z"
      stroke="#01265D"
      stroke-width="1.5"
    />
    <path
      d="M7.04834 8.41638H13.715M7.04834 11.7497H11.215"
      stroke="#01265D"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);

export const IconFileAdd = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.127 8.26953C19.4107 8.28257 20.6475 8.38646 21.4543 9.21407C22.377 10.1605 22.377 11.6837 22.377 14.7301V15.8071C22.377 18.8535 22.377 20.3768 21.4543 21.3231C20.5317 22.2695 19.0468 22.2695 16.077 22.2695H7.67695C4.7071 22.2695 3.22218 22.2695 2.29957 21.3231C1.37695 20.3768 1.37695 18.8535 1.37695 15.8071V14.7301C1.37695 11.6837 1.37695 10.1605 2.29957 9.21406C3.10637 8.38646 4.34317 8.28257 6.62695 8.26953"
      stroke="#1C274C"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M11.877 15.2695V1.26953M11.877 1.26953L15.377 5.03876M11.877 1.26953L8.37695 5.03876"
      stroke="#1C274C"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconPaginationLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M14.8499 6.41663L4.09739 6.41663L8.79499 1.71904C9.17041 1.34362 9.17041 0.72754 8.79499 0.352118C8.41957 -0.0233046 7.81311 -0.0233047 7.43769 0.352118L1.09401 6.69579C1.00477 6.78485 0.933975 6.89063 0.885669 7.00708C0.837364 7.12353 0.812501 7.24837 0.812501 7.37444C0.812501 7.50051 0.837364 7.62535 0.885669 7.7418C0.933975 7.85825 1.00477 7.96403 1.09401 8.05309L7.42806 14.4064C7.51719 14.4955 7.62299 14.5662 7.73943 14.6144C7.85587 14.6627 7.98068 14.6875 8.10671 14.6875C8.23275 14.6875 8.35755 14.6627 8.47399 14.6144C8.59044 14.5662 8.69624 14.4955 8.78536 14.4064C8.87448 14.3173 8.94518 14.2115 8.99341 14.095C9.04164 13.9786 9.06647 13.8538 9.06647 13.7277C9.06647 13.6017 9.04164 13.4769 8.99341 13.3605C8.94518 13.244 8.87448 13.1382 8.78536 13.0491L4.09739 8.34188L14.8499 8.34188C15.3793 8.34188 15.8125 7.9087 15.8125 7.37926C15.8125 6.84981 15.3793 6.41663 14.8499 6.41663Z"
      fill="#01265D"
    />
  </svg>
);

export const IconPaginationRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M1.77512 8.95837H12.5276L7.83001 13.656C7.45459 14.0314 7.45459 14.6475 7.83001 15.0229C8.20544 15.3983 8.81189 15.3983 9.18731 15.0229L15.531 8.67921C15.6202 8.59015 15.691 8.48437 15.7393 8.36792C15.7876 8.25147 15.8125 8.12663 15.8125 8.00056C15.8125 7.87449 15.7876 7.74965 15.7393 7.6332C15.691 7.51675 15.6202 7.41097 15.531 7.32191L9.19694 0.968605C9.10781 0.879484 9.00201 0.808789 8.88557 0.760557C8.76913 0.712325 8.64432 0.6875 8.51829 0.6875C8.39225 0.6875 8.26745 0.712325 8.15101 0.760557C8.03456 0.808789 7.92876 0.879484 7.83964 0.968605C7.75052 1.05773 7.67982 1.16353 7.63159 1.27997C7.58336 1.39641 7.55853 1.52122 7.55853 1.64725C7.55853 1.77329 7.58336 1.89809 7.63159 2.01454C7.67982 2.13098 7.75052 2.23678 7.83964 2.3259L12.5276 7.03312H1.77512C1.24568 7.03312 0.8125 7.4663 0.8125 7.99575C0.8125 8.52519 1.24568 8.95837 1.77512 8.95837Z"
      fill="#01265D"
    />
  </svg>
);

export const IconViewAll = () => (
  <svg
    version="1.1"
    width="512"
    height="512"
    viewBox="0 0 64 64"
    style={{ enableBackground: "new 0 0 512 512" }}
  >
    <g>
      <path
        d="M61 31v24a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V9a6 6 0 0 1 6-6h24a3 3 0 0 1 0 6H11a2.006 2.006 0 0 0-2 2v42a2.006 2.006 0 0 0 2 2h42a2.006 2.006 0 0 0 2-2V31a3 3 0 0 1 6 0z"
        fill="#000000"
        opacity="1"
      />
      <path
        d="M61 5v14a3 3 0 0 1-6 0v-5.76L36.96 31.28a3 3 0 0 1-4.24-4.24L50.76 9H45a3 3 0 0 1 0-6h14a2.006 2.006 0 0 1 2 2z"
        fill="#000000"
        opacity="1"
      />
    </g>
  </svg>
);

export const IconConfirmed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
  >
    <path
      d="M3.85714 9.46875L5.28571 10.8021L8.14286 8.13542M6.71429 1.46875H3.28571C2.48564 1.46875 2.0856 1.46875 1.78001 1.61408C1.51121 1.7419 1.29266 1.94588 1.15571 2.19676C1 2.48198 1 2.85535 1 3.60208V11.3354C1 12.0821 1 12.4556 1.15571 12.7408C1.29266 12.9916 1.51121 13.1956 1.78001 13.3234C2.0856 13.4688 2.48564 13.4688 3.28571 13.4688H8.71429C9.51436 13.4688 9.91443 13.4688 10.22 13.3234C10.4888 13.1956 10.7074 12.9916 10.8443 12.7408C11 12.4556 11 12.0821 11 11.3354V5.46875M6.71429 1.46875L11 5.46875M6.71429 1.46875V4.40208C6.71429 4.77545 6.71429 4.96214 6.79214 5.10474C6.86064 5.23018 6.96986 5.33217 7.10429 5.39609C7.25707 5.46875 7.45707 5.46875 7.85714 5.46875H11"
      stroke="white"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconPacked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M7 4.13542V12.8021M7 4.13542H4.64286C4.29555 4.13542 3.96247 3.99494 3.71689 3.74489C3.4713 3.49484 3.33333 3.1557 3.33333 2.80208C3.33333 2.44846 3.4713 2.10932 3.71689 1.85928C3.96247 1.60922 4.29555 1.46875 4.64286 1.46875C6.4762 1.46875 7 4.13542 7 4.13542ZM7 4.13542H9.35713C9.70447 4.13542 10.0375 3.99494 10.2831 3.74489C10.5287 3.49484 10.6667 3.1557 10.6667 2.80208C10.6667 2.44846 10.5287 2.10932 10.2831 1.85928C10.0375 1.60922 9.70447 1.46875 9.35713 1.46875C7.5238 1.46875 7 4.13542 7 4.13542ZM2.33333 7.46875H11.6667V11.3354C11.6667 12.0821 11.6667 12.4556 11.5213 12.7408C11.3935 12.9916 11.1895 13.1956 10.9387 13.3234C10.6535 13.4688 10.2801 13.4688 9.53333 13.4688H4.46667C3.71993 13.4688 3.34656 13.4688 3.06135 13.3234C2.81046 13.1956 2.60649 12.9916 2.47866 12.7408C2.33333 12.4556 2.33333 12.0821 2.33333 11.3354V7.46875ZM2.06667 7.46875H11.9333C12.3067 7.46875 12.4934 7.46875 12.636 7.39608C12.7615 7.33215 12.8634 7.23022 12.9273 7.10475C13 6.96215 13 6.77548 13 6.40208V5.20208C13 4.82872 13 4.64203 12.9273 4.49942C12.8634 4.37398 12.7615 4.272 12.636 4.20808C12.4934 4.13542 12.3067 4.13542 11.9333 4.13542H2.06667C1.6933 4.13542 1.50661 4.13542 1.36401 4.20808C1.23857 4.272 1.13658 4.37398 1.07266 4.49942C1 4.64203 1 4.82872 1 5.20208V6.40208C1 6.77548 1 6.96215 1.07266 7.10475C1.13658 7.23022 1.23857 7.33215 1.36401 7.39608C1.50661 7.46875 1.6933 7.46875 2.06667 7.46875Z"
      stroke="white"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconDispatched = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      d="M11.25 0.46875H0.75C0.335438 0.46875 0 0.804188 0 1.21875V2.71875C0 3.13331 0.335438 3.46875 0.75 3.46875H11.25C11.6646 3.46875 12 3.13331 12 2.71875V1.21875C12 0.804188 11.6646 0.46875 11.25 0.46875Z"
      fill="white"
    />
    <path
      d="M0.75 4.96875V11.7188C0.75 12.1333 1.08544 12.4688 1.5 12.4688H10.5C10.9146 12.4688 11.25 12.1333 11.25 11.7188V4.96875H0.75ZM7.5 7.96875H4.5C4.08544 7.96875 3.75 7.63331 3.75 7.21875C3.75 6.80419 4.08544 6.46875 4.5 6.46875H7.5C7.91456 6.46875 8.25 6.80419 8.25 7.21875C8.25 7.63331 7.91456 7.96875 7.5 7.96875Z"
      fill="white"
    />
  </svg>
);

export const IconLocker = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M5.66667 8.96875H10.3333M2.24444 5.96875H13.7556C14.1912 5.96875 14.409 5.96875 14.5753 5.88701C14.7217 5.8151 14.8406 5.70036 14.9152 5.55924C15 5.39881 15 5.18879 15 4.76875V2.66875C15 2.24871 15 2.03869 14.9152 1.87826C14.8406 1.73714 14.7217 1.6224 14.5753 1.55049C14.409 1.46875 14.1912 1.46875 13.7556 1.46875H2.24444C1.80885 1.46875 1.59105 1.46875 1.42467 1.55049C1.27833 1.6224 1.15934 1.73714 1.08477 1.87826C1 2.03869 1 2.24871 1 2.66875V4.76875C1 5.18879 1 5.39881 1.08477 5.55924C1.15934 5.70036 1.27833 5.8151 1.42467 5.88701C1.59105 5.96875 1.80885 5.96875 2.24444 5.96875ZM2.55556 5.96875H13.4444V11.0687C13.4444 11.9088 13.4444 12.3289 13.2749 12.6498C13.1258 12.932 12.8878 13.1615 12.5951 13.3052C12.2624 13.4687 11.8267 13.4688 10.9556 13.4688H5.04444C4.17325 13.4688 3.73765 13.4687 3.4049 13.3052C3.1122 13.1615 2.87423 12.932 2.7251 12.6498C2.55556 12.3289 2.55556 11.9088 2.55556 11.0687V5.96875Z"
      stroke="#A4B4CB"
      stroke-width="1.55556"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconDivider = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
  >
    <path
      d="M11 6.46875L6 1.46875L1 6.46875"
      stroke="#A4B4CB"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const EmiratesID = () => (
  <img src={images["icon-1.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="58"
  //   height="42"
  //   viewBox="0 0 58 42"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <path
  //     d="M51.9567 2.26953H6.79717C4.35595 2.26953 2.37695 4.22936 2.37695 6.64692V35.8921C2.37695 38.3097 4.35595 40.2695 6.79717 40.2695H51.9567C54.398 40.2695 56.377 38.3097 56.377 35.8921V6.64692C56.377 4.22936 54.398 2.26953 51.9567 2.26953Z"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M16.921 22.1016C19.4306 22.1016 21.465 20.0868 21.465 17.6016C21.465 15.1163 19.4306 13.1016 16.921 13.1016C14.4114 13.1016 12.377 15.1163 12.377 17.6016C12.377 20.0868 14.4114 22.1016 16.921 22.1016Z"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M9.73439 32.9283H24.1494C24.4089 32.9286 24.6631 32.8552 24.8817 32.7168C25.1003 32.5783 25.2741 32.3807 25.3827 32.1473C25.4912 31.9138 25.5297 31.6545 25.4938 31.4C25.4579 31.1455 25.3489 30.9066 25.1799 30.7116C24.1897 29.4909 22.9355 28.5058 21.5097 27.829C20.084 27.1522 18.523 26.8008 16.9419 26.8008C15.3608 26.8008 13.7998 27.1522 12.3741 27.829C10.9483 28.5058 9.69412 29.4909 8.70389 30.7116C8.53488 30.9066 8.42595 31.1455 8.39001 31.4C8.35408 31.6545 8.39266 31.9138 8.50117 32.1473C8.60968 32.3807 8.78357 32.5783 9.00217 32.7168C9.22077 32.8552 9.4749 32.9286 9.73439 32.9283Z"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M36.3145 16.6738H46.627"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M36.3145 26.7012H46.627"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M36.3145 21.6895H50.5645"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  // </svg>
);

export const Visa = () => (
  <img src={images["icon-2.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="58"
  //   height="42"
  //   viewBox="0 0 58 42"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <path
  //     d="M51.5798 2H6.42022C3.979 2 2 3.979 2 6.42022V35.9515C2 38.3927 3.979 40.3717 6.42022 40.3717H51.5798C54.021 40.3717 56 38.3927 56 35.9515V6.42022C56 3.979 54.021 2 51.5798 2Z"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M37.1675 15.491C36.587 15.2529 35.6825 15 34.5575 15C31.6775 15 29.645 16.5791 29.63 18.8418C29.612 20.5057 31.076 21.4421 32.1815 22C33.317 22.571 33.6965 22.9299 33.6935 23.4437C33.686 24.2219 32.786 24.5742 31.9505 24.5742C30.8015 24.5742 30.1715 24.3997 29.204 23.9625L28.8455 23.7814L28.439 26.3883C29.138 26.7064 30.398 26.9788 31.7015 27C34.763 27 36.764 25.4323 36.788 23.0212C36.812 21.6949 36.023 20.6884 34.3565 19.8597C33.3455 19.3214 32.7155 18.9608 32.7155 18.4144C32.7155 17.9315 33.254 17.416 34.379 17.416C35.3465 17.3997 36.023 17.6264 36.5615 17.8613L36.8315 17.9935L37.238 15.4747L37.1675 15.491ZM44.642 15.2137H42.392C41.6915 15.2137 41.168 15.4209 40.8605 16.1778L36.533 26.8369H39.5945L40.2065 25.0914L43.9415 25.0946C44.033 25.5024 44.3015 26.8369 44.3015 26.8369H47L44.642 15.2137ZM25.49 15.1158H28.4045L26.582 26.7455H23.666L25.49 15.1126V15.1158ZM18.0815 21.5253L18.3845 23.1403L21.236 15.2137H24.3245L19.733 26.8206H16.652L14.132 16.9902C14.0795 16.8222 14.015 16.708 13.862 16.6036C13.01 16.1191 12.0575 15.7243 11 15.4502L11.0375 15.2055H15.734C16.37 15.2316 16.883 15.4502 17.0585 16.1909L18.0815 21.5302V21.5253ZM41.0435 22.7113L42.206 19.4584C42.191 19.491 42.446 18.7863 42.593 18.3491L42.7925 19.3524L43.466 22.708H41.0435V22.7113Z"
  //     fill="#131635"
  //   />
  // </svg>
);

export const Passport = () => (
  <img src={images["icon-3.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="44"
  //   height="55"
  //   viewBox="0 0 44 55"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <path
  //     d="M29.2356 25.6641C30.5762 24.2463 31.4714 22.4676 31.8108 20.5477C32.1501 18.6279 31.9188 16.6508 31.1453 14.8607C30.3719 13.0705 29.0901 11.5456 27.4583 10.4743C25.8265 9.40294 23.9161 8.83203 21.9629 8.83203C20.0097 8.83203 18.0993 9.40294 16.4675 10.4743C14.8357 11.5456 13.5539 13.0705 12.7804 14.8607C12.007 16.6508 11.7756 18.6279 12.115 20.5477C12.4544 22.4676 13.3496 24.2463 14.6902 25.6641C15.6187 26.6633 16.7439 27.4604 17.9953 28.0056C19.2468 28.5507 20.5975 28.832 21.9629 28.832C23.3283 28.832 24.679 28.5507 25.9304 28.0056C27.1819 27.4604 28.3071 26.6633 29.2356 25.6641ZM28.846 12.9813C30.1466 14.4968 30.9047 16.4014 31.0005 18.3945H27.0447C27.0343 18.1508 27.0278 17.9071 27.0018 17.666C26.9876 17.5364 26.9603 17.4003 26.9421 17.2681C26.9044 17.0088 26.8668 16.7496 26.8122 16.4903C26.7785 16.3335 26.733 16.1779 26.6928 16.0224C26.633 15.7929 26.572 15.5635 26.498 15.3366C26.4447 15.1733 26.3837 15.0138 26.3226 14.8518C26.272 14.7222 26.2304 14.5796 26.1746 14.4448C26.2265 14.424 26.2733 14.3955 26.3239 14.3748C26.7422 14.2089 27.1503 14.0185 27.546 13.8044C27.5681 13.7928 27.5889 13.7785 27.6096 13.7668C27.9838 13.556 28.3458 13.3244 28.6941 13.0733C28.7421 13.0422 28.7967 13.0163 28.846 12.9813ZM28.1824 12.2878C27.8653 12.5248 27.5353 12.7442 27.1941 12.945C27.1512 12.9683 27.1135 12.9981 27.072 13.0215C26.6523 13.2395 26.2184 13.4292 25.7733 13.5892C25.6603 13.3702 25.5291 13.1615 25.4031 12.9502C25.3382 12.84 25.2733 12.7259 25.2109 12.6183C24.9654 12.2346 24.6979 11.8654 24.4096 11.5126C24.3473 11.4361 24.2798 11.3674 24.2122 11.2935C23.9772 11.0213 23.7356 10.7595 23.4772 10.5158C23.3629 10.4056 23.2421 10.3045 23.1226 10.1982C23.0031 10.0919 22.8551 9.93891 22.7109 9.83002C24.7626 9.99796 26.6938 10.8659 28.1798 12.2878H28.1824ZM17.807 18.3945C17.8161 18.1807 17.82 17.9655 17.8421 17.7542C17.8551 17.6362 17.8798 17.5196 17.8967 17.4029C17.9317 17.1566 17.9668 16.9116 18.02 16.6679C18.0499 16.5292 18.0915 16.3918 18.1265 16.2531C18.1837 16.034 18.2421 15.8149 18.3122 15.605C18.3603 15.4611 18.4174 15.3172 18.472 15.1746C18.5265 15.032 18.5811 14.8959 18.6395 14.7585C18.6798 14.7701 18.7213 14.774 18.7616 14.7857C19.2446 14.9263 19.7361 15.0362 20.233 15.115C20.285 15.1227 20.3369 15.1266 20.3889 15.1344C21.4339 15.2934 22.4971 15.2934 23.5421 15.1344C23.5954 15.1266 23.6473 15.1227 23.6993 15.115C24.1958 15.0364 24.6868 14.9264 25.1694 14.7857C25.2096 14.774 25.2512 14.7701 25.2915 14.7585C25.3499 14.8959 25.407 15.0346 25.459 15.1746C25.5109 15.3146 25.5707 15.4611 25.6187 15.605C25.6889 15.8214 25.7486 16.0405 25.8044 16.2531C25.8395 16.3918 25.8811 16.5292 25.9109 16.6679C25.9642 16.9116 25.9993 17.1566 26.0343 17.4029C26.0512 17.5196 26.0759 17.6362 26.0889 17.7542C26.1109 17.9655 26.1148 18.1807 26.1239 18.3945H17.807ZM26.1187 19.3136C26.1096 19.5275 26.1057 19.7414 26.0837 19.954C26.0707 20.0719 26.046 20.1899 26.0291 20.3079C25.9941 20.5529 25.959 20.7979 25.9057 21.0403C25.8759 21.1803 25.8343 21.3177 25.7993 21.4564C25.7421 21.6741 25.6837 21.8932 25.6135 22.1045C25.5655 22.2484 25.5083 22.3923 25.4538 22.5349C25.3993 22.6775 25.3447 22.8136 25.2863 22.951C25.2447 22.9393 25.2031 22.9354 25.1629 22.9238C24.6874 22.7842 24.2032 22.6759 23.7135 22.5997C23.6421 22.588 23.5707 22.5828 23.4993 22.5725C22.997 22.5024 22.4908 22.4651 21.9837 22.461H21.9356C21.4307 22.4651 20.9266 22.5024 20.4265 22.5725C20.3525 22.5815 20.2798 22.588 20.2057 22.5997C19.7179 22.6767 19.2355 22.7849 18.7616 22.9238C18.7187 22.9354 18.6759 22.9393 18.6317 22.951C18.5733 22.8136 18.5161 22.6749 18.4642 22.5349C18.4122 22.3949 18.3525 22.2484 18.3045 22.1045C18.2343 21.888 18.1746 21.669 18.1187 21.4564C18.0837 21.3177 18.0421 21.1803 18.0122 21.0403C17.959 20.7979 17.9239 20.5529 17.8889 20.3079C17.872 20.1899 17.8473 20.0719 17.8343 19.954C17.8122 19.7414 17.8083 19.5275 17.7993 19.3136H26.1187ZM22.872 11.2028C22.9694 11.2974 23.0577 11.4037 23.1512 11.5022C23.3369 11.698 23.5213 11.8911 23.6928 12.1024C23.7941 12.232 23.8863 12.3617 23.9824 12.4913C24.1304 12.6896 24.2772 12.8892 24.4109 13.0979C24.5019 13.2392 24.5863 13.387 24.6707 13.5335C24.7382 13.6502 24.8006 13.7707 24.8642 13.89C24.6044 13.9652 24.3369 14.0352 24.072 14.0896C23.9083 14.1233 23.7473 14.1687 23.5837 14.1946C22.5058 14.3631 21.4083 14.3631 20.3304 14.1946C20.1681 14.1687 20.007 14.1233 19.846 14.0896C19.5785 14.0352 19.3135 13.96 19.0486 13.89C19.1122 13.7694 19.1785 13.6489 19.2434 13.5309C19.3265 13.3857 19.4096 13.2405 19.5032 13.0992C19.6395 12.8892 19.7863 12.687 19.9356 12.4874C20.0304 12.3578 20.1213 12.2281 20.2213 12.1063C20.3941 11.8963 20.5811 11.698 20.7694 11.5009C20.8616 11.4037 20.9473 11.3 21.0434 11.208C21.3344 10.9233 21.6414 10.6554 21.9629 10.4056C22.2808 10.654 22.5843 10.9201 22.872 11.2028ZM21.2148 9.82483C21.0707 9.9402 20.9408 10.0711 20.8032 10.193C20.6655 10.3148 20.5629 10.4004 20.4486 10.5106C20.1889 10.7595 19.9486 11.0213 19.7135 11.2883C19.6499 11.3622 19.5837 11.4309 19.5161 11.5074C19.2281 11.8624 18.961 12.2337 18.7161 12.6196C18.6473 12.7272 18.5863 12.8413 18.5239 12.9515C18.3941 13.1628 18.2642 13.3715 18.1538 13.5905C17.7087 13.4304 17.2748 13.2408 16.8551 13.0228C16.8135 12.9994 16.7759 12.9696 16.733 12.9463C16.3918 12.7455 16.0618 12.5261 15.7447 12.2891C17.2301 10.8645 19.1619 9.99427 21.2148 9.82483ZM15.0798 12.9813C15.1265 13.0163 15.1811 13.0422 15.2291 13.0772C15.5774 13.3283 15.9394 13.5599 16.3135 13.7707C16.3343 13.7824 16.3551 13.7966 16.3772 13.8083C16.7729 14.0224 17.181 14.2128 17.5993 14.3787C17.6499 14.3994 17.6967 14.4279 17.7486 14.4487C17.6915 14.5783 17.6512 14.7209 17.6006 14.857C17.5395 15.0177 17.4785 15.1772 17.4252 15.3392C17.3512 15.5674 17.2954 15.7968 17.2304 16.0275C17.1902 16.1831 17.1447 16.3374 17.1109 16.4942C17.0564 16.7535 17.0174 17.0127 16.9811 17.272C16.9616 17.4016 16.9356 17.5312 16.9213 17.6609C16.8954 17.9033 16.8889 18.147 16.8785 18.3907H12.9278C13.0238 16.3991 13.7809 14.4961 15.0798 12.9813ZM15.0798 24.7269C13.7793 23.2113 13.0213 21.3068 12.9252 19.3136H16.8785C16.8889 19.5573 16.8954 19.801 16.9213 20.0434C16.9356 20.173 16.9616 20.3027 16.9811 20.4323C17.0174 20.6916 17.0564 20.9508 17.1109 21.2101C17.1447 21.3656 17.1902 21.5199 17.2304 21.6741C17.2902 21.9049 17.3512 22.1356 17.4252 22.3638C17.4785 22.5258 17.5395 22.6852 17.6006 22.846C17.6512 22.9821 17.6915 23.1195 17.7486 23.2543C17.6967 23.275 17.6499 23.3036 17.5993 23.3243C17.1811 23.4904 16.773 23.6808 16.3772 23.8947C16.3551 23.9063 16.3356 23.9206 16.3135 23.9323C15.94 24.143 15.5785 24.3741 15.2304 24.6245C15.1837 24.6647 15.1304 24.6906 15.0798 24.7269ZM15.7434 25.4204C16.0592 25.1861 16.3878 24.9698 16.7278 24.7723C16.772 24.7476 16.8109 24.7152 16.8577 24.6919C17.2772 24.4735 17.7111 24.2839 18.1564 24.1241C18.2694 24.3445 18.4019 24.5545 18.5278 24.7723C18.5928 24.8811 18.6499 24.9939 18.7174 25.1002C18.9634 25.4851 19.2318 25.8551 19.5213 26.2085C19.5811 26.2824 19.6512 26.3485 19.7122 26.4211C19.9486 26.6946 20.1928 26.9591 20.4525 27.2093C20.5681 27.3207 20.6902 27.4232 20.8096 27.5281C20.9291 27.6331 21.0772 27.7809 21.22 27.8963C19.1642 27.7245 17.2308 26.85 15.746 25.4204H15.7434ZM21.0447 26.5041C20.9486 26.4108 20.8616 26.3071 20.7694 26.2111C20.5824 26.0141 20.3954 25.8222 20.2239 25.6058C20.1226 25.4761 20.0304 25.3465 19.9356 25.2169C19.7863 25.0185 19.6408 24.8176 19.5057 24.6089C19.4135 24.4663 19.3304 24.3186 19.246 24.1721C19.1785 24.0567 19.1161 23.9362 19.0538 23.8182C19.3135 23.743 19.5798 23.6717 19.846 23.6173C20.0096 23.5849 20.172 23.5382 20.3382 23.5123C21.414 23.3452 22.5092 23.3452 23.585 23.5123C23.7499 23.5382 23.9135 23.5849 24.0772 23.6186C24.3369 23.673 24.6057 23.7482 24.8681 23.8182C24.8044 23.9362 24.7382 24.0554 24.6759 24.1708C24.5915 24.3186 24.507 24.4663 24.4161 24.6089C24.2863 24.8176 24.1356 25.0185 23.9863 25.2169C23.8915 25.3465 23.7993 25.4761 23.698 25.6058C23.5265 25.8158 23.3408 26.0128 23.1538 26.2085C23.0603 26.3071 22.9733 26.4108 22.8772 26.5041C22.5898 26.7871 22.2863 27.0533 21.9681 27.3013C21.6481 27.0534 21.3429 26.7873 21.0538 26.5041H21.0447ZM22.707 27.8846C22.8499 27.7693 22.9798 27.6396 23.1174 27.5178C23.2551 27.3959 23.359 27.3078 23.4746 27.1963C23.7343 26.9487 23.9759 26.6856 24.2096 26.4185C24.2746 26.3433 24.3395 26.2759 24.407 26.1995C24.6956 25.8468 24.9631 25.4776 25.2083 25.0937C25.2772 24.9861 25.3382 24.8721 25.4006 24.7619C25.5304 24.5506 25.6603 24.3432 25.7707 24.1228C26.2155 24.2832 26.6493 24.4724 27.0694 24.6893C27.1135 24.7139 27.1525 24.745 27.1993 24.7697C27.5397 24.9672 27.8688 25.1836 28.185 25.4178C26.6986 26.8444 24.7647 27.7156 22.7096 27.8846H22.707ZM28.6915 24.631C28.3413 24.3781 27.9771 24.1453 27.6005 23.9336C27.5824 23.9232 27.5642 23.9102 27.5447 23.8999C27.1476 23.6856 26.7382 23.4947 26.3187 23.3282C26.2694 23.3075 26.2226 23.2789 26.172 23.2595C26.2278 23.1299 26.2694 22.9873 26.32 22.8525C26.3811 22.6917 26.4421 22.531 26.4954 22.3689C26.5694 22.1408 26.6252 21.9101 26.6902 21.6806C26.7304 21.5251 26.7759 21.3708 26.8096 21.2153C26.8642 20.956 26.9031 20.6967 26.9395 20.4375C26.959 20.3079 26.985 20.1782 26.9993 20.0486C27.0252 19.8075 27.0317 19.5638 27.0421 19.3201H30.9954C30.8993 21.3104 30.1432 23.2123 28.846 24.7269C28.7954 24.6906 28.7421 24.6647 28.6941 24.631H28.6915Z"
  //     fill="#131635"
  //   />
  //   <rect
  //     x="1.87695"
  //     y="1.76953"
  //     width="40"
  //     height="51"
  //     rx="4.5"
  //     stroke="#131635"
  //     stroke-width="3"
  //   />
  //   <path
  //     d="M13.5872 41.2878C13.6131 40.7045 13.4411 40.1295 13.0988 39.655C12.7995 39.2534 12.3717 38.9649 11.8856 38.8368C11.2172 38.7265 10.5392 38.6843 9.86219 38.7108H7.13281V47.085H8.83631V43.9268H9.94737C10.5379 43.9407 11.1284 43.9004 11.7114 43.8064C12.0291 43.7338 12.329 43.5989 12.5935 43.4095C12.8949 43.195 13.1402 42.9119 13.3089 42.5838C13.507 42.1809 13.6026 41.7359 13.5872 41.2878ZM11.6414 41.9612C11.5108 42.1494 11.3251 42.2932 11.1095 42.3731C10.671 42.4851 10.2178 42.5295 9.76566 42.5048H8.83252V40.1272H9.65588C10.065 40.1162 10.4743 40.1357 10.8805 40.1855C11.1447 40.23 11.3857 40.3627 11.5638 40.5617C11.7472 40.7691 11.844 41.0382 11.8345 41.3141C11.838 41.5443 11.7707 41.7701 11.6414 41.9612Z"
  //     fill="#131635"
  //   />
  //   <path
  //     d="M16.536 38.7109L13.2539 47.0852H15.0577L15.7618 45.1835H19.1291L19.8654 47.0852H21.7165L18.3417 38.7109H16.536ZM16.2767 43.7727L17.4123 40.6653L18.5745 43.7727H16.2767Z"
  //     fill="#131635"
  //   />
  //   <path
  //     d="M27.7635 42.4597C27.177 42.1886 26.5609 41.986 25.9275 41.8559C25.3754 41.7665 24.8451 41.5751 24.3641 41.2916C24.2859 41.2316 24.2226 41.1546 24.179 41.0666C24.1353 40.9786 24.1125 40.8818 24.1123 40.7837C24.1097 40.6814 24.1329 40.5801 24.1799 40.4891C24.2268 40.3981 24.296 40.3202 24.3811 40.2626C24.7262 40.0429 25.1322 39.9369 25.5414 39.9598C25.9225 39.933 26.3018 40.0322 26.6203 40.242C26.8869 40.4834 27.0541 40.8144 27.0897 41.1712L28.7932 41.0978C28.7946 40.7481 28.7201 40.4022 28.5748 40.0838C28.4294 39.7653 28.2166 39.4818 27.9509 39.2525C27.2651 38.7436 26.4176 38.4978 25.5641 38.5603C24.9973 38.5458 24.4334 38.6449 23.906 38.8519C23.477 39.0224 23.11 39.3182 22.8536 39.7002C22.6154 40.0543 22.4883 40.4706 22.4883 40.8965C22.4835 41.2182 22.5506 41.537 22.6848 41.8297C22.819 42.1225 23.017 42.382 23.2644 42.5894C23.8318 43.008 24.4885 43.2912 25.1836 43.4171C25.8934 43.5939 26.3458 43.7143 26.5464 43.7933C26.7775 43.8607 26.9878 43.9849 27.1578 44.1544C27.2758 44.2966 27.3383 44.4762 27.3338 44.6604C27.3311 44.8179 27.2921 44.9726 27.2199 45.1128C27.1478 45.253 27.0443 45.3749 26.9174 45.4693C26.5576 45.7251 26.1189 45.8476 25.6776 45.8154C25.2329 45.8389 24.7948 45.7005 24.4455 45.426C24.1066 45.103 23.8917 44.6726 23.8379 44.209L22.1836 44.3708C22.2364 45.1874 22.6022 45.9528 23.2057 46.5095C23.9095 47.042 24.7838 47.3027 25.6663 47.2431C26.2918 47.2617 26.915 47.1581 27.5004 46.9383C27.9684 46.7503 28.3655 46.4214 28.6361 45.9978C28.8994 45.5967 29.0395 45.1281 29.0392 44.6492C29.0545 44.1821 28.9377 43.7201 28.7023 43.3155C28.474 42.9503 28.1493 42.6543 27.7635 42.4597Z"
  //     fill="#131635"
  //   />
  //   <path
  //     d="M35.6169 42.4596C35.0304 42.1886 34.4143 41.986 33.7809 41.8558C33.2283 41.7664 32.6974 41.575 32.2156 41.2915C32.1377 41.2313 32.0746 41.1543 32.031 41.0663C31.9874 40.9784 31.9645 40.8817 31.9638 40.7837C31.961 40.6812 31.9844 40.5797 32.0317 40.4885C32.0791 40.3974 32.1488 40.3197 32.2345 40.2626C32.5796 40.0429 32.9856 39.9369 33.3948 39.9598C33.7753 39.933 34.154 40.0322 34.4718 40.2419C34.7397 40.4824 34.9072 40.8139 34.9412 41.1712L36.6447 41.0978C36.6461 40.7481 36.5716 40.4022 36.4263 40.0838C36.2809 39.7653 36.0681 39.4818 35.8024 39.2525C35.1159 38.7436 34.2678 38.4979 33.4137 38.5603C32.8469 38.5459 32.283 38.6451 31.7556 38.8519C31.3272 39.0234 30.9605 39.319 30.7032 39.7002C30.4072 40.1481 30.2858 40.688 30.3617 41.2185C30.4377 41.7491 30.7058 42.2339 31.1159 42.5819C31.6833 43.0005 32.34 43.2837 33.0351 43.4096C33.7449 43.5864 34.1973 43.7068 34.3979 43.7858C34.629 43.8532 34.8393 43.9774 35.0093 44.1469C35.1273 44.289 35.1898 44.4687 35.1853 44.6529C35.1826 44.8103 35.1436 44.9651 35.0714 45.1053C34.9993 45.2455 34.8958 45.3674 34.7689 45.4617C34.4091 45.7176 33.9704 45.84 33.5292 45.8078C33.0844 45.8317 32.6462 45.6932 32.297 45.4185C31.9575 45.0959 31.7425 44.6653 31.6894 44.2015L30.0332 44.3632C30.0869 45.1785 30.4527 45.9424 31.0553 46.4982C31.7591 47.0307 32.6334 47.2914 33.5159 47.2318C34.1408 47.2502 34.7633 47.1467 35.3481 46.927C35.8163 46.7392 36.2134 46.4103 36.4838 45.9865C36.7465 45.5853 36.886 45.1166 36.885 44.6379C36.9009 44.1709 36.7848 43.709 36.55 43.3042C36.3212 42.9443 35.9988 42.6526 35.6169 42.4596Z"
  //     fill="#131635"
  //   />
  // </svg>
);

export const LabourCard = () => (
  <img src={images["icon-4.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="58"
  //   height="47"
  //   viewBox="0 0 58 47"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <path
  //     d="M23.9777 35.8633H13.1777"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M18.5777 27.8008H13.1777"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M34.7773 31.832C34.7773 29.2983 34.7773 28.0314 35.5682 27.2442C36.359 26.457 37.6318 26.457 40.1773 26.457C42.7229 26.457 43.9957 26.457 44.7865 27.2442C45.5773 28.0314 45.5773 29.2983 45.5773 31.832C45.5773 34.3658 45.5773 35.6327 44.7865 36.4199C43.9957 37.207 42.7229 37.207 40.1773 37.207C37.6318 37.207 36.359 37.207 35.5682 36.4199C34.7773 35.6327 34.7773 34.3658 34.7773 31.832Z"
  //     stroke="#131635"
  //     stroke-width="3"
  //   />
  //   <path
  //     d="M56.377 23.7695C56.377 13.6343 56.377 8.56675 53.2136 5.41813C50.0506 2.26953 44.9592 2.26953 34.777 2.26953H23.977C13.7946 2.26953 8.70346 2.26953 5.54019 5.41813C2.37695 8.56675 2.37695 13.6343 2.37695 23.7695C2.37695 33.9046 2.37695 38.9724 5.54019 42.1209C8.70346 45.2695 13.7946 45.2695 23.977 45.2695H34.777C44.9592 45.2695 50.0506 45.2695 53.2136 42.1209C54.9773 40.3654 55.7576 38.0135 56.1029 34.5195"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M2.37695 18.3945H15.877M56.377 18.3945H26.677"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  // </svg>
);

export const DrivingLicense = () => (
  <img src={images["icon-5.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="55"
  //   height="40"
  //   viewBox="0 0 55 40"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <rect
  //     x="1.87695"
  //     y="1.76953"
  //     width="51"
  //     height="36"
  //     rx="4.5"
  //     stroke="#131635"
  //     stroke-width="3"
  //   />
  //   <mask id="path-2-inside-1_3_1348" fill="white">
  //     <rect x="35.377" y="7.26953" width="12" height="12" rx="1" />
  //   </mask>
  //   <rect
  //     x="35.377"
  //     y="7.26953"
  //     width="12"
  //     height="12"
  //     rx="1"
  //     stroke="#131635"
  //     stroke-width="4"
  //     mask="url(#path-2-inside-1_3_1348)"
  //   />
  //   <path
  //     d="M26.0055 24.6484H7.35095C6.80821 24.6484 6.36914 25.085 6.36914 25.6234C6.36914 26.1619 6.80821 26.5984 7.35095 26.5984H26.0055C26.5482 26.5984 26.9873 26.1619 26.9873 25.6234C26.9873 25.085 26.5482 24.6484 26.0055 24.6484Z"
  //     fill="#131635"
  //   />
  //   <path
  //     d="M26.0055 29.5156H7.35095C6.80821 29.5156 6.36914 29.9522 6.36914 30.4906C6.36914 31.0291 6.80821 31.4656 7.35095 31.4656H26.0055C26.5482 31.4656 26.9873 31.0291 26.9873 30.4906C26.9873 29.9522 26.5482 29.5156 26.0055 29.5156Z"
  //     fill="#131635"
  //   />
  //   <circle
  //     cx="15.877"
  //     cy="12.5859"
  //     r="3.5"
  //     stroke="#131635"
  //     stroke-width="2"
  //   />
  // </svg>
);

export const InsurancePolicy = () => (
  <img src={images["icon-6.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="50"
  //   height="58"
  //   viewBox="0 0 50 58"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <path
  //     d="M41.377 56.2695H8.37695C5.06324 56.2695 2.37695 53.5832 2.37695 50.2695V8.26953C2.37695 4.95582 5.06324 2.26953 8.37695 2.26953H35.377C38.6907 2.26953 41.377 4.95582 41.377 8.26953V17.7695"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M18.377 15.2695H28.377M23.377 10.2695V20.2695"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M10.377 31.2695H20.377"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M10.377 36.2695H20.377"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M10.377 41.2695H20.377"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M34.877 26.2695C34.877 25.9934 35.1008 25.7695 35.377 25.7695H47.377C47.6531 25.7695 47.877 25.9934 47.877 26.2695V43.5816C47.877 43.744 47.7981 43.8962 47.6655 43.9899L41.6655 48.2291C41.4925 48.3513 41.2614 48.3513 41.0884 48.2291L35.0884 43.9899L34.2229 45.215L35.0884 43.9899C34.9558 43.8962 34.877 43.744 34.877 43.5816V26.2695Z"
  //     stroke="#131635"
  //     stroke-width="3"
  //   />
  // </svg>
);

export const InsuranceCard = () => (
  <img src={images["icon-7.png"]} alt="" />
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="58"
  //   height="47"
  //   viewBox="0 0 58 47"
  //   fill="none"
  //   className="svg-icon-main"
  // >
  //   <path
  //     d="M23.9777 34.8633H13.1777"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M18.5777 27.8008H13.1777"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M34.377 31.2695H44.377M39.377 26.2695V36.2695"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //     stroke-linejoin="round"
  //   />
  //   <path
  //     d="M56.377 23.7695C56.377 13.6343 56.377 8.56675 53.2136 5.41813C50.0506 2.26953 44.9592 2.26953 34.777 2.26953H23.977C13.7946 2.26953 8.70346 2.26953 5.54019 5.41813C2.37695 8.56675 2.37695 13.6343 2.37695 23.7695C2.37695 33.9046 2.37695 38.9724 5.54019 42.1209C8.70346 45.2695 13.7946 45.2695 23.977 45.2695H34.777C44.9592 45.2695 50.0506 45.2695 53.2136 42.1209C54.9773 40.3654 55.7576 38.0135 56.1029 34.5195"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  //   <path
  //     d="M2.37695 18.3945H26.677H56.377"
  //     stroke="#131635"
  //     stroke-width="3"
  //     stroke-linecap="round"
  //   />
  // </svg>
);

export const Tradelicense = () => (
  <img src={images["Tradelicense.png"]} alt="" />
);

export const VATcertificate = () => (
  <img src={images["VATcertificate.png"]} alt="" />
);

export const Corporatecertificate = () => (
  <img src={images["Corporatecertificate.png"]} alt="" />
);

export const Ejari = () => <img src={images["VATcertificate.png"]} alt="" />;

export const Tenancycontract = () => (
  <img src={images["Tenancycontract.png"]} alt="" />
);

export const Establishmentcard = () => (
  <img src={images["VATcertificate.png"]} alt="" />
);

export const Letterhead = () => <img src={images["Letterhead.png"]} alt="" />;

export const Projectagreement = () => (
  <img src={images["Projectagreement.png"]} alt="" />
);

export const Projectinsurance = () => (
  <img src={images["Projectinsurance.png"]} alt="" />
);

export const PdfRed = () => <img src={images["pdf_red.png"]} alt="" />;

export const PdfGreen = () => <img src={images["pdf_green.png"]} alt="" />;

export const PdfIcon = () => <img src={images["pdf-new.png"]} alt="" />;
export const DwgIcon = () => <img src={images["dwg.png"]} alt="" />;
export const DwgPulse = () => <img src={images["icon-pluse.png"]} alt="" />;

export const IconRightGreen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <circle cx="13" cy="13.9531" r="13" fill="#0DB73A" />
    <path
      d="M19 9.95312L10.75 17.9531L7 14.3168"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconDocumet = () => (
  <svg
    width="21"
    height="26"
    viewBox="0 0 21 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3142 0.574219L20.9546 4.22611L20.9405 4.23954L17.3451 4.24225L17.3115 0.576931L17.3142 0.574219Z"
      fill="#F1F1F1"
    />
    <path
      d="M7.54001 6.33866C7.54001 7.03155 7.15295 7.35883 6.55885 7.35415C6.47756 7.35415 6.38677 7.35415 6.33105 7.34139V5.44416C6.38677 5.43141 6.48157 5.41797 6.62807 5.41797C7.19122 5.41803 7.54408 5.73656 7.54001 6.33866Z"
      fill="#F1F1F1"
    />
    <path
      d="M4.60618 5.83556C4.60618 6.13257 4.39108 6.30934 4.04303 6.30934C3.94824 6.30934 3.87902 6.30465 3.82324 6.2919V5.43567C3.87095 5.42291 3.961 5.41016 4.09406 5.41016C4.42134 5.41016 4.60618 5.56874 4.60618 5.83556Z"
      fill="#F1F1F1"
    />
    <path
      d="M2.41939 3.125H13.7097V9.6438H2.41939H2.39184H0V3.125H2.39178H2.41939Z"
      fill="#F1F1F1"
    />
    <path
      d="M12.0052 13.0085C12.0133 13.6852 11.5805 15.0057 11.5805 15.0057C11.4312 14.8485 11.1328 14.0071 11.1328 13.2288C11.1328 12.4506 11.3842 12.2383 11.5805 12.2383C11.7773 12.2383 11.997 12.3324 12.0052 13.0085Z"
      fill="#DC1D00"
    />
    <path
      d="M16.7172 18.9118C16.7172 19.8056 15.0976 19.4413 14.1016 18.4931C14.1016 18.4931 16.7172 18.0186 16.7172 18.9118Z"
      fill="#DC1D00"
    />
    <path
      d="M7.31832 21.8523C6.51658 21.3725 9.00112 19.8946 9.44938 19.8477C9.44938 19.8477 8.15771 22.3543 7.31832 21.8523Z"
      fill="#DC1D00"
    />
    <path
      d="M11.9586 16.4766C12.4143 17.3254 13.3188 18.324 13.3188 18.324C13.3188 18.324 12.9726 18.3631 12.1683 18.5599C11.3638 18.7568 10.96 18.9612 10.96 18.9612C10.96 18.9612 10.96 18.9612 11.29 18.2219C11.6206 17.4826 11.9586 16.4766 11.9586 16.4766Z"
      fill="#DC1D00"
    />
    <path
      d="M20.9673 4.23896V25.5703H2.41895V9.64287H13.7092V3.12406H2.41895V0.570312H17.3108L17.3134 0.573641L17.3108 0.576291L17.3443 4.24162L20.9398 4.2389L20.9539 4.22547L20.9673 4.23896Z"
      fill="#DC1D00"
    />
    <path
      d="M9.44995 19.8475C9.00175 19.8946 6.51715 21.3724 7.31889 21.8522C8.15828 22.3542 9.44995 19.8475 9.44995 19.8475ZM14.1018 18.49C15.0977 19.4382 16.7174 19.8025 16.7174 18.9087C16.7174 18.0155 14.1018 18.49 14.1018 18.49ZM13.3182 18.322C13.3182 18.322 12.4136 17.3234 11.958 16.4745C11.958 16.4745 11.62 17.4805 11.2893 18.2198C10.9593 18.959 10.9593 18.959 10.9593 18.959C10.9593 18.959 11.3632 18.7547 12.1676 18.5578C12.972 18.361 13.3182 18.322 13.3182 18.322ZM11.5803 15.0041C11.5803 15.0041 12.0131 13.6836 12.0051 13.0068C11.9969 12.3307 11.7773 12.2366 11.5803 12.2366C11.3841 12.2366 11.1327 12.449 11.1327 13.2272C11.1327 14.0054 11.4311 14.8469 11.5803 15.0041ZM12.1233 16.0263C12.5636 16.9778 13.7746 18.2037 13.7746 18.2037C13.7746 18.2037 14.1671 18.1016 15.7867 18.0626C17.4069 18.0236 17.4776 18.9349 17.4849 19.0135C17.493 19.0928 17.5562 19.816 16.2665 19.8629C14.9776 19.91 13.6402 18.5659 13.6402 18.5659C13.6402 18.5659 13.0904 18.6526 12.6348 18.7622C12.1791 18.8724 10.7161 19.2736 10.7161 19.2736C10.7161 19.2736 10.2833 20.0599 9.32428 21.3173C8.36464 22.5753 7.29004 22.4813 6.98354 22.0645C6.62735 21.5807 6.90224 21.0976 7.57831 20.4684C8.25437 19.8395 9.81421 19.3179 9.81421 19.3179C9.81421 19.3179 10.1287 18.752 10.5898 17.6721C11.0507 16.5921 11.3996 15.5074 11.3996 15.5074C11.3996 15.5074 10.9432 14.4712 10.8545 13.5894C10.7551 12.6063 10.8653 11.9457 11.62 11.9376C12.3747 11.9295 12.6106 12.4961 12.6341 13.4785C12.6576 14.4618 12.1233 16.0263 12.1233 16.0263Z"
      fill="white"
    />
    <path
      d="M10.3908 5.4883V4.93359H8.66504V7.8304H9.28138V6.65935H10.3292V6.16628H9.28138V5.4883H10.3908Z"
      fill="#A51600"
    />
    <path
      d="M7.74589 5.2239C7.46631 5.01286 7.09577 4.91406 6.5447 4.91406C6.21341 4.91406 5.89107 4.93557 5.64453 4.97453V7.82264C5.82943 7.84415 6.06284 7.8656 6.40288 7.8656C6.97078 7.8656 7.44271 7.74529 7.7478 7.4913C8.02737 7.25474 8.23311 6.87163 8.23311 6.31655C8.23311 5.80523 8.04765 5.44769 7.74589 5.2239ZM6.52356 7.35361C6.44226 7.35361 6.38414 7.35361 6.26087 7.34085V5.44362C6.38414 5.43087 6.44627 5.41743 6.59284 5.41743C7.15599 5.41743 7.50878 5.73595 7.50471 6.33812C7.50471 7.03101 7.11759 7.35829 6.52356 7.35361Z"
      fill="#A51600"
    />
    <path
      d="M4.94549 5.14655C4.75196 4.99129 4.43646 4.91406 4.03183 4.91406C3.63195 4.91406 3.30307 4.94026 3.11816 4.97453V7.8317H3.79614V6.7984C3.85777 6.80716 3.94708 6.81184 4.03318 6.81184C4.42025 6.81184 4.75813 6.71705 4.98198 6.50607C5.154 6.3428 5.252 6.10151 5.252 5.81793C5.252 5.53367 5.13027 5.29305 4.94549 5.14655ZM4.02906 6.30854C3.93432 6.30854 3.85777 6.30385 3.79614 6.29109V5.43487C3.85777 5.42211 3.94708 5.40935 4.08009 5.40935C4.40743 5.40935 4.59221 5.56794 4.59221 5.83475C4.59221 6.13177 4.37717 6.30854 4.02906 6.30854Z"
      fill="#A51600"
    />
  </svg>
);

export const IconExplanation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <circle cx="13.6992" cy="13.6016" r="13" fill="#F3C619" />
    <path
      d="M15.4961 21.544C15.4961 21.893 15.3908 22.2342 15.1936 22.5244C14.9964 22.8145 14.716 23.0407 14.3881 23.1743C14.0601 23.3078 13.6992 23.3428 13.351 23.2747C13.0028 23.2066 12.683 23.0385 12.432 22.7918C12.1809 22.545 12.01 22.2306 11.9407 21.8883C11.8715 21.546 11.907 21.1912 12.0429 20.8688C12.1787 20.5463 12.4088 20.2707 12.704 20.0769C12.9991 19.883 13.3462 19.7795 13.7012 19.7795C14.1772 19.7795 14.6338 19.9654 14.9704 20.2963C15.307 20.6272 15.4961 21.076 15.4961 21.544ZM13.7012 17.1326C13.9392 17.1326 14.1675 17.0397 14.3358 16.8742C14.5041 16.7088 14.5986 16.4843 14.5986 16.2504V4.78072C14.5986 4.54672 14.5041 4.32231 14.3358 4.15685C14.1675 3.99139 13.9392 3.89844 13.7012 3.89844C13.4632 3.89844 13.2349 3.99139 13.0666 4.15685C12.8983 4.32231 12.8037 4.54672 12.8037 4.78072V16.2504C12.8037 16.4843 12.8983 16.7088 13.0666 16.8742C13.2349 17.0397 13.4632 17.1326 13.7012 17.1326Z"
      fill="white"
    />
  </svg>
);

export const IconRedMinus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <circle cx="13" cy="13.3672" r="13" fill="#E75050" />
    <path
      d="M6 12.9531H20.5"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconCloseRed = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
  >
    <circle cx="13" cy="13.9531" r="13" fill="#E75050" />
    <path
      d="M8 8.95312L18 18.9531M8 18.9531L18 8.95312"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconApprovals = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M4.9668 6.56836H16.4906"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.9668 11.2656H14.1858"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.9668 15.9551H10.7287"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.3618 10.0823V2.86328C19.3618 2.311 18.9141 1.86328 18.3618 1.86328H2.5C1.94772 1.86328 1.5 2.311 1.5 2.86328V20.2368C1.5 20.7891 1.94772 21.2368 2.5 21.2368H10.1428"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.3152 24.2776C16.4222 24.2776 14.0771 21.8882 14.0771 18.9406C14.0771 15.9929 16.4222 13.6035 19.3152 13.6035C22.2082 13.6035 24.5533 15.9929 24.5533 18.9406C24.5533 21.8882 22.2082 24.2776 19.3152 24.2776ZM19.8391 18.9406V16.272H18.7914V20.008H21.9343V18.9406H19.8391Z"
      fill="#01265D"
    />
  </svg>
);

export const IconMail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
  >
    <circle cx="20" cy="20.9727" r="20" fill="#F1F7FF" />
    <path
      d="M29 15.0179V26.6083C29 27.3612 28.3898 27.972 27.6369 27.972H24.454V20.2453L18.9997 24.337L13.5454 20.2453V27.9727H10.3631C9.61018 27.9727 9 27.3625 9 26.6096V26.609V15.0185C9 13.8889 9.91561 12.9727 11.0453 12.9727C11.5081 12.9727 11.9349 13.1267 12.2776 13.3854L12.2723 13.3814L18.9997 18.4274L25.727 13.3814C26.0645 13.126 26.4912 12.9727 26.9541 12.9727C28.0837 12.9727 29 13.8882 29 15.0179Z"
      fill="#131635"
    />
  </svg>
);

export const IconPhone = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <circle cx="20.5493" cy="20.9727" r="20" fill="#F1F7FF" />
    <path
      d="M23.8818 12.083V13.1941C23.8818 15.2892 23.8818 16.3368 24.5327 16.9877C25.1836 17.6386 26.2312 17.6386 28.3263 17.6386H29.9929M29.9929 17.6386L27.2152 15.4163M29.9929 17.6386L27.2152 19.8608"
      stroke="#131635"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24.5006 23.8034L23.9945 24.3362C23.9945 24.3362 22.7916 25.6026 19.5083 22.1459C16.225 18.6891 17.4279 17.4227 17.4279 17.4227L17.7466 17.0872C18.5316 16.2607 18.6056 14.9337 17.9207 13.965L16.5196 11.9833C15.6718 10.7843 14.0337 10.6259 13.062 11.6489L11.318 13.485C10.8362 13.9923 10.5134 14.6498 10.5525 15.3793C10.6527 17.2454 11.4501 21.2604 15.8997 25.9451C20.6183 30.9129 25.0457 31.1103 26.8563 30.9316C27.429 30.8751 27.927 30.5663 28.3283 30.1437L29.9067 28.482C30.9722 27.3603 30.6717 25.4373 29.3085 24.6526L27.1857 23.4308C26.2906 22.9155 25.2002 23.0669 24.5006 23.8034Z"
      fill="#131635"
    />
  </svg>
);

export const IconWhatsApp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
  >
    <circle cx="20.3213" cy="20.9727" r="20" fill="#F1F7FF" />
    <path
      d="M11.1091 30.3775C11.1822 30.0997 11.2519 29.8351 11.3216 29.5705C11.5754 28.6057 11.8295 27.6409 12.0808 26.6753C12.0891 26.6429 12.075 26.5958 12.0548 26.5668C11.6384 25.9639 11.3023 25.3187 11.0305 24.6394C10.852 24.1933 10.7046 23.7364 10.5982 23.2676C10.5285 22.9602 10.4692 22.65 10.4147 22.3395C10.3878 22.1861 10.3854 22.0284 10.3664 21.8732C10.316 21.4625 10.32 21.0496 10.3227 20.6374C10.3242 20.4339 10.349 20.2303 10.3667 20.0274C10.4151 19.4731 10.5138 18.9273 10.6566 18.3898C11.0577 16.8783 11.7671 15.5282 12.8094 14.3611C14.2642 12.7323 16.0718 11.6958 18.1977 11.212C18.494 11.1445 18.7961 11.1017 19.0972 11.0598C19.3211 11.0286 19.5473 11.0115 19.773 10.9981C20.0258 10.9831 20.2796 10.9703 20.5328 10.973C20.7859 10.9758 21.0394 10.9908 21.2913 11.0137C22.4416 11.1188 23.5417 11.4137 24.5883 11.9029C25.4413 12.3017 26.221 12.8133 26.9261 13.4379C27.9274 14.3251 28.712 15.3763 29.2987 16.5764C29.6824 17.3605 29.9616 18.181 30.1307 19.0373C30.1793 19.2833 30.2132 19.5327 30.2426 19.7817C30.271 20.021 30.293 20.2618 30.3031 20.5023C30.3163 20.8165 30.3282 21.1318 30.3166 21.4457C30.2995 21.9093 30.2508 22.3707 30.1643 22.8276C29.8751 24.354 29.2724 25.7429 28.3344 26.9836C27.6006 27.9542 26.7087 28.7505 25.6826 29.4036C24.943 29.8745 24.166 30.262 23.3267 30.5169C22.9877 30.6199 22.6437 30.7091 22.2973 30.7833C22.0206 30.8426 21.7374 30.8747 21.4558 30.9089C21.2556 30.9334 21.0538 30.9484 20.8523 30.9557C20.5554 30.9664 20.2576 30.9808 19.9613 30.967C19.6381 30.952 19.3155 30.9151 18.9945 30.8732C18.3338 30.7873 17.6895 30.6278 17.0606 30.4075C16.469 30.2 15.9049 29.9341 15.3652 29.6151C15.2365 29.539 15.1001 29.4748 14.9653 29.41C14.939 29.3975 14.9005 29.3981 14.8711 29.4054C13.7689 29.689 12.6669 29.9738 11.5647 30.2589C11.4179 30.2975 11.2709 30.3357 11.1091 30.3775ZM23.5631 26.5674C23.7401 26.5579 23.9193 26.5625 24.0936 26.5362C24.4761 26.4785 24.8112 26.2918 25.1503 26.1194C25.1967 26.0959 25.2362 26.0568 25.2765 26.0219C25.4056 25.9107 25.5334 25.7985 25.6612 25.6864C25.8449 25.525 26.0299 25.3649 26.1384 25.1385C26.2568 24.8912 26.3149 24.6254 26.3595 24.3586C26.3861 24.1997 26.3739 24.0346 26.3837 23.8727C26.3873 23.8116 26.3693 23.7688 26.3155 23.7422C26.1473 23.6588 25.9804 23.5726 25.8101 23.4941C25.1347 23.182 24.4583 22.8716 23.7814 22.5635C23.6631 22.5097 23.5423 22.455 23.4041 22.4942C23.2674 22.533 23.1283 22.562 23.0295 22.6794C22.9296 22.7979 22.8229 22.9107 22.7213 23.028C22.5003 23.2835 22.2777 23.5378 22.0618 23.7978C21.9732 23.9048 21.7503 23.9748 21.6136 23.9026C21.5265 23.8568 21.4445 23.7987 21.354 23.7624C20.7615 23.5237 20.2013 23.227 19.6953 22.8364C19.4825 22.672 19.2954 22.4749 19.0844 22.3074C18.6138 21.934 18.2188 21.4903 17.8669 21.0087C17.6892 20.7654 17.541 20.5005 17.3841 20.2423C17.3428 20.1741 17.3003 20.0974 17.2918 20.021C17.2786 19.903 17.3043 19.7878 17.3847 19.687C17.6201 19.3915 17.9106 19.1397 18.0922 18.8014C18.0959 18.7947 18.1014 18.7892 18.1063 18.7834C18.3053 18.5407 18.3668 18.269 18.2567 17.9726C18.1338 17.642 18.0066 17.3125 17.8672 16.9886C17.6663 16.5226 17.4605 16.0581 17.241 15.6003C17.13 15.369 16.927 15.2464 16.6644 15.2422C16.4785 15.2391 16.2923 15.2348 16.107 15.2434C15.9088 15.2522 15.7098 15.2654 15.5419 15.3962C15.4083 15.5007 15.2576 15.5862 15.1362 15.7027C15.0142 15.8194 14.9127 15.9597 14.813 16.0975C14.1933 16.9553 13.9814 17.8984 14.2501 18.9303C14.3272 19.2265 14.4198 19.5235 14.5473 19.801C14.9411 20.66 15.4496 21.4496 16.0571 22.1745C16.5109 22.716 17.0206 23.2022 17.5373 23.6823C17.6412 23.7789 17.725 23.8974 17.8329 23.9885C19.0566 25.0226 20.4251 25.7973 21.9585 26.2734C22.4807 26.4363 23.0072 26.5796 23.5631 26.5674Z"
      fill="#00E576"
    />
  </svg>
);

export const IconActiveTasks = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <circle
      opacity="0.05"
      cx="27.7427"
      cy="27.6094"
      r="27.5312"
      fill="#00AC4F"
    />
    <path
      d="M20.4482 21.4805H31.9851"
      stroke="#00AC4F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.4482 26.0801H29.6777"
      stroke="#00AC4F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.4482 30.6973H26.2167"
      stroke="#00AC4F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.8699 24.9313V17.8555C34.8699 17.3032 34.4222 16.8555 33.8699 16.8555H17.9878C17.4355 16.8555 16.9878 17.3032 16.9878 17.8555V34.8913C16.9878 35.4436 17.4355 35.8913 17.9878 35.8913H25.6404"
      stroke="#00AC4F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M34.8688 38.7875C37.7361 38.7875 40.0604 36.4631 40.0604 33.5959C40.0604 30.7287 37.7361 28.4043 34.8688 28.4043C32.0016 28.4043 29.6772 30.7287 29.6772 33.5959C29.6772 36.4631 32.0016 38.7875 34.8688 38.7875Z"
      fill="#00AC4F"
      stroke="#00AC4F"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.8252 35.1442V32.0293"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M35.9028 35.1442V32.0293"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconToDo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57"
    height="57"
    viewBox="0 0 57 57"
    fill="none"
  >
    <circle
      opacity="0.05"
      cx="28.7417"
      cy="28.6094"
      r="27.8359"
      fill="#0177FD"
    />
    <g clip-path="url(#clip0_100_187544)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.2813 35.7495C21.0835 35.7495 20.8939 35.671 20.754 35.5311C20.6142 35.3913 20.5356 35.2017 20.5356 35.0039V20.0918C20.5356 19.8941 20.6142 19.7044 20.754 19.5646C20.8939 19.4247 21.0835 19.3462 21.2813 19.3462H35.075C35.3716 19.3462 35.656 19.2284 35.8658 19.0186C36.0755 18.8089 36.1934 18.5244 36.1934 18.2278C36.1934 17.9312 36.0755 17.6467 35.8658 17.4369C35.656 17.2272 35.3716 17.1094 35.075 17.1094H21.2813C20.4903 17.1094 19.7317 17.4236 19.1724 17.9829C18.613 18.5422 18.2988 19.3008 18.2988 20.0918V35.0039C18.2988 35.7949 18.613 36.5535 19.1724 37.1128C19.7317 37.6721 20.4903 37.9863 21.2813 37.9863H36.1934C36.9843 37.9863 37.7429 37.6721 38.3023 37.1128C38.8616 36.5535 39.1758 35.7949 39.1758 35.0039V30.1575C39.1758 29.8609 39.058 29.5764 38.8482 29.3666C38.6385 29.1569 38.354 29.0391 38.0574 29.0391C37.7608 29.0391 37.4763 29.1569 37.2665 29.3666C37.0568 29.5764 36.939 29.8609 36.939 30.1575V35.0039C36.939 35.2017 36.8604 35.3913 36.7206 35.5311C36.5808 35.671 36.3911 35.7495 36.1934 35.7495H21.2813ZM40.3389 22.597C40.5365 22.385 40.644 22.1046 40.6389 21.8149C40.6338 21.5251 40.5164 21.2487 40.3115 21.0438C40.1066 20.8388 39.8302 20.7215 39.5404 20.7164C39.2507 20.7112 38.9703 20.8188 38.7582 21.0163L30.4701 29.303L27.6771 26.416C27.5752 26.3095 27.4532 26.2243 27.3182 26.1651C27.1833 26.1059 27.0379 26.0739 26.8906 26.0711C26.7432 26.0683 26.5967 26.0946 26.4596 26.1485C26.3224 26.2025 26.1973 26.283 26.0914 26.3855C25.9854 26.488 25.9008 26.6104 25.8424 26.7457C25.7839 26.881 25.7528 27.0265 25.7507 27.1739C25.7487 27.3213 25.7758 27.4676 25.8305 27.6044C25.8853 27.7413 25.9665 27.866 26.0695 27.9714L29.6529 31.6755C29.756 31.7825 29.8794 31.8678 30.0158 31.9265C30.1523 31.9852 30.299 32.0162 30.4476 32.0176C30.5961 32.019 30.7434 31.9908 30.881 31.9346C31.0185 31.8784 31.1434 31.7954 31.2485 31.6904L40.3389 22.597Z"
        fill="#0177FD"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_187544">
        <rect
          width="23.8594"
          height="23.8594"
          fill="white"
          transform="translate(16.8062 15.6191)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconHR = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <path
      d="M18.4013 0.761126C17.8683 0.228126 16.9453 0.592126 16.9453 1.33313V5.87013C16.9453 7.76813 18.5573 9.34113 20.5203 9.34113C21.7553 9.35413 23.4713 9.35413 24.9403 9.35413C25.6813 9.35413 26.0713 8.48313 25.5513 7.96313C23.6793 6.07813 20.3253 2.68513 18.4013 0.761126Z"
      fill="white"
    />
    <path
      d="M24.5094 11.1314H20.7524C17.6714 11.1314 15.1624 8.62237 15.1624 5.54137V1.78437C15.1624 1.06937 14.5774 0.484375 13.8624 0.484375H8.35037C4.34637 0.484375 1.10938 3.08438 1.10938 7.72538V19.2434C1.10938 23.8844 4.34637 26.4844 8.35037 26.4844H18.5684C22.5724 26.4844 25.8094 23.8844 25.8094 19.2434V12.4314C25.8094 11.7164 25.2244 11.1314 24.5094 11.1314ZM12.8094 20.9594H7.60938C7.07638 20.9594 6.63437 20.5174 6.63437 19.9844C6.63437 19.4514 7.07638 19.0094 7.60938 19.0094H12.8094C13.3424 19.0094 13.7844 19.4514 13.7844 19.9844C13.7844 20.5174 13.3424 20.9594 12.8094 20.9594ZM15.4094 15.7594H7.60938C7.07638 15.7594 6.63437 15.3174 6.63437 14.7844C6.63437 14.2514 7.07638 13.8094 7.60938 13.8094H15.4094C15.9424 13.8094 16.3844 14.2514 16.3844 14.7844C16.3844 15.3174 15.9424 15.7594 15.4094 15.7594Z"
      fill="white"
    />
  </svg>
);

export const RightIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7446 7.63525L17.7554 8.646L9.34375 17.0576L5.24463 12.9585L6.25537 11.9478L9.34375 15.0361L16.7446 7.63525ZM11.5 0.953125C12.5557 0.953125 13.5739 1.08789 14.5547 1.35742C15.5355 1.62695 16.4526 2.01253 17.3062 2.51416C18.1597 3.01579 18.9346 3.61475 19.6309 4.31104C20.3271 5.00732 20.9261 5.78597 21.4277 6.64697C21.9294 7.50798 22.3149 8.42513 22.5845 9.39844C22.854 10.3717 22.9925 11.39 23 12.4531C23 13.5088 22.8652 14.527 22.5957 15.5078C22.3262 16.4886 21.9406 17.4058 21.439 18.2593C20.9373 19.1128 20.3384 19.8877 19.6421 20.584C18.9458 21.2803 18.1672 21.8792 17.3062 22.3809C16.4452 22.8825 15.528 23.2681 14.5547 23.5376C13.5814 23.8071 12.5632 23.9456 11.5 23.9531C10.4443 23.9531 9.42611 23.8184 8.44531 23.5488C7.46452 23.2793 6.54736 22.8937 5.69385 22.3921C4.84033 21.8905 4.06543 21.2915 3.36914 20.5952C2.67285 19.8989 2.07389 19.1203 1.57227 18.2593C1.07064 17.3983 0.685059 16.4849 0.415527 15.519C0.145996 14.5532 0.00748698 13.5312 0 12.4531C0 11.3975 0.134766 10.3792 0.404297 9.39844C0.673828 8.41764 1.05941 7.50049 1.56104 6.64697C2.06266 5.79346 2.66162 5.01855 3.35791 4.32227C4.0542 3.62598 4.83285 3.02702 5.69385 2.52539C6.55485 2.02376 7.46826 1.63818 8.43408 1.36865C9.3999 1.09912 10.4219 0.960612 11.5 0.953125ZM11.5 22.5156C12.4209 22.5156 13.3081 22.3958 14.1616 22.1562C15.0151 21.9167 15.8162 21.5798 16.5649 21.1455C17.3136 20.7113 17.995 20.1834 18.6089 19.562C19.2228 18.9406 19.7469 18.263 20.1812 17.5293C20.6154 16.7956 20.9561 15.9945 21.2031 15.126C21.4502 14.2575 21.57 13.3665 21.5625 12.4531C21.5625 11.5322 21.4427 10.645 21.2031 9.7915C20.9635 8.93799 20.6266 8.13688 20.1924 7.38818C19.7581 6.63949 19.2303 5.95817 18.6089 5.34424C17.9875 4.73031 17.3099 4.20622 16.5762 3.77197C15.8424 3.33773 15.0413 2.99707 14.1729 2.75C13.3044 2.50293 12.4134 2.38314 11.5 2.39062C10.5791 2.39062 9.69189 2.51042 8.83838 2.75C7.98486 2.98958 7.18376 3.3265 6.43506 3.76074C5.68636 4.19499 5.00505 4.72282 4.39111 5.34424C3.77718 5.96566 3.25309 6.64323 2.81885 7.37695C2.3846 8.11068 2.04395 8.91178 1.79688 9.78027C1.5498 10.6488 1.43001 11.5397 1.4375 12.4531C1.4375 13.374 1.55729 14.2612 1.79688 15.1147C2.03646 15.9683 2.37337 16.7694 2.80762 17.5181C3.24186 18.2668 3.76969 18.9481 4.39111 19.562C5.01253 20.1759 5.6901 20.7 6.42383 21.1343C7.15755 21.5685 7.95866 21.9092 8.82715 22.1562C9.69564 22.4033 10.5866 22.5231 11.5 22.5156Z"
      fill="white"
    />
  </svg>
);

export const ExclamationIcon = () => (
  <svg
    width="6"
    height="22"
    viewBox="0 0 6 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 24.3743C5.5 24.8503 5.35338 25.3157 5.07867 25.7115C4.80397 26.1073 4.41353 26.4159 3.95671 26.598C3.49989 26.7802 2.99723 26.8279 2.51227 26.735C2.02732 26.6421 1.58187 26.4129 1.23223 26.0763C0.882604 25.7396 0.644501 25.3108 0.548038 24.8439C0.451575 24.377 0.501083 23.893 0.690302 23.4532C0.879521 23.0134 1.19995 22.6375 1.61108 22.373C2.0222 22.1085 2.50555 21.9673 3 21.9673C3.66304 21.9673 4.29893 22.2209 4.76777 22.6723C5.23661 23.1237 5.5 23.7359 5.5 24.3743ZM3 18.3569C3.33152 18.3569 3.64946 18.2301 3.88389 18.0044C4.11831 17.7787 4.25 17.4726 4.25 17.1534V1.50817C4.25 1.18898 4.11831 0.882875 3.88389 0.657179C3.64946 0.431483 3.33152 0.304688 3 0.304688C2.66848 0.304688 2.35054 0.431483 2.11612 0.657179C1.8817 0.882875 1.75 1.18898 1.75 1.50817V17.1534C1.75 17.4726 1.8817 17.7787 2.11612 18.0044C2.35054 18.2301 2.66848 18.3569 3 18.3569Z"
      fill="white"
    />
  </svg>
);

export const WatchIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.88211 2.29611C12.0144 1.82764 14.2417 2.07592 16.2185 3.00243C18.1192 3.8933 19.6863 5.36337 20.6968 7.19846L17.5427 6.6423C17.2253 6.58636 16.9228 6.79821 16.8668 7.11548C16.8109 7.43275 17.0228 7.7353 17.34 7.79125L21.9358 8.6016C22.2531 8.65755 22.5556 8.4457 22.6116 8.12842L23.422 3.53266C23.4779 3.21539 23.266 2.91284 22.9488 2.85689C22.6314 2.80095 22.3289 3.0128 22.273 3.33006L21.6971 6.59648C20.567 4.56377 18.8245 2.93536 16.7136 1.94604C14.5042 0.910527 12.0149 0.633046 9.63174 1.15661C7.24858 1.68019 5.10479 2.97556 3.53292 4.8418C1.96105 6.70803 1.04895 9.04082 0.938114 11.4783C0.923472 11.8001 1.17251 12.0729 1.49435 12.0876C1.81617 12.1022 2.08894 11.8531 2.10357 11.5313C2.10608 11.4764 2.10903 11.4214 2.11243 11.3666C2.12032 11.3359 2.12552 11.304 2.12778 11.2715C2.12996 11.2399 2.12928 11.2085 2.12597 11.1779C2.29286 9.12556 3.09499 7.17274 4.42525 5.59337C5.83166 3.92358 7.74978 2.76457 9.88211 2.29611ZM1.23557 14.5072C1.27542 14.6756 1.31924 14.8431 1.36703 15.0097C1.41481 15.1763 1.46645 15.3416 1.52188 15.5056C1.62509 15.8108 1.96589 15.9564 2.26521 15.8372C2.56454 15.7181 2.70887 15.3793 2.60754 15.0735C2.56529 14.946 2.52559 14.8175 2.48849 14.6881C2.45139 14.5587 2.41695 14.4287 2.3852 14.2982C2.30905 13.9852 2.00711 13.7743 1.69014 13.832C1.37316 13.8896 1.16137 14.1938 1.23557 14.5072ZM22.1073 16.5486C22.2407 16.2554 22.0919 15.916 21.7921 15.798C21.4923 15.6801 21.1553 15.8284 21.0199 16.1207C20.9635 16.2427 20.9044 16.3635 20.8429 16.4832C20.7816 16.6029 20.7176 16.7213 20.6515 16.8382C20.4928 17.1186 20.5688 17.479 20.8394 17.6539C21.11 17.8287 21.4725 17.7519 21.6329 17.4724C21.719 17.3224 21.8017 17.1703 21.8809 17.016C21.96 16.8618 22.0355 16.7059 22.1073 16.5486ZM3.06803 18.4878C3.17001 18.6276 3.27533 18.7651 3.38397 18.9001C3.4926 19.0352 3.60427 19.1676 3.71888 19.2972C3.93232 19.5385 4.30292 19.5407 4.53267 19.3148C4.76244 19.089 4.76417 18.7208 4.55224 18.4781C4.46386 18.377 4.37747 18.2739 4.29312 18.1691C4.20877 18.0642 4.12665 17.9577 4.04679 17.8496C3.85526 17.5905 3.49523 17.5133 3.22535 17.6892C2.95549 17.8651 2.87812 18.2276 3.06803 18.4878ZM19.5383 20.0987C19.775 19.8802 19.7693 19.5097 19.5386 19.2847C19.308 19.0598 18.9398 19.0659 18.7016 19.2829C18.6024 19.3734 18.5012 19.462 18.3981 19.5485C18.2951 19.6351 18.1903 19.7194 18.084 19.8016C17.8291 19.9985 17.7594 20.3602 17.9411 20.6262C18.1227 20.8923 18.4867 20.9619 18.7429 20.7665C18.8805 20.6616 19.0156 20.5534 19.1484 20.442C19.2811 20.3304 19.4111 20.216 19.5383 20.0987ZM6.30007 21.4472C6.44822 21.5364 6.59861 21.6223 6.75111 21.7048C6.90361 21.7871 7.05785 21.8659 7.21372 21.9409C7.50401 22.0807 7.84648 21.939 7.97076 21.6418C8.09502 21.3446 7.95391 21.0044 7.6645 20.8629C7.5438 20.8039 7.42422 20.7424 7.30583 20.6783C7.18742 20.6144 7.07044 20.548 6.95495 20.4794C6.678 20.3148 6.31614 20.3832 6.13557 20.65C5.95499 20.9167 6.02414 21.2808 6.30007 21.4472ZM15.7941 22.3757C16.0969 22.266 16.2354 21.9222 16.1099 21.6254C15.9845 21.3287 15.6426 21.1917 15.3391 21.2995C15.2125 21.3444 15.0849 21.3867 14.9563 21.4266C14.8277 21.4664 14.6986 21.5036 14.5687 21.5382C14.2573 21.6209 14.0529 21.9272 14.1173 22.2429C14.1816 22.5586 14.4902 22.764 14.8021 22.6831C14.9695 22.6397 15.1361 22.5924 15.3016 22.541C15.4673 22.4897 15.6314 22.4345 15.7941 22.3757ZM10.4265 22.9224C10.5976 22.9473 10.7696 22.9681 10.942 22.9851C11.1146 23.002 11.2872 23.0147 11.46 23.0234C11.7818 23.0398 12.0427 22.7765 12.042 22.4543C12.0414 22.1322 11.7795 21.8733 11.4578 21.855C11.3236 21.8474 11.1896 21.8371 11.0557 21.824C10.9217 21.8108 10.7881 21.7951 10.655 21.7765C10.3359 21.7322 10.0289 21.9353 9.96576 22.2513C9.90276 22.5673 10.1076 22.8761 10.4265 22.9224ZM11.9375 7.87114V11.9545H16.0219C16.3442 11.9545 16.6053 12.2157 16.6053 12.5378C16.6053 12.86 16.3442 13.1211 16.0219 13.1211H10.7709V7.87114C10.7709 7.54898 11.032 7.28781 11.3542 7.28781C11.6763 7.28781 11.9375 7.54898 11.9375 7.87114Z"
      fill="white"
    />
  </svg>
);
export const IconInProgress = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <circle
      opacity="0.05"
      cx="27.7417"
      cy="27.6133"
      r="27.5117"
      fill="#2BB2FE"
    />
    <g clip-path="url(#clip0_100_187565)">
      <path
        d="M37.7198 18.7534C35.2769 15.9973 31.7222 14.2539 27.7447 14.2539C20.3638 14.2539 14.3818 20.2359 14.3818 27.6167H17.7225C17.7225 22.0785 22.2064 17.5946 27.7447 17.5946C30.7983 17.5946 33.5074 18.9779 35.3396 21.1337L32.1972 24.276H41.1075V15.3657L37.7198 18.7534ZM27.7447 37.6389C24.6911 37.6389 21.9819 36.2556 20.1498 34.0998L23.2921 30.9575H14.3818V39.8677L17.7695 36.4801C20.2124 39.2361 23.7724 40.9796 27.7447 40.9796C35.1255 40.9796 41.1075 34.9976 41.1075 27.6167H37.7668C37.7668 33.155 33.2829 37.6389 27.7447 37.6389Z"
        fill="#2BB2FE"
      />
    </g>
    <defs>
      <clipPath id="clip0_100_187565">
        <rect
          width="26.7257"
          height="26.7257"
          fill="white"
          transform="translate(14.3818 14.2539)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconCompleted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <circle
      opacity="0.05"
      cx="28.3896"
      cy="27.6055"
      r="27.5039"
      fill="#00AC4F"
    />
    <path
      d="M33.5297 22.8904L34.5196 23.8804L26.281 32.119L22.2662 28.1042L23.2561 27.1142L26.281 30.1391L33.5297 22.8904ZM28.3929 16.3457C29.4269 16.3457 30.4241 16.4777 31.3848 16.7417C32.3454 17.0057 33.2437 17.3833 34.0796 17.8746C34.9156 18.3659 35.6746 18.9526 36.3565 19.6346C37.0385 20.3165 37.6252 21.0792 38.1165 21.9225C38.6078 22.7658 38.9854 23.664 39.2494 24.6173C39.5134 25.5706 39.6491 26.5679 39.6564 27.6092C39.6564 28.6432 39.5244 29.6405 39.2604 30.6011C38.9964 31.5617 38.6188 32.46 38.1275 33.296C37.6362 34.1319 37.0495 34.8909 36.3675 35.5729C35.6856 36.2548 34.9229 36.8415 34.0796 37.3328C33.2364 37.8241 32.3381 38.2017 31.3848 38.4657C30.4315 38.7297 29.4342 38.8654 28.3929 38.8727C27.3589 38.8727 26.3617 38.7407 25.401 38.4767C24.4404 38.2127 23.5421 37.8351 22.7061 37.3438C21.8702 36.8525 21.1112 36.2658 20.4292 35.5839C19.7473 34.9019 19.1606 34.1393 18.6693 33.296C18.178 32.4527 17.8004 31.558 17.5364 30.6121C17.2724 29.6661 17.1367 28.6652 17.1294 27.6092C17.1294 26.5753 17.2614 25.578 17.5254 24.6173C17.7894 23.6567 18.167 22.7584 18.6583 21.9225C19.1496 21.0865 19.7363 20.3275 20.4182 19.6456C21.1002 18.9636 21.8629 18.3769 22.7061 17.8856C23.5494 17.3943 24.4441 17.0167 25.39 16.7527C26.336 16.4887 27.3369 16.353 28.3929 16.3457ZM28.3929 37.4648C29.2949 37.4648 30.1638 37.3474 30.9998 37.1128C31.8357 36.8781 32.6204 36.5481 33.3537 36.1228C34.087 35.6975 34.7543 35.1805 35.3556 34.5719C35.9569 33.9633 36.4702 33.2996 36.8955 32.581C37.3208 31.8624 37.6545 31.0777 37.8965 30.2271C38.1385 29.3765 38.2558 28.5038 38.2485 27.6092C38.2485 26.7072 38.1311 25.8383 37.8965 25.0023C37.6618 24.1664 37.3318 23.3817 36.9065 22.6484C36.4812 21.9151 35.9642 21.2478 35.3556 20.6465C34.747 20.0452 34.0833 19.5319 33.3647 19.1066C32.646 18.6813 31.8614 18.3476 31.0108 18.1056C30.1602 17.8636 29.2875 17.7463 28.3929 17.7536C27.4909 17.7536 26.622 17.871 25.786 18.1056C24.9501 18.3403 24.1654 18.6703 23.4321 19.0956C22.6988 19.5209 22.0315 20.0379 21.4302 20.6465C20.8289 21.2552 20.3156 21.9188 19.8903 22.6374C19.465 23.3561 19.1313 24.1407 18.8893 24.9913C18.6473 25.842 18.53 26.7146 18.5373 27.6092C18.5373 28.5112 18.6547 29.3801 18.8893 30.2161C19.124 31.0521 19.454 31.8367 19.8793 32.57C20.3046 33.3033 20.8216 33.9706 21.4302 34.5719C22.0388 35.1732 22.7025 35.6865 23.4211 36.1118C24.1398 36.5371 24.9244 36.8708 25.775 37.1128C26.6256 37.3548 27.4983 37.4721 28.3929 37.4648Z"
      fill="#00AC4F"
    />
  </svg>
);

export const IconOnHold = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
  >
    <circle
      opacity="0.05"
      cx="28.3877"
      cy="27.6094"
      r="27.5078"
      fill="#F3C619"
    />
    <path
      d="M24.8232 32.4721C24.8232 32.8648 25.2552 33.1042 25.5882 32.8961L32.9473 28.2967C33.2607 28.1008 33.2607 27.6445 32.9473 27.4487L25.5882 22.8492C25.2552 22.6411 24.8232 22.8805 24.8232 23.2732V32.4721Z"
      fill="#F3C619"
    />
    <path
      d="M39.123 27.8742C39.123 33.9511 34.1967 38.8773 28.1198 38.8773C22.043 38.8773 17.1167 33.9511 17.1167 27.8742C17.1167 21.7974 22.043 16.8711 28.1198 16.8711C34.1967 16.8711 39.123 21.7974 39.123 27.8742ZM18.5798 27.8742C18.5798 33.143 22.851 37.4142 28.1198 37.4142C33.3886 37.4142 37.6598 33.143 37.6598 27.8742C37.6598 22.6054 33.3886 18.3342 28.1198 18.3342C22.851 18.3342 18.5798 22.6054 18.5798 27.8742Z"
      fill="#F3C619"
    />
  </svg>
);

export const IconApppending = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="56"
    viewBox="0 0 55 56"
    fill="none"
  >
    <ellipse
      opacity="0.05"
      cx="27.1124"
      cy="27.6074"
      rx="27.0245"
      ry="27.5352"
      fill="#01265D"
    />
    <path
      d="M21.748 20.7539H33.2718"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.748 25.4512H30.9671"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.748 30.1406H27.5099"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.1431 24.2679V17.0488C36.1431 16.4965 35.6954 16.0488 35.1431 16.0488H19.2813C18.729 16.0488 18.2812 16.4965 18.2812 17.0488V34.4223C18.2812 34.9746 18.729 35.4223 19.2812 35.4223H26.9241"
      stroke="#01265D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.097 38.4632C33.204 38.4632 30.8589 36.0738 30.8589 33.1261C30.8589 30.1785 33.204 27.7891 36.097 27.7891C38.99 27.7891 41.3351 30.1785 41.3351 33.1261C41.3351 36.0738 38.99 38.4632 36.097 38.4632ZM36.6208 33.1261V30.4576H35.5732V34.1935H38.716V33.1261H36.6208Z"
      fill="#01265D"
    />
  </svg>
);

export const IconRejection = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
  >
    <circle cx="14" cy="14.1953" r="14" fill="#FF0000" fill-opacity="0.1" />
    <path
      d="M18.9982 9.19531L10.0018 19.1735M10 9.21713L19 19.1953"
      stroke="#FF0000"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export const IconAcception = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
  >
    <circle cx="14" cy="14.1953" r="14" fill="#00A34B" fill-opacity="0.1" />
    <path
      d="M20 10.1953L11.75 18.1953L8 14.5589"
      stroke="#00A34B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconAssignedDate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.06556 22.7106H4.30469C2.64784 22.7106 1.30469 21.3675 1.30469 19.7106V7.90625C1.30469 6.2494 2.64783 4.90625 4.30469 4.90625H17.4786C19.1355 4.90625 20.4786 6.2494 20.4786 7.90625V9.47147"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.95703 1.71094V4.45007"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.69531 9.46875L4.95618 9.46875"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15 9.46875L12.2609 9.46875"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.69531 14.4922L4.95618 14.4922"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M11.3477 1.71094V4.45007"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M17.7383 1.71094V4.45007"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M21.0445 15.7341L16.3301 13.0402C15.3302 12.4688 14.0859 13.1908 14.0859 14.3426V19.9998C14.0859 21.1796 15.3853 21.8976 16.3842 21.2697L21.0985 18.3064C22.0575 17.7036 22.0279 16.2961 21.0445 15.7341Z"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconDueDate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.5929 22.7106H3.83203C2.17518 22.7106 0.832031 21.3675 0.832031 19.7106V7.90625C0.832031 6.2494 2.17518 4.90625 3.83203 4.90625H17.0059C18.6628 4.90625 20.0059 6.2494 20.0059 7.90625V9.47147"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.48438 1.71094V4.45007"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.22266 9.46875L4.48353 9.46875"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M14.5273 9.46875L11.7882 9.46875"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M7.22266 14.4922L4.48353 14.4922"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M10.875 1.71094V4.45007"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M17.2656 1.71094V4.45007"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M22.7446 16.9766L14.8505 21.9385C14.1624 22.3711 13.255 22.1769 12.8041 21.5006L10.875 18.6065"
      stroke="#BDC7D4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconChangeDueDate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
  >
    <path
      d="M5.5 0.109375C8.53765 0.109375 11 2.65116 11 5.78679C11 8.92243 8.53765 11.4642 5.5 11.4642C2.46235 11.4642 0 8.92243 0 5.78679C0 2.65116 2.46235 0.109375 5.5 0.109375ZM5.5 1.24486C4.33305 1.24486 3.21389 1.72338 2.38873 2.57516C1.56357 3.42694 1.1 4.5822 1.1 5.78679C1.1 6.99139 1.56357 8.14665 2.38873 8.99843C3.21389 9.85021 4.33305 10.3287 5.5 10.3287C6.66695 10.3287 7.78611 9.85021 8.61127 8.99843C9.43643 8.14665 9.9 6.99139 9.9 5.78679C9.9 4.5822 9.43643 3.42694 8.61127 2.57516C7.78611 1.72338 6.66695 1.24486 5.5 1.24486ZM5.5 2.38034C5.63471 2.38036 5.76474 2.43141 5.86541 2.52382C5.96607 2.61622 6.03039 2.74355 6.04615 2.88166L6.05 2.94808V5.55175L7.53885 7.08863C7.63749 7.1908 7.69476 7.32789 7.69903 7.47207C7.70329 7.61625 7.65423 7.7567 7.56181 7.86489C7.4694 7.97308 7.34055 8.0409 7.20144 8.05458C7.06233 8.06826 6.9234 8.02677 6.81285 7.93854L6.76115 7.89141L5.11115 6.18819C5.02567 6.09987 4.97077 5.98494 4.95495 5.86117L4.95 5.78679V2.94808C4.95 2.79751 5.00795 2.6531 5.11109 2.54663C5.21424 2.44016 5.35413 2.38034 5.5 2.38034Z"
      fill="#5E6B7B"
    />
  </svg>
);

export const IconTodo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
  >
    <path
      d="M10.7747 1.68082C10.4756 1.38109 10.0779 1.21601 9.65465 1.21601H8.93981V1.07193C8.93981 0.674721 8.61665 0.351562 8.21944 0.351562H3.03276C2.63555 0.351562 2.31239 0.674721 2.31239 1.07193V1.21601H1.59499C0.723023 1.21601 0.0128236 1.92618 0.0118438 2.79907L9.66788e-07 13.5182C-0.000460071 13.9418 0.163986 14.3402 0.463056 14.64C0.762154 14.9397 1.15994 15.1048 1.58315 15.1048H9.64277C10.5148 15.1048 11.225 14.3946 11.2259 13.5217L11.2378 2.80258C11.2383 2.37892 11.0738 1.98052 10.7747 1.68082ZM3.17684 1.21601H8.07536V2.08045H3.17684V1.21601ZM10.3624 13.5207C10.3619 13.9175 10.0391 14.2403 9.64277 14.2403H1.58315C1.39078 14.2403 1.20997 14.1653 1.07402 14.029C0.938068 13.8928 0.863323 13.7117 0.863524 13.5192L0.875367 2.80005C0.875799 2.40324 1.19861 2.08045 1.59499 2.08045H2.31239V2.22453C2.31239 2.62174 2.63555 2.9449 3.03276 2.9449H8.21944C8.61665 2.9449 8.93981 2.62174 8.93981 2.22453V2.08045H9.65465C9.84701 2.08045 10.0278 2.15549 10.1638 2.29172C10.2997 2.42796 10.3745 2.60906 10.3743 2.8016L10.3624 13.5207Z"
      fill="#5E6B7B"
    />
    <path
      d="M5.76621 6.11445H8.83703C9.07574 6.11445 9.26926 5.92093 9.26926 5.68222C9.26926 5.44352 9.07574 5.25 8.83703 5.25H5.76621C5.5275 5.25 5.33398 5.44352 5.33398 5.68222C5.33398 5.92093 5.5275 6.11445 5.76621 6.11445Z"
      fill="#5E6B7B"
    />
    <path
      d="M5.76621 8.9953H8.83703C9.07574 8.9953 9.26926 8.80178 9.26926 8.56308C9.26926 8.32438 9.07574 8.13086 8.83703 8.13086H5.76621C5.5275 8.13086 5.33398 8.32438 5.33398 8.56308C5.33398 8.80178 5.5275 8.9953 5.76621 8.9953Z"
      fill="#5E6B7B"
    />
    <path
      d="M8.8494 11.0098H5.76621C5.5275 11.0098 5.33398 11.2033 5.33398 11.442C5.33398 11.6807 5.5275 11.8742 5.76621 11.8742H8.8494C9.0881 11.8742 9.28162 11.6807 9.28162 11.442C9.28162 11.2033 9.08813 11.0098 8.8494 11.0098Z"
      fill="#5E6B7B"
    />
    <path
      d="M3.92763 4.49964L2.93087 5.4964L2.69586 5.26136C2.52706 5.09256 2.2534 5.09256 2.08461 5.26136C1.91581 5.43013 1.91581 5.70381 2.08461 5.87261L2.62526 6.41329C2.70631 6.49435 2.81624 6.53991 2.9309 6.53991C3.04552 6.53991 3.15545 6.49438 3.23651 6.41329L4.53891 5.11092C4.70771 4.94215 4.70771 4.66847 4.53891 4.49967C4.37011 4.33084 4.09646 4.33084 3.92763 4.49964Z"
      fill="#5E6B7B"
    />
    <path
      d="M3.92763 7.60704L2.93087 8.6038L2.69586 8.36879C2.52706 8.19999 2.2534 8.19999 2.08461 8.36879C1.91581 8.53756 1.91581 8.81121 2.08461 8.98004L2.62526 9.52072C2.70631 9.60178 2.81624 9.64734 2.9309 9.64734C3.04552 9.64734 3.15548 9.60181 3.23651 9.52072L4.53891 8.21832C4.70771 8.04955 4.70771 7.77587 4.53891 7.60707C4.37011 7.43827 4.09643 7.43827 3.92763 7.60704Z"
      fill="#5E6B7B"
    />
    <path
      d="M3.92763 10.4859L2.93087 11.4827L2.69586 11.2477C2.52706 11.0789 2.2534 11.0789 2.08461 11.2477C1.91581 11.4165 1.91581 11.6901 2.08461 11.8589L2.62526 12.3996C2.70631 12.4807 2.81624 12.5262 2.9309 12.5262C3.04552 12.5262 3.15548 12.4807 3.23651 12.3996L4.53891 11.0972C4.70771 10.9285 4.70771 10.6548 4.53891 10.486C4.37011 10.3172 4.09643 10.3172 3.92763 10.4859Z"
      fill="#5E6B7B"
    />
  </svg>
);

export const IconProgress = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.29907 6.85182C1.29907 9.71886 3.63137 12.0516 6.49928 12.0516C7.91114 12.0516 9.21379 11.4848 10.1713 10.5235L8.44936 8.80174H12.3495V12.7016L11.0898 11.4413C9.89242 12.6437 8.2641 13.3516 6.49928 13.3516C2.91439 13.3516 -0.000976562 10.4358 -0.000976562 6.85182H1.29907ZM6.49876 0.351562C10.0837 0.351562 12.999 3.26735 12.999 6.8513H11.699C11.699 3.98427 9.36668 1.65151 6.49876 1.65151C5.08691 1.65151 3.78426 2.21829 2.82677 3.1796L4.54868 4.90138H0.648536V1.00154L1.90828 2.26118C3.10563 1.05939 4.73395 0.351562 6.49876 0.351562Z"
      fill="#5E6B7B"
    />
  </svg>
);

export const IconCompletedNew = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
  >
    <path
      d="M12 1.35156L4.4375 8.35156L1 5.16974"
      stroke="#5E6B7B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconCancel = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 1.35156L1.5 9.35156"
      stroke="#5E6B7B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 1.35156L9 9.35156"
      stroke="#5E6B7B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconHold = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.66667 15.0208C11.3486 15.0208 14.3333 12.0361 14.3333 8.35417C14.3333 4.67227 11.3486 1.6875 7.66667 1.6875C3.98477 1.6875 1 4.67227 1 8.35417C1 12.0361 3.98477 15.0208 7.66667 15.0208Z"
      stroke="#5E6B7B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.33203 10.3516V6.35156"
      stroke="#5E6B7B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 10.3516V6.35156"
      stroke="#5E6B7B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PurchaseIcon = () => (
  <svg
    width="22"
    height="28"
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.80136 4.52171H12.4114C12.9517 4.52171 12.9232 4.74045 12.8751 5.29824L12.5689 9.21808C12.5164 9.84149 12.5601 9.69056 11.8995 9.7868L6.47473 10.2615L6.79628 11.1955C9.4343 11.1955 10.0511 11.1955 12.687 11.1955C12.7767 11.528 12.897 12.0661 12.9845 12.4358H11.8973L11.7923 12.0573C9.59617 12.0573 9.41461 12.0573 7.21627 12.0573C6.01538 12.0377 6.13568 12.3614 5.84913 11.3246L3.78641 4.28109H3.14987V3.40394H4.53231C4.61325 3.70799 4.72699 4.21547 4.80136 4.52171ZM14.9116 0.652182C14.8153 0.564685 14.6797 0.507812 14.5463 0.507812C14.5178 0.507812 14.4894 0.507812 14.4588 0.516562H1.21183C0.885901 0.516562 0.577476 0.652182 0.356548 0.87311C0.135619 1.09404 0 1.39153 0 1.72839V26.1749C0 26.5117 0.135619 26.8092 0.356548 27.0302C0.577476 27.2511 0.874964 27.3867 1.21183 27.3867H20.1898C20.5267 27.3867 20.8241 27.2511 21.0451 27.0302C21.266 26.8092 21.4016 26.5117 21.4016 26.1749V7.57315C21.4104 7.52502 21.4213 7.48565 21.4213 7.43753C21.4213 7.27347 21.3447 7.1291 21.2376 7.02411L14.9772 0.689368C14.9575 0.669681 14.9488 0.660931 14.9291 0.649994L14.9116 0.652182ZM14.4807 1.6037V5.8604C14.4807 6.3132 14.6644 6.72662 14.9619 7.02411C15.2594 7.32159 15.6728 7.50534 16.1256 7.50534H20.2948V26.1771C20.2948 26.2055 20.286 26.2449 20.2554 26.2646C20.2357 26.2843 20.2073 26.3039 20.1679 26.3039H1.20089C1.17245 26.3039 1.13308 26.2952 1.11339 26.2646C1.0937 26.2449 1.07402 26.2077 1.07402 26.1771V1.72839C1.07402 1.68901 1.08277 1.66058 1.11339 1.64089C1.13308 1.6212 1.16151 1.60152 1.20089 1.60152H14.4807V1.6037ZM15.5656 5.8604V2.46992L19.457 6.41819H16.1234C15.9703 6.41819 15.8347 6.35038 15.7297 6.25414C15.6334 6.15789 15.5656 6.01352 15.5656 5.8604ZM4.48856 15.7519C4.19108 15.7519 3.94171 15.9925 3.94171 16.2987C3.94171 16.5962 4.18233 16.8478 4.48856 16.8478H16.7665C17.064 16.8478 17.3155 16.6071 17.3155 16.2987C17.3155 16.0012 17.0749 15.7519 16.7665 15.7519H4.48856ZM4.69418 22.2463C4.39669 22.2463 4.14514 22.4869 4.14514 22.7953C4.14514 23.0928 4.38576 23.3422 4.69418 23.3422H16.8912C17.1887 23.3422 17.4402 23.1016 17.4402 22.7931C17.4402 22.4957 17.1996 22.2463 16.8912 22.2463H4.69418ZM4.48856 19.1139C4.19108 19.1139 3.94171 19.3545 3.94171 19.6608C3.94171 19.9583 4.18233 20.2076 4.48856 20.2076H16.8912C17.1887 20.2076 17.438 19.967 17.438 19.6608C17.438 19.3633 17.1974 19.1139 16.8912 19.1139H4.48856ZM8.09342 5.51042H9.66616V7.10723H11.0814L8.88088 9.24652L6.67816 7.10504H8.09342V5.51042ZM7.22501 12.5845C7.68875 12.5845 8.06498 12.9607 8.06498 13.4245C8.06498 13.8882 7.68875 14.2644 7.22501 14.2644C6.76128 14.2644 6.38505 13.8882 6.38505 13.4245C6.38505 12.9607 6.76128 12.5845 7.22501 12.5845ZM10.6877 12.5845C11.1514 12.5845 11.5276 12.9607 11.5276 13.4245C11.5276 13.8882 11.1514 14.2644 10.6877 14.2644C10.224 14.2644 9.84772 13.8882 9.84772 13.4245C9.84772 12.9607 10.224 12.5845 10.6877 12.5845Z"
      fill="white"
    />
  </svg>
);

export const PlannedIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.92135 10.1276V7.41737C1.92135 7.06291 2.20188 6.7739 2.54592 6.7739H5.17653C5.52057 6.7739 5.8011 7.06291 5.8011 7.41737C5.8011 7.81 5.22416 7.81 5.21887 7.41737C5.21887 7.39011 5.1977 7.37375 5.17653 7.37375H2.54592C2.51946 7.37375 2.50358 7.39556 2.50358 7.41737V10.1276C2.50358 10.1549 2.52475 10.1712 2.54592 10.1712H5.17653C5.55762 10.1712 5.55762 10.7656 5.17653 10.7711H2.54592C2.20188 10.7711 1.92135 10.4821 1.92135 10.1276ZM4.40905 8.23535C4.1391 7.95723 3.73155 8.38258 3.99619 8.6607L4.90129 9.59319C5.01245 9.7077 5.1977 9.7077 5.31415 9.59319L7.08729 7.76637C7.19844 7.65186 7.19844 7.461 7.08729 7.34103C6.97614 7.22651 6.79088 7.22651 6.67444 7.34103L5.10772 8.95517L4.40905 8.23535ZM2.54592 17.0913H5.17653C5.55762 17.0913 5.55762 16.4969 5.17653 16.4915H2.54592C2.51946 16.4915 2.50358 16.4696 2.50358 16.4478V13.7376C2.50358 13.7103 2.52475 13.694 2.54592 13.694H5.17653C5.20299 13.694 5.21887 13.7158 5.21887 13.7376C5.21887 13.9012 5.3512 14.0375 5.50998 14.0375C5.66877 14.0375 5.8011 13.9012 5.8011 13.7376C5.8011 13.3831 5.52057 13.0941 5.17653 13.0941H2.54592C2.20188 13.0941 1.92135 13.3831 1.92135 13.7376V16.4478C1.92135 16.8023 2.20188 17.0913 2.54592 17.0913ZM6.67973 13.6667L5.11301 15.2809L4.40905 14.5556C4.1391 14.2775 3.73155 14.7028 3.99619 14.9809L4.90129 15.9134C4.95952 15.9734 5.03362 16.0007 5.10772 16.0007C5.18182 16.0007 5.25592 15.9734 5.31415 15.9134L7.08729 14.0866C7.35723 13.8139 6.94967 13.3886 6.67973 13.6667ZM5.18182 22.8171H2.54592C2.51946 22.8171 2.50358 22.7953 2.50358 22.7735V20.0633C2.50358 20.036 2.52475 20.0197 2.54592 20.0197H5.17653C5.20299 20.0197 5.21887 20.0415 5.21887 20.0633C5.21887 20.2269 5.3512 20.3632 5.50998 20.3632C5.66877 20.3632 5.8011 20.2269 5.8011 20.0633C5.8011 19.7088 5.52057 19.4198 5.17653 19.4198H2.54592C2.20188 19.4198 1.92135 19.7088 1.92135 20.0633V22.7735C1.92135 23.128 2.20188 23.417 2.54592 23.417H5.17653C5.55762 23.4115 5.56291 22.8171 5.18182 22.8171ZM6.67973 19.9924L5.11301 21.6065L4.40905 20.8813C4.1391 20.6031 3.73155 21.0285 3.99619 21.3066L4.90129 22.2391C5.01245 22.3536 5.1977 22.3536 5.31415 22.2391L7.08729 20.4123C7.35723 20.1342 6.94967 19.7143 6.67973 19.9924ZM9.1939 7.96269H13.1795C13.5606 7.96269 13.5606 7.36284 13.1795 7.36284H9.1939C8.8128 7.36829 8.8128 7.96269 9.1939 7.96269ZM9.1939 9.57683H16.1806C16.5564 9.57683 16.5617 8.97698 16.1806 8.97698H9.1939C8.81809 8.97698 8.8128 9.57137 9.1939 9.57683ZM10.533 16.3333C10.9141 16.3333 10.9141 15.7335 10.533 15.7335H9.1939C8.8128 15.7335 8.8128 16.3333 9.1939 16.3333H10.533ZM11.8298 14.4247C11.8298 14.2611 11.6975 14.1248 11.5387 14.1248H9.1939C8.8128 14.1248 8.8128 14.7246 9.1939 14.7246H11.5387C11.6975 14.7246 11.8298 14.5937 11.8298 14.4247ZM9.1939 20.9085H10.0831C10.4642 20.9085 10.4642 20.3087 10.0831 20.3087H9.1939C8.8128 20.3141 8.8128 20.9085 9.1939 20.9085ZM10.75 21.9174H9.1939C8.8128 21.9174 8.8128 22.5172 9.1939 22.5172H10.75C11.1311 22.5172 11.1311 21.9228 10.75 21.9174ZM26.9995 18.5746C27.0577 23.5315 22.421 27.3978 17.7315 26.329C17.5462 26.438 17.3345 26.498 17.1122 26.498H1.27031C0.571641 26.498 0 25.9145 0 25.1893V3.49654C0 2.77672 0.566348 2.19323 1.27031 2.19323H2.81586V1.54975C2.81586 0.977171 3.27106 0.508198 3.82682 0.508198C4.3667 0.497291 4.84836 0.99353 4.83778 1.54975V2.19323H8.18294V1.54975C8.18294 0.977171 8.63813 0.508198 9.1939 0.508198C9.73907 0.491838 10.2154 0.998984 10.2049 1.54975V2.19323H13.55V1.54975C13.55 0.977171 14.0052 0.508198 14.561 0.508198C15.1009 0.491838 15.5878 0.998984 15.5719 1.54975V2.19323H17.1175C17.8161 2.19323 18.3878 2.77672 18.3878 3.49654V10.7111C22.9133 10.1112 27.0312 13.8685 26.9995 18.5746ZM14.1322 3.42565C14.1375 4.00914 14.9844 4.01459 14.9897 3.42565C14.9897 2.95667 14.9897 2.01873 14.9897 1.54975C14.9897 0.977171 14.1428 0.955358 14.1322 1.54975V3.42565ZM8.76516 3.42565C8.77575 4.00914 9.61204 4.00914 9.62263 3.42565C9.62263 2.95667 9.62263 2.01873 9.62263 1.54975C9.61204 0.966264 8.77575 0.966264 8.76516 1.54975V3.42565ZM3.39809 3.42565C3.40867 4.00914 4.25026 4.00914 4.26084 3.42565C4.26084 2.95667 4.26084 2.01873 4.26084 1.54975C4.24496 0.966264 3.40867 0.966264 3.39809 1.54975V3.42565ZM16.3818 25.9036C9.35798 22.779 10.4219 12.5052 17.8056 10.8038V3.49108C17.8056 3.10391 17.4986 2.78763 17.1175 2.78763H15.5719V3.42565C15.5719 3.99823 15.1167 4.4672 14.561 4.47266C14.0052 4.47266 13.55 4.00368 13.55 3.42565V2.79308H10.2049V3.4311C10.2049 4.00368 9.74436 4.47266 9.1939 4.47811C8.63813 4.47811 8.18294 3.99823 8.18294 3.4311V2.79308H4.83778V3.4311C4.83778 4.00914 4.37729 4.47811 3.82682 4.47811C3.26576 4.47266 2.81057 3.98187 2.81586 3.42565V2.79308H1.27031C0.88922 2.79308 0.582227 3.10936 0.582227 3.49654V25.1947C0.582227 25.5819 0.88922 25.9036 1.27031 25.9036H16.3818ZM18.1443 11.3546C11.454 12.5052 10.189 22.2064 16.2865 25.2056C18.9806 26.5089 22.4581 25.8273 24.4959 23.5915C29.0214 18.3455 24.8929 10.3839 18.1443 11.3546ZM19.3088 25.2165C15.7572 25.2165 12.8672 22.2391 12.8672 18.58C12.8672 14.9209 15.7572 11.9435 19.3088 11.9435C27.8569 12.3034 27.8569 24.8512 19.3088 25.2165ZM25.1734 18.5746C25.1734 15.2427 22.5428 12.5379 19.3141 12.5379C16.0801 12.5379 13.4547 15.2481 13.4547 18.5746C13.767 26.5853 24.8505 26.5853 25.1734 18.5746ZM21.3254 15.5099L19.9651 17.9911C20.2827 18.3346 20.235 18.9563 19.8857 19.2453L20.595 21.0776C20.6532 21.2303 20.5844 21.4048 20.4309 21.4648C20.288 21.5247 20.1133 21.4538 20.0551 21.2957L19.3458 19.4689C18.0702 19.4743 18.1972 17.5112 19.4623 17.6912L20.8226 15.21C21.0078 14.8719 21.5106 15.1663 21.3254 15.5099ZM19.3088 18.2746C18.9277 18.2746 18.9277 18.869 19.3088 18.8745C19.6899 18.869 19.6952 18.2855 19.3088 18.2746ZM19.3088 14.3265C19.4676 14.3265 19.5999 14.1902 19.5999 14.0266V13.3504C19.5999 13.1868 19.4676 13.0505 19.3088 13.0505C19.15 13.0505 19.0177 13.1868 19.0177 13.3504V14.0266C19.0177 14.1957 19.15 14.3265 19.3088 14.3265ZM19.3088 22.8226C19.15 22.8226 19.0177 22.9589 19.0177 23.1225V23.7987C19.0177 23.9623 19.15 24.0986 19.3088 24.0986C19.4676 24.0986 19.5999 23.9623 19.5999 23.7987V23.1225C19.5999 22.9589 19.4728 22.8226 19.3088 22.8226ZM14.8944 18.2746H14.2381C13.857 18.2746 13.857 18.8745 14.2381 18.8745H14.8944C15.2755 18.8745 15.2755 18.2801 14.8944 18.2746ZM24.3847 18.2746H23.7284C23.3473 18.2746 23.3473 18.8745 23.7284 18.8745H24.3847C24.7605 18.8745 24.7605 18.2801 24.3847 18.2746Z"
      fill="white"
    />
  </svg>
);

export const PlannedWorkingIcon = () => (
  <svg
    width="25"
    height="33"
    viewBox="0 0 25 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 8.95312L21 8.95312" stroke="white" stroke-linecap="round" />
    <path d="M7 14.9531H4" stroke="white" stroke-linecap="round" />
    <path d="M12 14.9531H9" stroke="white" stroke-linecap="round" />
    <path d="M17 14.9531H14" stroke="white" stroke-linecap="round" />
    <path d="M7 17.9531H4" stroke="white" stroke-linecap="round" />
    <path d="M12 17.9531H9" stroke="white" stroke-linecap="round" />
    <path d="M12 20.9531H9" stroke="white" stroke-linecap="round" />
    <path d="M7 20.9531H4" stroke="white" stroke-linecap="round" />
    <path d="M7 23.9531H4" stroke="white" stroke-linecap="round" />
    <path d="M11 23.9531H9" stroke="white" stroke-linecap="round" />
    <path d="M17 17.9531H14" stroke="white" stroke-linecap="round" />
    <path
      d="M21.5 21.9531V8.95312V3.95313C21.5 3.40084 21.0523 2.95312 20.5 2.95312H1.5C1.22386 2.95312 1 3.17698 1 3.45312V28.9531C1 29.2293 1.22386 29.4531 1.5 29.4531H14"
      stroke="white"
      stroke-linecap="round"
    />
    <path
      d="M7 1.45312V4.45312"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M15 1.45312V4.45312"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M24.5 26.9531C24.5 29.9907 22.0376 32.4531 19 32.4531C15.9624 32.4531 13.5 29.9907 13.5 26.9531C13.5 23.9156 15.9624 21.4531 19 21.4531C22.0376 21.4531 24.5 23.9156 24.5 26.9531Z"
      stroke="white"
    />
    <path
      d="M19 23.9531V27.809C19 27.8951 19.0551 27.9715 19.1368 27.9987L22 28.9531"
      stroke="white"
      stroke-linecap="round"
    />
  </svg>
);

export const PlannedCompIcon = () => (
  <svg
    width="25"
    height="31"
    viewBox="0 0 25 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 13.9531L18 13.9531" stroke="white" stroke-linecap="round" />
    <path d="M5 13.9531H4" stroke="white" stroke-linecap="round" />
    <path d="M7 17.9531L18 17.9531" stroke="white" stroke-linecap="round" />
    <path d="M5 17.9531H4" stroke="white" stroke-linecap="round" />
    <path d="M7 21.9531L14 21.9531" stroke="white" stroke-linecap="round" />
    <path d="M5 21.9531H4" stroke="white" stroke-linecap="round" />
    <path
      d="M15 0.953125H1.5C1.22386 0.953125 1 1.17698 1 1.45312V26.9531C1 27.2293 1.22386 27.4531 1.5 27.4531H14M15 0.953125L21.5 6.95312M15 0.953125V5.95312C15 6.50541 15.4477 6.95312 16 6.95312H21.5M21.5 6.95312V19.9531"
      stroke="white"
      stroke-linecap="round"
    />
    <path
      d="M24.5 24.9531C24.5 27.9907 22.0376 30.4531 19 30.4531C15.9624 30.4531 13.5 27.9907 13.5 24.9531C13.5 21.9156 15.9624 19.4531 19 19.4531C22.0376 19.4531 24.5 21.9156 24.5 24.9531Z"
      stroke="white"
    />
    <path
      d="M17 25.9531L18.8189 27.772C18.9109 27.864 19.0648 27.845 19.1318 27.7335L22 22.9531"
      stroke="white"
      stroke-linecap="round"
    />
  </svg>
);
export const ContractCompIcon = () => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.37524 0.078125C7.87782 0.078125 8.28524 0.485342 8.28524 0.987669L8.2849 2.68983H18.057L18.0572 0.998709C18.0572 0.496381 18.4646 0.0891645 18.9672 0.0891645C19.4698 0.0891645 19.8772 0.496381 19.8772 0.998709L19.877 2.68983L23.4 2.68985C24.8359 2.68985 26 3.85332 26 5.28855V23.4794C26 24.9146 24.8359 26.0781 23.4 26.0781H2.6C1.16406 26.0781 0 24.9146 0 23.4794V5.28855C0 3.85332 1.16406 2.68985 2.6 2.68985L6.4649 2.68983L6.46524 0.987669C6.46524 0.485342 6.87266 0.078125 7.37524 0.078125ZM1.82 10.1427V23.4794C1.82 23.91 2.16922 24.259 2.6 24.259H23.4C23.8308 24.259 24.18 23.91 24.18 23.4794V10.1609L1.82 10.1427ZM8.66667 19.0824V21.2483H6.5V19.0824H8.66667ZM14.0833 19.0824V21.2483H11.9167V19.0824H14.0833ZM19.5 19.0824V21.2483H17.3333V19.0824H19.5ZM8.66667 13.9124V16.0784H6.5V13.9124H8.66667ZM14.0833 13.9124V16.0784H11.9167V13.9124H14.0833ZM19.5 13.9124V16.0784H17.3333V13.9124H19.5ZM6.4649 4.50852L2.6 4.50894C2.16922 4.50894 1.82 4.85798 1.82 5.28855V8.32402L24.18 8.34222V5.28855C24.18 4.85798 23.8308 4.50894 23.4 4.50894L19.877 4.50852L19.8772 5.71619C19.8772 6.21852 19.4698 6.62574 18.9672 6.62574C18.4646 6.62574 18.0572 6.21852 18.0572 5.71619L18.057 4.50852H8.2849L8.28524 5.70515C8.28524 6.20748 7.87782 6.6147 7.37524 6.6147C6.87266 6.6147 6.46524 6.20748 6.46524 5.70515L6.4649 4.50852Z"
      fill="white"
    />
  </svg>
);
export const ActualStartIcon = () => (
  <svg
    width="22"
    height="28"
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8.03906L20.5122 8.03906"
      stroke="white"
      stroke-linecap="round"
    />
    <path
      d="M1 2.96875V26.5759C1 26.852 1.22386 27.0759 1.5 27.0759H20.5C20.7761 27.0759 21 26.852 21 26.5759V15.0045V3.46875C21 2.91647 20.5523 2.46875 20 2.46875H1.5C1.22386 2.46875 1 2.69261 1 2.96875Z"
      stroke="white"
      stroke-linecap="round"
    />
    <path
      d="M6.85156 1.07812V3.86384"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M14.6602 1.07812V3.86384"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M4.90234 15.0056V13.1484H7.82917V15.0056H4.90234Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.90234 18.7165V16.8594H7.82917V18.7165H4.90234Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.90234 22.4353V20.5781H7.82917V22.4353H4.90234Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.77734 15.0056V13.1484H12.7042V15.0056H9.77734Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.77734 18.7165V16.8594H12.7042V18.7165H9.77734Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.77734 22.4353V20.5781H12.7042V22.4353H9.77734Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6602 15.0056V13.1484H17.587V15.0056H14.6602Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6602 18.7165V16.8594H17.587V18.7165H14.6602Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6602 22.4353V20.5781H17.587V22.4353H14.6602Z"
      fill="white"
      stroke="white"
      stroke-width="0.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ActualEndIcon = () => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1 2.67812H19.5V1.37812C19.5 1.03334 19.363 0.702683 19.1192 0.458886C18.8754 0.215089 18.5448 0.078125 18.2 0.078125C17.8552 0.078125 17.5246 0.215089 17.2808 0.458886C17.037 0.702683 16.9 1.03334 16.9 1.37812V2.67812H9.1V1.37812C9.1 1.03334 8.96304 0.702683 8.71924 0.458886C8.47544 0.215089 8.14478 0.078125 7.8 0.078125C7.45522 0.078125 7.12456 0.215089 6.88076 0.458886C6.63696 0.702683 6.5 1.03334 6.5 1.37812V2.67812H3.9C2.86566 2.67812 1.87368 3.08902 1.14228 3.82041C0.410892 4.5518 0 5.54378 0 6.57812V22.1781C0 23.2125 0.410892 24.2044 1.14228 24.9358C1.87368 25.6672 2.86566 26.0781 3.9 26.0781H22.1C23.1343 26.0781 24.1263 25.6672 24.8577 24.9358C25.5891 24.2044 26 23.2125 26 22.1781V6.57812C26 5.54378 25.5891 4.5518 24.8577 3.82041C24.1263 3.08902 23.1343 2.67812 22.1 2.67812ZM23.4 22.1781C23.4 22.5229 23.263 22.8536 23.0192 23.0974C22.7754 23.3412 22.4448 23.4781 22.1 23.4781H3.9C3.55522 23.4781 3.22456 23.3412 2.98076 23.0974C2.73696 22.8536 2.6 22.5229 2.6 22.1781V13.0781H23.4V22.1781ZM23.4 10.4781H2.6V6.57812C2.6 6.23334 2.73696 5.90268 2.98076 5.65889C3.22456 5.41509 3.55522 5.27812 3.9 5.27812H6.5V6.57812C6.5 6.92291 6.63696 7.25357 6.88076 7.49736C7.12456 7.74116 7.45522 7.87812 7.8 7.87812C8.14478 7.87812 8.47544 7.74116 8.71924 7.49736C8.96304 7.25357 9.1 6.92291 9.1 6.57812V5.27812H16.9V6.57812C16.9 6.92291 17.037 7.25357 17.2808 7.49736C17.5246 7.74116 17.8552 7.87812 18.2 7.87812C18.5448 7.87812 18.8754 7.74116 19.1192 7.49736C19.363 7.25357 19.5 6.92291 19.5 6.57812V5.27812H22.1C22.4448 5.27812 22.7754 5.41509 23.0192 5.65889C23.263 5.90268 23.4 6.23334 23.4 6.57812V10.4781Z"
      fill="white"
    />
  </svg>
);
export const ActualWorkingIcon = () => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8 3.57812H6.2C3.32812 3.57812 1 5.81692 1 8.57862V21.0799C1 23.8416 3.32812 26.0804 6.2 26.0804H21.8C24.6719 26.0804 27 23.8416 27 21.0799V8.57862C27 5.81692 24.6719 3.57812 21.8 3.57812Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.8 1.07812V6.07862M19.2 1.07812V6.07862M1 11.0791H27"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M5.26172 15.3828H12.1257" stroke="white" />
    <path d="M7.13281 17.7812H13.9968" stroke="white" />
    <path d="M12.1289 20.1797H18.9929" stroke="white" />
    <path d="M15.8711 22.5781H22.7351" stroke="white" />
    <path d="M13.375 15.3828H20.239" stroke="white" />
    <path d="M15.8711 17.7812H22.7351" stroke="white" />
    <path d="M7.13281 22.5781H13.9968" stroke="white" />
  </svg>
);
export const TotalDelayIcon = () => (
  <svg
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.4375 15.6671C19.5757 16.4238 20.6021 16.7821 21.4829 16.6979C21.6372 19.971 20.4858 21.9052 18.4487 22.7122C16.4824 21.9581 15.3174 20.1075 15.4033 16.6502C16.439 16.7077 17.4546 16.471 18.4375 15.6692V15.6671ZM14.3672 0.956445C14.3672 0.472881 14.8208 0.078125 15.3857 0.078125C15.9507 0.078125 16.4048 0.470314 16.4048 0.956445V4.79877C16.4048 5.28233 15.9507 5.67709 15.3857 5.67709C14.8208 5.67709 14.3672 5.28439 14.3672 4.79877V0.956445ZM18.4482 12.3012C20.2539 12.3012 21.8936 13.0732 23.0786 14.3212C24.2656 15.5655 25 17.2877 25 19.1902C25 21.0905 24.2666 22.8148 23.0811 24.0607L23.0478 24.0936C21.8647 25.3194 20.2402 26.0781 18.4482 26.0781C16.6416 26.0781 15.0029 25.3061 13.8174 24.0607C12.6309 22.8123 11.8965 21.089 11.8965 19.1902C11.8965 17.2877 12.6309 15.5655 13.8159 14.3191L13.8496 14.2868C15.0332 13.0599 16.6587 12.3012 18.4482 12.3012ZM22.293 15.1456C21.312 14.1133 19.9512 13.4731 18.4482 13.4731C16.959 13.4731 15.6094 14.102 14.6304 15.1168L14.6035 15.1476C13.6196 16.1815 13.0107 17.6117 13.0107 19.1902C13.0107 20.7692 13.6196 22.2009 14.602 23.2337C15.5845 24.266 16.9458 24.9062 18.4482 24.9062C19.9365 24.9062 21.2861 24.2773 22.2671 23.2625L22.2935 23.2327C23.2773 22.1983 23.8857 20.7687 23.8857 19.1902C23.8857 17.6117 23.2764 16.1815 22.293 15.1456ZM2.77393 12.5153C2.71631 12.5153 2.66455 12.2483 2.66455 11.9213C2.66455 11.5938 2.71045 11.3294 2.77393 11.3294H5.5542C5.6123 11.3294 5.66406 11.5964 5.66406 11.9213C5.66406 12.2493 5.61816 12.5153 5.5542 12.5153H2.77393ZM7.20654 12.5153C7.14844 12.5153 7.09668 12.2483 7.09668 11.9213C7.09668 11.5938 7.14258 11.3294 7.20654 11.3294H9.98682C10.0444 11.3294 10.0962 11.5964 10.0962 11.9213C10.0962 12.2493 10.0503 12.5153 9.98682 12.5153H7.20654ZM11.6387 12.5153C11.5811 12.5153 11.5293 12.2483 11.5293 11.9213C11.5293 11.5938 11.5747 11.3294 11.6387 11.3294H14.4189C14.4766 11.3294 14.5283 11.5938 14.5283 11.9193C14.2501 12.1016 13.9821 12.3006 13.7256 12.5153H11.6387ZM2.78027 15.9156C2.72266 15.9156 2.6709 15.6487 2.6709 15.3217C2.6709 14.9942 2.71631 14.7272 2.78027 14.7272H5.56055C5.61816 14.7272 5.66992 14.9942 5.66992 15.3217C5.66992 15.6487 5.62451 15.9156 5.56055 15.9156H2.78027ZM7.2124 15.9156C7.15479 15.9156 7.10303 15.6487 7.10303 15.3217C7.10303 14.9942 7.14844 14.7272 7.2124 14.7272H9.99267C10.0503 14.7272 10.1021 14.9942 10.1021 15.3217C10.1021 15.6487 10.0566 15.9156 9.99267 15.9156H7.2124ZM2.78613 19.318C2.72852 19.318 2.67676 19.0511 2.67676 18.723C2.67676 18.3966 2.72266 18.1296 2.78613 18.1296H5.56641C5.62451 18.1296 5.67578 18.3966 5.67578 18.723C5.67578 19.0511 5.63037 19.318 5.56641 19.318H2.78613ZM7.21875 19.318C7.16064 19.318 7.10889 19.0511 7.10889 18.723C7.10889 18.3966 7.15478 18.1296 7.21875 18.1296H9.99902C10.0566 18.1296 10.1084 18.3966 10.1084 18.723C10.1084 19.0511 10.0625 19.318 9.99902 19.318H7.21875ZM5.21631 0.956445C5.21631 0.472881 5.66992 0.078125 6.23486 0.078125C6.7998 0.078125 7.25342 0.470314 7.25342 0.956445V4.79877C7.25342 5.28233 6.79834 5.67709 6.23486 5.67709C5.66992 5.67709 5.21631 5.28439 5.21631 4.79877V0.956445ZM1.12207 8.47837H20.5259V4.05443C20.5259 3.90351 20.4683 3.77056 20.3755 3.67302C20.2827 3.57549 20.1504 3.51492 20.0122 3.51492H18.1519C17.8398 3.51492 17.5869 3.24798 17.5869 2.92098C17.5869 2.59348 17.8398 2.32654 18.1519 2.32654H20.0122C20.4683 2.32654 20.8765 2.52007 21.1753 2.83372C21.4746 3.14891 21.6577 3.57806 21.6577 4.057V11.08C21.2871 10.9455 20.9053 10.8372 20.5132 10.7571V9.65956H20.5259H1.12207V21.1157C1.12207 21.2666 1.17969 21.3991 1.27246 21.4966C1.36523 21.5941 1.49756 21.6547 1.63525 21.6547H10.8569C10.9619 22.0664 11.0942 22.4678 11.2534 22.8539H1.646C1.19189 22.8539 0.781738 22.6614 0.48291 22.3462C0.183106 22.0346 0 21.6054 0 21.126V4.05905C0 3.58216 0.183106 3.15045 0.48291 2.83628C0.781738 2.52161 1.18994 2.32859 1.646 2.32859H3.63184C3.94336 2.32859 4.19727 2.59553 4.19727 2.92252C4.19727 3.25055 3.94336 3.51748 3.63184 3.51748H1.646C1.50146 3.51748 1.37549 3.57806 1.28271 3.67559C1.18994 3.77312 1.13184 3.91121 1.13184 4.057V8.47991H1.12207V8.47837ZM8.88281 3.51492C8.57178 3.51492 8.31787 3.24798 8.31787 2.92098C8.31787 2.59348 8.57178 2.32654 8.88281 2.32654H12.6694C12.9814 2.32654 13.2354 2.59348 13.2354 2.92098C13.2354 3.24798 12.9814 3.51492 12.6694 3.51492H8.88281ZM18.4648 16.4756C19.3413 17.0583 20.1313 17.336 20.811 17.2708C20.9287 19.7918 20.0435 21.2825 18.4741 21.9026L18.4648 16.4756Z"
      fill="white"
    />
    <rect
      x="3.26172"
      y="2.34375"
      width="15.2174"
      height="1.13043"
      fill="white"
    />
  </svg>
);
export const PlusIcon = () => (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.4688 1.38125L23.4688 37.7812M1.96875 19.5813L44.9688 19.5813"
      stroke="#C2AE5E"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconApprove = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="11"
    viewBox="0 0 15 11"
    fill="none"
  >
    <path
      d="M13.5 1.35156L5.25 9.35156L1.5 5.7152"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconReject = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="11"
    viewBox="0 0 9 11"
    fill="none"
  >
    <path
      d="M7.99861 1.35156L1.00139 9.33411M1 1.36901L8 9.35156"
      stroke="black"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
);

export const TotalSubmitted = () => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9116 0.234213C14.8153 0.146716 14.6797 0.0898438 14.5463 0.0898438C14.5178 0.0898438 14.4894 0.0898438 14.4588 0.0985934H1.21183C0.885901 0.0985934 0.577476 0.234213 0.356548 0.455141C0.135619 0.67607 0 0.973557 0 1.31042V25.7569C0 26.0938 0.135619 26.3913 0.356548 26.6122C0.577476 26.8331 0.874964 26.9687 1.21183 26.9687H20.1898C20.5267 26.9687 20.8241 26.8331 21.0451 26.6122C21.266 26.3913 21.4016 26.0938 21.4016 25.7569V7.15518C21.4104 7.10705 21.4213 7.06768 21.4213 7.01956C21.4213 6.8555 21.3447 6.71113 21.2376 6.60614L14.9772 0.271399C14.9575 0.251712 14.9488 0.242962 14.9291 0.232025L14.9116 0.234213ZM14.4807 1.18574V5.44244C14.4807 5.89523 14.6644 6.30865 14.9619 6.60614C15.2594 6.90363 15.6728 7.08737 16.1256 7.08737H20.2948V25.7591C20.2948 25.7875 20.286 25.8269 20.2554 25.8466C20.2357 25.8663 20.2073 25.886 20.1679 25.886H1.20089C1.17245 25.886 1.13308 25.8772 1.11339 25.8466C1.0937 25.8269 1.07402 25.7897 1.07402 25.7591V1.31042C1.07402 1.27105 1.08277 1.24261 1.11339 1.22292C1.13308 1.20324 1.16151 1.18355 1.20089 1.18355H14.4807V1.18574ZM15.5656 5.44244V2.05195L19.457 6.00023H16.1234C15.9703 6.00023 15.8347 5.93242 15.7297 5.83617C15.6334 5.73992 15.5656 5.59555 15.5656 5.44244ZM4.48856 15.3339C4.19108 15.3339 3.94171 15.5745 3.94171 15.8808C3.94171 16.1782 4.18233 16.4298 4.48856 16.4298H16.7665C17.064 16.4298 17.3155 16.1892 17.3155 15.8808C17.3155 15.5833 17.0749 15.3339 16.7665 15.3339H4.48856ZM4.69418 21.8283C4.39669 21.8283 4.14514 22.0689 4.14514 22.3774C4.14514 22.6749 4.38576 22.9242 4.69418 22.9242H16.8912C17.1887 22.9242 17.4402 22.6836 17.4402 22.3752C17.4402 22.0777 17.1996 21.8283 16.8912 21.8283H4.69418ZM4.48856 18.696C4.19108 18.696 3.94171 18.9366 3.94171 19.2428C3.94171 19.5403 4.18233 19.7897 4.48856 19.7897H16.8912C17.1887 19.7897 17.438 19.549 17.438 19.2428C17.438 18.9453 17.1974 18.696 16.8912 18.696H4.48856Z"
      fill="white"
    />
    <path d="M4.5 12.5898H17" stroke="white" stroke-linecap="round" />
  </svg>
);
export const PendingSamples = () => (
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8821 4.57345C14.0144 4.10499 16.2417 4.35327 18.2185 5.27977C20.1192 6.17064 21.6863 7.64071 22.6968 9.47581L19.5427 8.91965C19.2253 8.8637 18.9228 9.07556 18.8668 9.39282C18.8109 9.7101 19.0228 10.0126 19.34 10.0686L23.9358 10.8789C24.2531 10.9349 24.5556 10.723 24.6116 10.4058L25.422 5.81C25.4779 5.49274 25.266 5.19018 24.9488 5.13423C24.6314 5.07829 24.3289 5.29015 24.273 5.60741L23.6971 8.87382C22.567 6.84111 20.8245 5.2127 18.7136 4.22338C16.5042 3.18787 14.0149 2.91039 11.6317 3.43396C9.24858 3.95753 7.10479 5.25291 5.53292 7.11914C3.96105 8.98537 3.04895 11.3182 2.93811 13.7557C2.92347 14.0775 3.17251 14.3502 3.49435 14.3649C3.81617 14.3795 4.08894 14.1304 4.10357 13.8087C4.10608 13.7537 4.10903 13.6988 4.11243 13.6439C4.12032 13.6132 4.12552 13.5814 4.12778 13.5488C4.12996 13.5172 4.12928 13.4858 4.12597 13.4553C4.29286 11.4029 5.09499 9.45008 6.42525 7.87072C7.83166 6.20093 9.74978 5.04191 11.8821 4.57345ZM3.23557 16.7846C3.27542 16.9529 3.31924 17.1205 3.36703 17.2871C3.41481 17.4537 3.46645 17.619 3.52188 17.7829C3.62509 18.0881 3.96589 18.2337 4.26521 18.1146C4.56454 17.9955 4.70887 17.6567 4.60754 17.3509C4.56529 17.2234 4.52559 17.0948 4.48849 16.9654C4.45139 16.836 4.41695 16.7061 4.3852 16.5755C4.30905 16.2625 4.00711 16.0517 3.69014 16.1093C3.37316 16.167 3.16137 16.4711 3.23557 16.7846ZM24.1073 18.8259C24.2407 18.5327 24.0919 18.1933 23.7921 18.0754C23.4923 17.9574 23.1553 18.1057 23.0199 18.3981C22.9635 18.52 22.9044 18.6409 22.8429 18.7606C22.7816 18.8803 22.7176 18.9987 22.6515 19.1156C22.4928 19.3959 22.5688 19.7563 22.8394 19.9312C23.11 20.1061 23.4725 20.0292 23.6329 19.7498C23.719 19.5998 23.8017 19.4476 23.8809 19.2934C23.96 19.1392 24.0355 18.9833 24.1073 18.8259ZM5.06803 20.7651C5.17001 20.9049 5.27533 21.0425 5.38397 21.1774C5.4926 21.3125 5.60427 21.445 5.71888 21.5746C5.93232 21.8158 6.30292 21.8181 6.53267 21.5922C6.76244 21.3663 6.76417 20.9981 6.55224 20.7555C6.46386 20.6543 6.37747 20.5513 6.29312 20.4464C6.20877 20.3415 6.12665 20.235 6.04679 20.127C5.85526 19.8679 5.49523 19.7906 5.22535 19.9666C4.95549 20.1425 4.87812 20.505 5.06803 20.7651ZM21.5383 22.3761C21.775 22.1576 21.7693 21.787 21.5386 21.5621C21.308 21.3372 20.9398 21.3432 20.7016 21.5602C20.6024 21.6508 20.5012 21.7393 20.3981 21.8259C20.2951 21.9124 20.1903 21.9968 20.084 22.0789C19.8291 22.2759 19.7594 22.6375 19.9411 22.9035C20.1227 23.1696 20.4867 23.2393 20.7429 23.0439C20.8805 22.939 21.0156 22.8307 21.1484 22.7193C21.2811 22.6078 21.4111 22.4933 21.5383 22.3761ZM8.30007 23.7245C8.44822 23.8138 8.59861 23.8996 8.75111 23.9821C8.90361 24.0645 9.05785 24.1432 9.21372 24.2182C9.50401 24.358 9.84648 24.2164 9.97076 23.9191C10.095 23.622 9.95391 23.2818 9.6645 23.1402C9.5438 23.0812 9.42422 23.0197 9.30583 22.9557C9.18742 22.8917 9.07044 22.8254 8.95495 22.7568C8.678 22.5921 8.31614 22.6605 8.13557 22.9273C7.95499 23.194 8.02414 23.5581 8.30007 23.7245ZM17.7941 24.6531C18.0969 24.5434 18.2354 24.1996 18.1099 23.9028C17.9845 23.6061 17.6426 23.469 17.3391 23.5768C17.2125 23.6217 17.0849 23.6641 16.9563 23.704C16.8277 23.7438 16.6986 23.781 16.5687 23.8155C16.2573 23.8982 16.0529 24.2046 16.1173 24.5203C16.1816 24.836 16.4902 25.0413 16.8021 24.9605C16.9695 24.9171 17.1361 24.8697 17.3016 24.8184C17.4673 24.767 17.6314 24.7119 17.7941 24.6531ZM12.4265 25.1998C12.5976 25.2246 12.7696 25.2455 12.942 25.2624C13.1146 25.2793 13.2872 25.292 13.46 25.3008C13.7818 25.3171 14.0427 25.0538 14.042 24.7317C14.0414 24.4096 13.7795 24.1507 13.4578 24.1324C13.3236 24.1248 13.1896 24.1144 13.0557 24.1013C12.9217 24.0882 12.7881 24.0724 12.655 24.0539C12.3359 24.0095 12.0289 24.2126 11.9658 24.5287C11.9028 24.8446 12.1076 25.1534 12.4265 25.1998ZM13.9375 10.1485V14.2318H18.0219C18.3442 14.2318 18.6053 14.493 18.6053 14.8151C18.6053 15.1374 18.3442 15.3985 18.0219 15.3985H12.7709V10.1485C12.7709 9.82632 13.032 9.56515 13.3542 9.56515C13.6763 9.56515 13.9375 9.82632 13.9375 10.1485Z"
      fill="white"
    />
  </svg>
);
export const ApprovedSamples = () => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7446 6.77197L17.7554 7.78271L9.34375 16.1943L5.24463 12.0952L6.25537 11.0845L9.34375 14.1729L16.7446 6.77197ZM11.5 0.0898438C12.5557 0.0898438 13.5739 0.224609 14.5547 0.494141C15.5355 0.763672 16.4526 1.14925 17.3062 1.65088C18.1597 2.15251 18.9346 2.75146 19.6309 3.44775C20.3271 4.14404 20.9261 4.92269 21.4277 5.78369C21.9294 6.64469 22.3149 7.56185 22.5845 8.53516C22.854 9.50846 22.9925 10.5267 23 11.5898C23 12.6455 22.8652 13.6637 22.5957 14.6445C22.3262 15.6253 21.9406 16.5425 21.439 17.396C20.9373 18.2495 20.3384 19.0244 19.6421 19.7207C18.9458 20.417 18.1672 21.016 17.3062 21.5176C16.4452 22.0192 15.528 22.4048 14.5547 22.6743C13.5814 22.9438 12.5632 23.0824 11.5 23.0898C10.4443 23.0898 9.42611 22.9551 8.44531 22.6855C7.46452 22.416 6.54736 22.0304 5.69385 21.5288C4.84033 21.0272 4.06543 20.4282 3.36914 19.7319C2.67285 19.0356 2.07389 18.257 1.57227 17.396C1.07064 16.535 0.685059 15.6216 0.415527 14.6558C0.145996 13.6899 0.00748698 12.668 0 11.5898C0 10.5342 0.134766 9.51595 0.404297 8.53516C0.673828 7.55436 1.05941 6.63721 1.56104 5.78369C2.06266 4.93018 2.66162 4.15527 3.35791 3.45898C4.0542 2.7627 4.83285 2.16374 5.69385 1.66211C6.55485 1.16048 7.46826 0.774902 8.43408 0.505371C9.3999 0.23584 10.4219 0.0973307 11.5 0.0898438ZM11.5 21.6523C12.4209 21.6523 13.3081 21.5326 14.1616 21.293C15.0151 21.0534 15.8162 20.7165 16.5649 20.2822C17.3136 19.848 17.995 19.3202 18.6089 18.6987C19.2228 18.0773 19.7469 17.3997 20.1812 16.666C20.6154 15.9323 20.9561 15.1312 21.2031 14.2627C21.4502 13.3942 21.57 12.5033 21.5625 11.5898C21.5625 10.6689 21.4427 9.78174 21.2031 8.92822C20.9635 8.07471 20.6266 7.2736 20.1924 6.5249C19.7581 5.7762 19.2303 5.09489 18.6089 4.48096C17.9875 3.86702 17.3099 3.34294 16.5762 2.90869C15.8424 2.47445 15.0413 2.13379 14.1729 1.88672C13.3044 1.63965 12.4134 1.51986 11.5 1.52734C10.5791 1.52734 9.69189 1.64714 8.83838 1.88672C7.98486 2.1263 7.18376 2.46322 6.43506 2.89746C5.68636 3.33171 5.00505 3.85954 4.39111 4.48096C3.77718 5.10238 3.25309 5.77995 2.81885 6.51367C2.3846 7.2474 2.04395 8.0485 1.79688 8.91699C1.5498 9.78548 1.43001 10.6764 1.4375 11.5898C1.4375 12.5107 1.55729 13.3979 1.79688 14.2515C2.03646 15.105 2.37337 15.9061 2.80762 16.6548C3.24186 17.4035 3.76969 18.0848 4.39111 18.6987C5.01253 19.3127 5.6901 19.8368 6.42383 20.271C7.15755 20.7052 7.95866 21.0459 8.82715 21.293C9.69564 21.54 10.5866 21.6598 11.5 21.6523Z"
      fill="white"
    />
  </svg>
);
export const ApprovalPending = () => (
  <svg
    width="6"
    height="28"
    viewBox="0 0 6 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 24.9251C5.5 25.4011 5.35338 25.8665 5.07867 26.2623C4.80397 26.6581 4.41353 26.9666 3.95671 27.1488C3.49989 27.331 2.99723 27.3787 2.51227 27.2858C2.02732 27.1929 1.58187 26.9637 1.23223 26.627C0.882604 26.2904 0.644501 25.8615 0.548038 25.3946C0.451575 24.9277 0.501083 24.4438 0.690302 24.004C0.879521 23.5641 1.19995 23.1882 1.61108 22.9238C2.0222 22.6593 2.50555 22.5181 3 22.5181C3.66304 22.5181 4.29893 22.7717 4.76777 23.2231C5.23661 23.6745 5.5 24.2867 5.5 24.9251ZM3 18.9077C3.33152 18.9077 3.64946 18.7809 3.88389 18.5552C4.11831 18.3295 4.25 18.0234 4.25 17.7042V2.05895C4.25 1.73977 4.11831 1.43366 3.88389 1.20796C3.64946 0.982264 3.33152 0.855469 3 0.855469C2.66848 0.855469 2.35054 0.982264 2.11612 1.20796C1.8817 1.43366 1.75 1.73977 1.75 2.05895V17.7042C1.75 18.0234 1.8817 18.3295 2.11612 18.5552C2.35054 18.7809 2.66848 18.9077 3 18.9077Z"
      fill="white"
    />
  </svg>
);

export const IconPencil = ({colorcode}) => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.864962 9.91591L0.0302158 12.1419C-0.00183801 12.2276 -0.00855697 12.3206 0.0108616 12.41C0.0302802 12.4994 0.0750154 12.5813 0.139725 12.646C0.204434 12.7106 0.286382 12.7552 0.375782 12.7746C0.465183 12.7939 0.558256 12.7871 0.643888 12.7549L2.86924 11.9202C3.12395 11.8248 3.35529 11.676 3.54771 11.4838L9.99381 5.03767C9.99381 5.03767 9.76892 4.36364 9.09554 3.68962C8.42215 3.01623 7.74749 2.79135 7.74749 2.79135L1.30139 9.23744C1.10917 9.42987 0.960359 9.66121 0.864962 9.91591ZM8.6464 1.89244L9.52498 1.01386C9.68253 0.85631 9.8928 0.755937 10.1126 0.792783C10.422 0.843604 10.8953 0.99734 11.3412 1.44394C11.7878 1.89053 11.9416 2.36317 11.9924 2.67255C12.0292 2.89235 11.9288 3.10263 11.7713 3.26018L10.8921 4.13876C10.8921 4.13876 10.6678 3.46537 9.99381 2.79198C9.32042 2.11732 8.6464 1.89244 8.6464 1.89244Z"
      fill={colorcode || "#01265D"}
    />
  </svg>
);

export const MorningIcon = () => (
  <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.32125 3.39821C7.055 2.93833 7.2125 2.34814 7.67125 2.08124C8.13 1.81434 8.71875 1.97097 8.985 2.4321L10.22 4.57483C10.4862 5.0347 10.3287 5.62489 9.87 5.89179C9.41125 6.1587 8.8225 6.00206 8.55625 5.54094L7.32125 3.39821ZM15 6.57596C17.3762 6.57596 19.5262 7.54082 21.0837 9.10213C22.64 10.6634 23.6038 12.82 23.6038 15.2008C23.6038 17.5828 22.6413 19.7381 21.0837 21.2994C19.5262 22.8607 17.3762 23.8256 15 23.8256C12.6237 23.8256 10.4738 22.8607 8.91625 21.2994C7.36 19.7381 6.39625 17.5828 6.39625 15.2008C6.39625 12.8187 7.35875 10.6634 8.91625 9.10213C10.4738 7.54207 12.625 6.57596 15 6.57596ZM19.7838 10.4053C18.56 9.17857 16.8687 8.41921 15 8.41921C13.1313 8.41921 11.44 9.17857 10.2163 10.4053C8.9925 11.6321 8.235 13.3274 8.235 15.2008C8.235 17.0741 8.9925 18.7695 10.2163 19.9962C11.44 21.223 13.1313 21.9823 15 21.9823C16.8687 21.9823 18.56 21.223 19.7838 19.9962C21.0075 18.7695 21.765 17.0741 21.765 15.2008C21.765 13.3274 21.0075 11.6321 19.7838 10.4053ZM14.235 1.13017C14.235 0.596368 14.6662 0.164062 15.1987 0.164062C15.7312 0.164062 16.1625 0.596368 16.1625 1.13017V3.60496C16.1625 4.13876 15.7312 4.57107 15.1987 4.57107C14.6662 4.57107 14.235 4.13876 14.235 3.60496V1.13017ZM21.3587 2.63509C21.6225 2.17522 22.2088 2.01608 22.6688 2.28048C23.1275 2.54487 23.2862 3.13256 23.0225 3.59368L21.7875 5.73641C21.5238 6.19629 20.9375 6.35543 20.4775 6.09103C20.0188 5.82663 19.86 5.23895 20.1238 4.77782L21.3587 2.63509ZM26.7738 7.50323C27.2325 7.23633 27.8212 7.39421 28.0875 7.85408C28.3538 8.31396 28.1975 8.90415 27.7375 9.17105L25.6 10.4091C25.1413 10.676 24.5525 10.5181 24.2862 10.0582C24.02 9.59834 24.1763 9.00815 24.6362 8.74125L26.7738 7.50323ZM29.0362 14.4339C29.5687 14.4339 30 14.8662 30 15.4C30 15.9338 29.5687 16.3661 29.0362 16.3661H26.5675C26.035 16.3661 25.6038 15.9338 25.6038 15.4C25.6038 14.8662 26.035 14.4339 26.5675 14.4339H29.0362ZM27.535 21.5751C27.9937 21.8395 28.1525 22.4272 27.8888 22.8883C27.625 23.3482 27.0387 23.5073 26.5788 23.2429L24.4412 22.0049C23.9825 21.7405 23.8237 21.1528 24.0875 20.6917C24.3512 20.2318 24.9375 20.0727 25.3975 20.3371L27.535 21.5751ZM22.6787 27.0033C22.945 27.4632 22.7875 28.0534 22.3288 28.3203C21.87 28.5872 21.2812 28.4306 21.015 27.9694L19.78 25.8267C19.5138 25.3668 19.6712 24.7766 20.13 24.5097C20.5887 24.2428 21.1775 24.3995 21.4438 24.8606L22.6787 27.0033ZM15.765 29.2714C15.765 29.8052 15.3338 30.2375 14.8013 30.2375C14.2688 30.2375 13.8375 29.8052 13.8375 29.2714V26.7966C13.8375 26.2628 14.2688 25.8305 14.8013 25.8305C15.3338 25.8305 15.765 26.2628 15.765 26.7966V29.2714ZM8.64125 27.7664C8.3775 28.2263 7.79125 28.3855 7.33125 28.1211C6.8725 27.8567 6.71375 27.269 6.9775 26.8079L8.2125 24.6651C8.47625 24.2052 9.0625 24.0461 9.5225 24.3105C9.98125 24.5749 10.14 25.1626 9.87625 25.6237L8.64125 27.7664ZM3.22625 22.8983C2.7675 23.1652 2.17875 23.0073 1.9125 22.5475C1.64625 22.0876 1.8025 21.4974 2.2625 21.2305L4.4 19.9925C4.85875 19.7256 5.4475 19.8834 5.71375 20.3433C5.98 20.8032 5.82375 21.3934 5.36375 21.6603L3.22625 22.8983ZM0.96375 15.9676C0.43125 15.9676 0 15.5353 0 15.0015C0 14.4677 0.43125 14.0354 0.96375 14.0354H3.4325C3.965 14.0354 4.39625 14.4677 4.39625 15.0015C4.39625 15.5353 3.965 15.9676 3.4325 15.9676H0.96375ZM2.465 8.82646C2.00625 8.56206 1.8475 7.97438 2.11125 7.51325C2.375 7.05338 2.96125 6.89424 3.42125 7.15864L5.55875 8.39666C6.0175 8.66105 6.17625 9.24874 5.9125 9.70986C5.64875 10.1697 5.0625 10.3289 4.6025 10.0645L2.465 8.82646Z" fill="black"/>
  </svg>
);

export const NightIcon = () => (
  <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3191 28.3081C20.2316 29.8497 27.4533 24.3261 28.2643 16.6325C16.1572 24.096 6.16432 14.0572 13.5808 1.90299C5.90448 2.7117 0.387885 9.95423 1.92615 17.89C2.67247 21.7453 5.18714 25.1164 8.66245 26.9939C9.06775 27.2128 9.21922 27.7196 9.00082 28.1259C8.7824 28.5322 8.27681 28.6841 7.8715 28.4651C3.9603 26.3522 1.13194 22.5606 0.289467 18.2085C-1.51106 8.91984 5.31252 0.458472 14.5212 0.164594C15.3187 0.140903 15.8881 0.913701 15.6744 1.66654L15.5619 1.90786C7.85541 13.2623 16.9503 22.3985 28.2568 14.6452L28.4936 14.5328C29.2465 14.3121 30.0289 14.8852 29.9992 15.6874C29.7061 24.9159 21.2661 31.7538 12.001 29.9487C11.549 29.8607 11.2539 29.422 11.3417 28.969C11.4295 28.5159 11.8671 28.22 12.3191 28.3081ZM5.19281 17.2213C5.94833 21.1235 9.09351 24.2764 12.9862 25.0337C13.4382 25.1216 13.7335 25.5602 13.6458 26.0133C13.558 26.4664 13.1205 26.7624 12.6686 26.6745C8.10833 25.7872 4.44113 22.1111 3.55607 17.5396C3.46837 17.0865 3.76364 16.648 4.21564 16.5601C4.66754 16.4722 5.10503 16.7682 5.19281 17.2213Z" fill="black"/>
  </svg>
);






export const RlyIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
<path d="M11.3203 21.3203C16.8432 21.3203 21.3203 16.8431 21.3203 11.3203C21.3203 5.79747 16.8432 1.32031 11.3203 1.32031C5.79747 1.32031 1.32031 5.79747 1.32031 11.3203C1.32031 12.9732 1.72135 14.5325 2.43142 15.9061L1.32031 21.3203L6.73453 20.2092C8.10813 20.9192 9.66742 21.3203 11.3203 21.3203Z" stroke="#292929" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.33142 11.3203H6.32031V11.3314H6.33142V11.3203Z" stroke="#292929" stroke-width="2.5" stroke-linejoin="round"/>
<path d="M11.3314 11.3203H11.3203V11.3314H11.3314V11.3203Z" stroke="#292929" stroke-width="2.5" stroke-linejoin="round"/>
<path d="M16.3314 11.3203H16.3203V11.3314H16.3314V11.3203Z" stroke="#292929" stroke-width="2.5" stroke-linejoin="round"/>
</svg>
)


export const SendIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M15.5593 0.145173C15.6285 0.214505 15.6758 0.302647 15.6954 0.398651C15.7149 0.494654 15.7058 0.594287 15.6693 0.685173L9.85025 15.2322C9.79897 15.3603 9.71334 15.4718 9.60279 15.5543C9.49223 15.6369 9.36103 15.6874 9.22364 15.7002C9.08624 15.713 8.94797 15.6877 8.82405 15.627C8.70012 15.5663 8.59535 15.4726 8.52125 15.3562L5.34325 10.3612L0.348254 7.18317C0.231572 7.10916 0.137605 7.00434 0.0767238 6.8803C0.0158421 6.75626 -0.00958824 6.61781 0.0032389 6.48023C0.016066 6.34264 0.066652 6.21128 0.149415 6.10063C0.232178 5.98998 0.3439 5.90434 0.472254 5.85317L15.0193 0.0361732C15.1101 -0.000414535 15.2098 -0.00949426 15.3058 0.0100619C15.4018 0.0296181 15.4899 0.0769483 15.5593 0.146173V0.145173ZM6.34125 10.0692L9.10225 14.4072L13.8353 2.57517L6.34125 10.0692ZM13.1283 1.86817L1.29625 6.60117L5.63525 9.36117L13.1283 1.86817Z" fill="black"/>
</svg>
)



export const IconDropDown = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="none">
<path d="M13.5 1.71875L7.5 7.71875L1.5 1.71875" stroke="#131635" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)

export const ClockIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.94922 17.5469C5.60672 17.5469 2.07422 14.0144 2.07422 9.67188C2.07422 5.32938 5.60672 1.79688 9.94922 1.79688C14.2917 1.79688 17.8242 5.32938 17.8242 9.67188C17.8242 14.0144 14.2917 17.5469 9.94922 17.5469ZM9.94922 2.92188C6.22547 2.92188 3.19922 5.94812 3.19922 9.67188C3.19922 13.3956 6.22547 16.4219 9.94922 16.4219C13.673 16.4219 16.6992 13.3956 16.6992 9.67188C16.6992 5.94812 13.673 2.92188 9.94922 2.92188Z" fill="#00A3FF"/>
    <path d="M12.1992 12.4844C12.098 12.4844 11.9967 12.4619 11.9067 12.4056L9.09423 10.7181C9.01131 10.6676 8.94286 10.5966 8.89555 10.5118C8.84823 10.427 8.82366 10.3315 8.82423 10.2344V5.73438C8.82423 5.41938 9.07173 5.17188 9.38673 5.17188C9.70173 5.17188 9.94923 5.41938 9.94923 5.73438V9.91938L12.4917 11.4381C12.5965 11.5023 12.6774 11.5989 12.7223 11.7132C12.7672 11.8275 12.7736 11.9534 12.7405 12.0717C12.7074 12.19 12.6367 12.2943 12.539 12.3687C12.4413 12.4432 12.3221 12.4838 12.1992 12.4844Z" fill="#00A3FF"/>
  </svg>  
);


// Eye icon components
export const EyeOpenIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
      fill="#01265D"
    />
  </svg>
);

export const EyeClosedIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C21.07 15.49 22.26 13.86 22.99 12C21.26 7.61 16.99 4.5 11.99 4.5C10.59 4.5 9.25 4.75 8.01 5.2L10.17 7.36C10.74 7.13 11.35 7 12 7ZM2 4.27L4.28 6.55L4.74 7.01C3.08 8.3 1.78 10.02 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.8 19.08L19.73 22L21 20.73L3.27 3L2 4.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8ZM11.84 9.02L14.99 12.17L15.01 12.01C15.01 10.35 13.67 9.01 12.01 9.01L11.84 9.02Z"
      fill="#01265D"
    />
  </svg>
);